import { Product } from '../types';

export const products: Product[] = [
  // Lights
  //Category : 1

  // JCB-------------------------------------------------------------------------------------
  // ASEL-3001
  {
    id: 'ASEL-3001',
    name: 'Work Lamp Square – Latest Model',
    partNumber: 'ASEL-3001',
    category: '1',
    featured: true,
    rating: 4.9,
    reviewCount: 395,
    images: [
      'asel3001-1_nlsyvf.webp',
      'asel3001-2_ye8idd.webp',
      'asel3001-3_gmshfs.webp'
    ],
    description: 'Engineered for durability and high performance, the Work Lamp Square provides powerful LED illumination for backhoe loaders, wheeled loaders, and other heavy machinery. Its advanced optics ensure clear visibility during night operations or low-light conditions. Constructed with rugged die-cast aluminum housing and long-lasting components, this lamp is resistant to vibration, dust, and harsh weather, making it perfect for demanding work environments.',
    specifications: {
      Voltage: '12V–24V DC',
      Lumens: '3600 LM',
      'Bulb Type': 'LED',
      'Beam Pattern': 'Flood',
      Housing: 'Die-cast aluminium',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C',
      'Material Durability': 'Vibration, Dust & Weather Resistant'
    },
    tags: [
      'LED',
      'Work Lamp',
      'Square Work Light',
      '12V',
      '24V',
      'Heavy Duty',
      'Waterproof',
      'Construction Equipment',
      'Industrial Equipment'
    ],
    references: [
      // Product codes
      'asel-3001', 'ASEL-3001', 'asel3001', 'ASEL3001',
      // Product variations
      'work lamp', 'work lamp square', 'square work lamp', '4dx work lamp', '3d work lamp', '3dx work lamp',
      'led work lamp', '24v led work lamp', '12v led work lamp', 'heavy duty work lamp', 'waterproof work lamp',
      'replacement work lamp', 'spare work lamp',
      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      // Company/brand names (SEO)
      'jcb', 'cat', 'tata hitachi', 'mahindra', 'escorts', 'ace', 'asus',
      // Product + company combos
      'jcb work lamp', 'cat work lamp', 'tata hitachi work lamp', 'mahindra work lamp', 'escorts work lamp', 'ace work lamp', 'asus work lamp',
      // Keywords
      'heavy equipment', 'industrial', 'construction', 'agricultural', 'durable', 'waterproof', 'spare part', 'replacement'
    ]
  },


  // ASEL-3002
  {
    id: 'ASEL-3002',
    name: 'Head Lamp Assembly – Latest Model',
    partNumber: 'ASEL-3002',
    category: '1',
    featured: true,
    rating: 4.9,
    reviewCount: 109,
    images: [
      'asel3002-1_rmdrsb.webp',
      'asel3002-2_iad8dc.webp',
      'asel3002-3_rrsmvh.webp'
    ],
    description: 'High-performance LED headlamp assembly engineered for backhoe loaders, wheeled loaders, and other heavy machinery. Provides bright, energy-efficient illumination with a durable die-cast PVC housing. Perfect for construction, agricultural, and industrial equipment, ensuring maximum safety and visibility during night or low-light operations. Designed for easy installation and long-lasting performance.',
    specifications: {
      Lumens: '3600 LM',
      'Bulb Type': 'LED',
      'Beam Pattern': 'Flood',
      Housing: 'Die-cast PVC',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C',
      'Durability': 'Vibration & Weather Resistant'
    },
    tags: [
      'Head Lamp',
      'LED',
      'Work Light',
      'Heavy Equipment',
      'Durable',
      'Waterproof',
      'Construction Equipment',
      'Industrial Equipment',
    ],
    references: [
      // Product codes
      'asel-3002', 'ASEL-3002', 'asel3002', 'ASEL3002',
      // Product variations
      'head lamp led', 'led head lamp', 'led work light', 'heavy equipment headlamp', 'construction machinery lamp', 'industrial work light', 'durable led lamp', 'agricultural machinery lamp',
      '3d head lamp', '3dx head lamp', '4dx head lamp',
      'backhoe loader head lamp', 'wheeled loader head lamp', 'excavator head lamp',
      // Company/brand names (SEO)
      'jcb', 'cat', 'tata hitachi', 'mahindra', 'escorts', 'ace', 'asus',
      // Product + company combos
      'jcb head lamp', 'cat head lamp', 'tata hitachi head lamp', 'mahindra head lamp', 'escorts head lamp', 'ace head lamp', 'asus head lamp',
      // Keywords
      'asus industries', 'backhoe spare parts', 'construction spare lamp', 'industrial spare lamp', 'replacement head lamp', 'heavy duty headlamp', 'work lamp for backhoe',
      'led work light 12v',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery', 'spare part'
    ]
  },


  // ASEL-3003
  {
    id: 'ASEL-3003',
    name: 'Head Lamp Assembly with White Indicator – Latest Model',
    partNumber: 'ASEL-3003',
    category: '1',
    featured: false,
    rating: 4.7,
    reviewCount: 205,
    images: [
      'asel3003-1_googii.webp',
      'asel3003-2_hijsfu.webp',
      'asel3003-3_bpkrgs.webp'
    ],
    description: 'Premium head lamp assembly with integrated white indicator, designed for backhoe loaders, wheeled loaders, excavators, and other heavy machinery. Features bright halogen illumination for excellent visibility in low-light conditions, and a durable die-cast PVC housing that is waterproof and vibration-resistant. Ideal for construction, agricultural, and industrial applications, it ensures safe operations and reliable signaling in all working environments.',
    specifications: {
      'Bulb Type': 'Halogen',
      'Beam Pattern': 'Flood',
      Housing: 'Die-cast PVC',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C',
      'Indicator Color': 'White',
      'Durability': 'Vibration & Weather Resistant'
    },
    tags: [
      'Head Lamp',
      'White Indicator',
      'Work Light',
      'Heavy Equipment',
      'Durable',
      'Waterproof',
      'Construction Equipment',
      'Backhoe Loader',
      'Wheeled Loader',
      'Excavator',
      'Industrial Equipment',
      'Agricultural Equipment'
    ],
    references: [
      // Product codes
      'asel-3003', 'ASEL-3003', 'asel3003', 'ASEL3003',
      // Product variations
      'head lamp with white indicator', 'headlamp white indicator', 'bulb head lamp', 'white indicator lamp',
      'halogen work light', 'heavy equipment headlamp', 'construction machinery lamp', 'industrial work light', 'durable halogen lamp', 'agricultural machinery lamp',
      '3d head lamp', '3dx head lamp', '4dx head lamp', '3d', '3dx', '4dx',
      'backhoe loader head lamp', 'wheeled loader head lamp', 'excavator head lamp',
      // Company/brand names (SEO)
      'jcb', 'cat', 'tata hitachi', 'mahindra', 'escorts', 'ace', 'bull', 'terex', 'asus',
      // Product + company combos
      'jcb head lamp', 'cat head lamp', 'tata hitachi head lamp', 'mahindra head lamp', 'escorts head lamp', 'ace head lamp', 'bull head lamp', 'terex head lamp', 'asus head lamp',
      // Keywords
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      'spare part', 'replacement head lamp', 'heavy duty headlamp'
    ]
  },


  // ASEL-3004
  {
    id: 'ASEL-3004',
    name: 'Head Lamp Assembly with Yellow Indicator – Latest Model',
    partNumber: 'ASEL-3004',
    category: '1',
    featured: false,
    rating: 4.8,
    reviewCount: 178,
    images: [
      'asel3004-1_fjinhr.webp',
      'asel3004-2_crk4ag.webp',
      'asel3004-3_xwbkij.webp'
    ],
    description: 'Premium head lamp assembly with integrated yellow indicator, designed for backhoe loaders, wheeled loaders, excavators, and other heavy machinery. Provides bright halogen illumination for excellent visibility, clear signaling, and safer operations in low-light conditions. Constructed with durable die-cast PVC housing and a waterproof design to ensure reliable performance in construction, agricultural, and industrial environments.',
    specifications: {
      'Bulb Type': 'Halogen',
      'Beam Pattern': 'Flood',
      Housing: 'Die-cast PVC',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C',
      'Indicator Color': 'Yellow',
      'Durability': 'Vibration & Weather Resistant'
    },
    tags: [
      'Head Lamp',
      'Yellow Indicator',
      'Halogen Bulb',
      'Work Light',
      'Heavy Equipment',
      'Durable',
      'Waterproof',
      'Construction Equipment',
      'Industrial Equipment',
      'Backhoe Loader',
      'Wheeled Loader',
      'Excavator',
      'Agricultural Equipment'
    ],
    references: [
      // Product codes
      'asel-3004', 'ASEL-3004', 'asel3004', 'ASEL3004',
      // Product variations
      'head lamp with yellow indicator', 'headlamp yellow indicator', 'yellow indicator head lamp',
      'halogen head lamp', 'halogen work light', 'work lamp yellow indicator', 'replacement head lamp', 'spare head lamp',
      '3d head lamp', '3dx head lamp', '4dx head lamp',
      // Equipment types
      'backhoe loader head lamp', 'wheeled loader head lamp', 'excavator head lamp', 'construction equipment head lamp', 'agricultural equipment head lamp', 'industrial equipment head lamp', 'heavy machinery head lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      // Brands
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'bull', 'asus',
      // Popular models
      'jcb 3dx', 'jcb 4dx', 'cat 424', 'cat 432', 'cat lnt', 'l&t backhoe', 'case backhoe', 'escorts bh100', 'digimax backhoe', 'terex backhoe', 'manitou loader', 'ace backhoe', 'bull loader', 'asus 3dx',
      // Product + brand combos
      'jcb head lamp', 'cat head lamp', 'l&t head lamp', 'case head lamp', 'escorts head lamp', 'digimax head lamp', 'terex head lamp', 'manitou head lamp', 'ace head lamp', 'bull head lamp', 'asus head lamp',
      'jcb work lamp', 'cat work lamp', 'l&t work lamp', 'case work lamp', 'escorts work lamp', 'digimax work lamp', 'terex work lamp', 'manitou work lamp', 'ace work lamp', 'bull work lamp', 'asus work lamp',
      // Spares / replacement keywords
      'jcb spares', 'cat spares', 'l&t spares', 'case spares', 'escorts spares', 'digimax spares', 'terex spares', 'manitou spares', 'ace spares', 'bull spares', 'asus spares',
      'backhoe spares', 'construction spares', 'agricultural spares', 'industrial spares', 'heavy equipment spares',
      'replacement head lamp', 'spare head lamp', 'waterproof head lamp', 'durable head lamp', 'heavy duty headlamp', 'halogen replacement lamp',
      'work lamp for backhoe', 'construction work lamp', 'industrial work lamp', 'agricultural work lamp'
    ]
  },

  // ASEL-3005
  {
    id: 'ASEL-3005',
    name: 'Head Lamp Assembly – Old Model',
    partNumber: 'ASEL-3005',
    category: '1',
    featured: false,
    rating: 4.6,
    reviewCount: 165,
    images: [
      'asel3005-1_sfq8v2.webp',
      'asel3005-2_eq9qwg.webp',
      'asel3005-3_wtunix.webp'
    ],
    description: 'Reliable head lamp assembly designed for older model construction, agricultural, and industrial machinery. Equipped with a halogen bulb for bright illumination and a durable die-cast PVC housing, it ensures safe operation even in tough working conditions. Built to withstand vibration, dust, and harsh weather for long-lasting performance.',
    specifications: {
      'Bulb Type': 'Halogen',
      'Beam Pattern': 'Flood',
      Housing: 'Die-cast PVC',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C',
      'Durability': 'Vibration & Weather Resistant'
    },
    tags: [
      'Head Lamp',
      'Halogen Bulb',
      'Work Light',
      'Heavy Equipment',
      'Durable',
      'Waterproof',
      'Construction Equipment',
      'Industrial Equipment',
      'Agricultural Equipment',
      'Replacement Lamp',
      'Spare Part'
    ],
    references: [
      // Product codes
      'asel-3005', 'ASEL-3005', 'asel3005', 'ASEL3005',
      // Product variations
      'old model head lamp', 'head lamp old model', 'halogen head lamp', 'halogen work light', 'heavy equipment headlamp', 'construction machinery lamp', 'industrial work light', 'durable head lamp', 'agricultural machinery lamp', 'machine spare head lamp',
      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      // Brands
      'jcb', 'cat', 'tata hitachi', 'mahindra', 'escorts', 'ace', 'bull', 'terex', 'asus',
      // Product + brand combos
      'jcb head lamp', 'cat head lamp', 'tata hitachi head lamp', 'mahindra head lamp', 'escorts head lamp', 'ace head lamp', 'bull head lamp', 'terex head lamp', 'asus head lamp',
      // Spares / replacement keywords
      'replacement head lamp', 'spare head lamp', 'waterproof head lamp', 'durable head lamp', 'heavy duty headlamp'
    ]
  },

  // ASEL-3006
  {
    id: 'ASEL-3006',
    name: 'Tail Lamp Assembly 3-Chamber – Latest Model',
    partNumber: 'ASEL-3006',
    category: '1',
    featured: true,
    rating: 4.8,
    reviewCount: 171,
    images: [
      'asel3006-1_vxriqh.webp',
      'asel3006-2_rbogoz.jpg',
      'asel3006-3_f6ewax.webp',
      'asel3006-4_xqfhoe.webp'
    ],
    description: 'High-quality tail lamp assembly with 3-chamber halogen bulbs for backhoe loaders, wheeled loaders, excavators, and other heavy machinery. Provides bright, reliable illumination for tail, stop, and indicator functions. Constructed with durable die-cast PVC housing and a waterproof design, ensuring long-lasting performance in construction, agricultural, and industrial environments.',
    specifications: {
      'Chambers': '3',
      'Bulb Type': 'Halogen',
      Housing: 'Die-cast PVC',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C',
      'Durability': 'Vibration & Weather Resistant'
    },
    tags: [
      'Tail Lamp',
      '3-Chamber',
      'Halogen Bulb',
      'Work Light',
      'Heavy Equipment',
      'Durable',
      'Waterproof',
      'Construction Equipment',
      'Industrial Equipment',
      'Backhoe Loader',
      'Wheeled Loader',
      'Excavator',
      'Agricultural Equipment'
    ],
    references: [
      // Product codes
      'asel-3006', 'ASEL-3006', 'asel3006', 'ASEL3006',
      // Product variations
      'tail lamp 3-chamber', '3-chamber tail lamp', 'halogen tail lamp', 'replacement tail lamp', 'spare tail lamp',
      '3d tail lamp', '3dx tail lamp', '4dx tail lamp',
      // Equipment types
      'backhoe loader tail lamp', 'wheeled loader tail lamp', 'excavator tail lamp', 'construction equipment tail lamp', 'agricultural equipment tail lamp', 'industrial equipment tail lamp', 'heavy machinery tail lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      // Brands
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'bull', 'asus',
      // Popular models
      'jcb 3dx', 'jcb 4dx', 'cat 424', 'cat 432', 'cat lnt', 'l&t backhoe', 'case backhoe', 'escorts bh100', 'digimax backhoe', 'terex backhoe', 'manitou loader', 'ace backhoe', 'bull loader', 'asus 3dx',
      // Product + brand combos
      'jcb tail lamp', 'cat tail lamp', 'l&t tail lamp', 'case tail lamp', 'escorts tail lamp', 'digimax tail lamp', 'terex tail lamp', 'manitou tail lamp', 'ace tail lamp', 'bull tail lamp', 'asus tail lamp',
      'jcb replacement lamp', 'cat replacement lamp', 'l&t replacement lamp', 'case replacement lamp', 'escorts replacement lamp', 'digimax replacement lamp', 'terex replacement lamp', 'manitou replacement lamp', 'ace replacement lamp', 'bull replacement lamp', 'asus replacement lamp',
      // Spares / keyword searches
      'jcb spares', 'cat spares', 'l&t spares', 'case spares', 'escorts spares', 'digimax spares', 'terex spares', 'manitou spares', 'ace spares', 'bull spares', 'asus spares',
      'backhoe spares', 'construction spares', 'agricultural spares', 'industrial spares', 'heavy equipment spares',
      'durable tail lamp', 'waterproof tail lamp', 'heavy duty tail lamp', 'industrial work lamp', 'construction work lamp', 'agricultural work lamp'
    ]
  },

  // ASEL-3007
  {
    id: 'ASEL-3007',
    name: 'Tail Lamp LED 12V 4-Chamber – Latest Model',
    partNumber: 'ASEL-3007',
    category: '1',
    featured: true,
    rating: 4.8,
    reviewCount: 197,
    images: [
      'asel3007-3_wkcoyg.jpg',
      'asel3007-2_b2oecp.webp',
      'asel3007-1_vkpwnn.webp'
    ],
    description: 'High-quality 4-chamber LED tail lamp assembly for backhoe loaders, wheeled loaders, excavators, and other heavy machinery. Provides bright, energy-efficient illumination for tail, stop, indicator, and reverse functions. Constructed with durable die-cast PVC housing and a waterproof design, ensuring long-lasting performance in construction, agricultural, and industrial environments.',
    specifications: {
      'Bulb Type': 'LED',
      Chambers: '4',
      Housing: 'Die-cast PVC',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C',
      'Durability': 'Vibration & Weather Resistant'
    },
    tags: [
      'Tail Lamp',
      'LED',
      '4-Chamber',
      'Energy Efficient',
      'Heavy Equipment',
      'Durable',
      'Waterproof',
      'Construction Equipment',
      'Industrial Equipment',
      'Backhoe Loader',
      'Wheeled Loader',
      'Excavator',
      'Agricultural Equipment'
    ],
    references: [
      // Product codes
      'asel-3007', 'ASEL-3007', 'asel3007', 'ASEL3007',
      // Product variations
      'led tail lamp', '4-chamber tail lamp', 'tail lamp led', 'replacement tail lamp', 'spare tail lamp',
      '3d tail lamp', '3dx tail lamp', '4dx tail lamp',
      // Equipment types
      'backhoe loader tail lamp', 'wheeled loader tail lamp', 'excavator tail lamp', 'construction equipment tail lamp', 'agricultural equipment tail lamp', 'industrial equipment tail lamp', 'heavy machinery tail lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      // Brands
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'bull', 'asus',
      // Popular models
      'jcb 3dx', 'jcb 4dx', 'cat 424', 'cat 432', 'cat lnt', 'l&t backhoe', 'case backhoe', 'escorts bh100', 'digimax backhoe', 'terex backhoe', 'manitou loader', 'ace backhoe', 'bull loader', 'asus 3dx',
      // Product + brand combos
      'jcb tail lamp', 'cat tail lamp', 'l&t tail lamp', 'case tail lamp', 'escorts tail lamp', 'digimax tail lamp', 'terex tail lamp', 'manitou tail lamp', 'ace tail lamp', 'bull tail lamp', 'asus tail lamp',
      'jcb replacement lamp', 'cat replacement lamp', 'l&t replacement lamp', 'case replacement lamp', 'escorts replacement lamp', 'digimax replacement lamp', 'terex replacement lamp', 'manitou replacement lamp', 'ace replacement lamp', 'bull replacement lamp', 'asus replacement lamp',
      // Spares / keyword searches
      'jcb spares', 'cat spares', 'l&t spares', 'case spares', 'escorts spares', 'digimax spares', 'terex spares', 'manitou spares', 'ace spares', 'bull spares', 'asus spares',
      'backhoe spares', 'construction spares', 'agricultural spares', 'industrial spares', 'heavy equipment spares',
      'durable tail lamp', 'waterproof tail lamp', 'heavy duty tail lamp', 'industrial work lamp', 'construction work lamp', 'agricultural work lamp'
    ]
  }
  ,

  // ASEL-3008
  {
    id: 'ASEL-3008',
    name: 'Work Lamp Oval LED – Latest Model',
    partNumber: 'ASEL-3008',
    category: '1',
    featured: true,
    rating: 4.9,
    reviewCount: 121,
    images: [
      'asel3008-1_qhij7p.webp'
    ],
    description: 'Illuminate your worksite with the powerful Oval 9-LED Work Lamp, engineered for backhoe loaders, excavators, wheeled loaders, and other heavy machinery. Featuring a rugged die-cast aluminum housing and a fully waterproof design, this lamp delivers bright, energy-efficient lighting even in the harshest construction, agricultural, or industrial conditions. Designed for long-lasting performance, it ensures you can work safely and efficiently, day or night, in any environment.',
    specifications: {
      'Bulb Type': 'LED',
      Housing: 'Die-cast aluminium',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C',
      'Durability': 'Vibration & Weather Resistant'
    },
    tags: [
      'Work Lamp',
      'Oval Work Light',
      '9 LED',
      'Energy Efficient',
      'Heavy Equipment',
      'Durable',
      'Waterproof',
      'Construction Equipment',
      'Industrial Equipment',
      'Backhoe Loader',
      'Wheeled Loader',
      'Excavator',
      'Agricultural Equipment'
    ],
    references: [
      // Product codes
      'asel-3008', 'ASEL-3008', 'asel3008', 'ASEL3008',
      // Product variations
      'work lamp', 'oval work lamp', '9 led work lamp', 'led work lamp', 'replacement work lamp', 'spare work lamp',
      '3d work lamp', '3dx work lamp', '4dx work lamp',
      // Equipment types
      'backhoe loader work lamp', 'wheeled loader work lamp', 'excavator work lamp', 'construction equipment work lamp', 'agricultural equipment work lamp', 'industrial equipment work lamp', 'heavy machinery work lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      // Brands
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'bull', 'asus',
      // Popular models
      'jcb 3dx', 'jcb 4dx', 'cat 424', 'cat 432', 'cat lnt', 'l&t backhoe', 'case backhoe', 'escorts bh100', 'digimax backhoe', 'terex backhoe', 'manitou loader', 'ace backhoe', 'bull loader', 'asus 3dx',
      // Product + brand combos
      'jcb work lamp', 'cat work lamp', 'l&t work lamp', 'case work lamp', 'escorts work lamp', 'digimax work lamp', 'terex work lamp', 'manitou work lamp', 'ace work lamp', 'bull work lamp', 'asus work lamp',
      'jcb replacement lamp', 'cat replacement lamp', 'l&t replacement lamp', 'case replacement lamp', 'escorts replacement lamp', 'digimax replacement lamp', 'terex replacement lamp', 'manitou replacement lamp', 'ace replacement lamp', 'bull replacement lamp', 'asus replacement lamp',
      // Spares / keyword searches
      'jcb spares', 'cat spares', 'l&t spares', 'case spares', 'escorts spares', 'digimax spares', 'terex spares', 'manitou spares', 'ace spares', 'bull spares', 'asus spares',
      'backhoe spares', 'construction spares', 'agricultural spares', 'industrial spares', 'heavy equipment spares',
      'durable work lamp', 'waterproof work lamp', 'heavy duty work lamp', 'industrial work lamp', 'construction work lamp', 'agricultural work lamp'
    ]
  },

  // ASEL-3009
  {
    id: 'ASEL-3009',
    name: 'Work Lamp Oval LED',
    partNumber: 'ASEL-3009',
    category: '1',
    featured: true,
    rating: 4.7,
    reviewCount: 136,
    images: [
      'asel3009-1_ohptqw.webp'
    ],
    description: 'Boost visibility on your worksite with the Oval 6-LED Work Lamp, specially designed for backhoe loaders, excavators, wheeled loaders, and other heavy machinery. Featuring a rugged die-cast PVC housing with a waterproof design, this lamp delivers bright, energy-efficient illumination for safer and more efficient operations in construction, agricultural, and industrial environments. Perfect for night work and low-light conditions.',
    specifications: {
      'Bulb Type': 'LED',
      Chambers: '6',
      Housing: 'PVC die-cast',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C',
      'Durability': 'Vibration & Weather Resistant'
    },
    tags: [
      'Work Lamp',
      'Oval Work Light',
      '6 LED',
      'Energy Efficient',
      'Heavy Equipment',
      'Durable',
      'Waterproof',
      'Construction Equipment',
      'Industrial Equipment',
      'Backhoe Loader',
      'Wheeled Loader',
      'Excavator',
      'Agricultural Equipment'
    ],
    references: [
      // Product codes
      'asel-3009', 'ASEL-3009', 'asel3009', 'ASEL3009',
      // Product variations
      'work lamp', 'oval work lamp', '6 led work lamp', 'led work lamp', 'replacement work lamp', 'spare work lamp',
      '3d work lamp', '3dx work lamp', '4dx work lamp',
      // Equipment types
      'backhoe loader work lamp', 'wheeled loader work lamp', 'excavator work lamp', 'construction equipment work lamp', 'agricultural equipment work lamp', 'industrial equipment work lamp', 'heavy machinery work lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      // Brands
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'bull', 'asus',
      // Popular models
      'jcb 3dx', 'jcb 4dx', 'cat 424', 'cat 432', 'cat lnt', 'l&t backhoe', 'case backhoe', 'escorts bh100', 'digimax backhoe', 'terex backhoe', 'manitou loader', 'ace backhoe', 'bull loader', 'asus 3dx',
      // Product + brand combos
      'jcb work lamp', 'cat work lamp', 'l&t work lamp', 'case work lamp', 'escorts work lamp', 'digimax work lamp', 'terex work lamp', 'manitou work lamp', 'ace work lamp', 'bull work lamp', 'asus work lamp',
      'jcb replacement lamp', 'cat replacement lamp', 'l&t replacement lamp', 'case replacement lamp', 'escorts replacement lamp', 'digimax replacement lamp', 'terex replacement lamp', 'manitou replacement lamp', 'ace replacement lamp', 'bull replacement lamp', 'asus replacement lamp',
      // Spares / keyword searches
      'jcb spares', 'cat spares', 'l&t spares', 'case spares', 'escorts spares', 'digimax spares', 'terex spares', 'manitou spares', 'ace spares', 'bull spares', 'asus spares',
      'backhoe spares', 'construction spares', 'agricultural spares', 'industrial spares', 'heavy equipment spares',
      'durable work lamp', 'waterproof work lamp', 'heavy duty work lamp', 'industrial work lamp', 'construction work lamp', 'agricultural work lamp'
    ]
  },

  // ASEL-3010
  {
    id: 'ASEL-3010',
    name: 'Work Lamp Oval with Bulb – PVC Body',
    partNumber: 'ASEL-3010',
    category: '1',
    featured: true,
    rating: 4.8,
    reviewCount: 128,
    images: [
      'asel3010-1_rlj5iy.jpg',
      'asel3010-2_rw43hf.webp'
    ],
    description: 'Illuminate your worksite with the Oval Work Lamp with Bulb, built for backhoe loaders, excavators, wheeled loaders, and other heavy machinery. Its durable PVC body and waterproof design ensure long-lasting performance in construction, agricultural, and industrial environments. Delivers bright, reliable illumination for safer, more efficient operations, even in low-light or nighttime conditions.',
    specifications: {
      'Bulb Type': 'Halogen Bulb',
      Housing: 'PVC body',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C',
      'Durability': 'Vibration & Weather Resistant'
    },
    tags: [
      'Work Lamp',
      'Oval Work Light',
      'Halogen Bulb',
      'Latest Model',
      'Energy Efficient',
      'Heavy Equipment',
      'Durable',
      'Waterproof',
      'Construction Equipment',
      'Industrial Equipment',
      'Backhoe Loader',
      'Wheeled Loader',
      'Excavator',
      'Agricultural Equipment'
    ],
    references: [
      // Product codes
      'asel-3010', 'ASEL-3010', 'asel3010', 'ASEL3010',
      // Product variations
      'work lamp', 'oval work lamp', 'bulb work lamp', 'halogen work lamp', 'plastic body work lamp', 'replacement work lamp', 'spare work lamp',
      '3d work lamp', '3dx work lamp', '4dx work lamp',
      // Equipment types
      'backhoe loader work lamp', 'wheeled loader work lamp', 'excavator work lamp', 'construction equipment work lamp', 'agricultural equipment work lamp', 'industrial equipment work lamp', 'heavy machinery work lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      // Brands
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'bull', 'volvo', 'asus', 'mahindra',
      // Popular models
      'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx', 'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',
      'cat 424', 'cat 426', 'cat 428', 'cat 432', 'cat 442',
      'case 570', 'case 580', 'case 770', 'case 851',
      'l&t 491', 'l&t 580', 'l&t 770', 'komatsu wb93', 'komatsu wb97',
      'escorts digmax', 'escorts digmax ii', 'escorts bh100',
      'terex 760', 'terex 770', 'terex 860', 'terex 970',
      'manitou 740', 'manitou 860',
      'ace ax124', 'ace backhoe',
      'bull champ', 'bull smart', 'bull hd76',
      'volvo bl60', 'volvo bl61', 'volvo bl70', 'volvo bl71',
      'mahindra gx', 'mahindra sx', 'mahindra vx',
      // Product + brand combos
      'jcb work lamp', 'cat work lamp', 'l&t work lamp', 'case work lamp', 'escorts work lamp', 'digimax work lamp', 'terex work lamp', 'manitou work lamp', 'ace work lamp', 'bull work lamp', 'volvo work lamp', 'asus work lamp', 'mahindra work lamp',
      'jcb replacement lamp', 'cat replacement lamp', 'l&t replacement lamp', 'case replacement lamp', 'escorts replacement lamp', 'digimax replacement lamp', 'terex replacement lamp', 'manitou replacement lamp', 'ace replacement lamp', 'bull replacement lamp', 'volvo replacement lamp', 'asus replacement lamp', 'mahindra replacement lamp',
      // Model + work lamp combos
      'jcb 2d work lamp', 'jcb 2dx work lamp', 'jcb 3d work lamp', 'jcb 3dx work lamp', 'jcb 3c work lamp', 'jcb 3cx work lamp', 'jcb 4d work lamp', 'jcb 4dx work lamp', 'jcb 4c work lamp', 'jcb 4cx work lamp',
      'cat 424 work lamp', 'cat 426 work lamp', 'cat 428 work lamp', 'cat 432 work lamp', 'cat 442 work lamp',
      'case 570 work lamp', 'case 580 work lamp', 'case 770 work lamp', 'case 851 work lamp',
      'terex 760 work lamp', 'terex 770 work lamp', 'terex 860 work lamp', 'terex 970 work lamp',
      'volvo bl60 work lamp', 'volvo bl71 work lamp',
      // Spares / keyword searches
      'jcb spares', 'cat spares', 'l&t spares', 'case spares', 'escorts spares', 'digimax spares', 'terex spares', 'manitou spares', 'ace spares', 'bull spares', 'volvo spares', 'asus spares', 'mahindra spares',
      'backhoe spares', 'construction spares', 'agricultural spares', 'industrial spares', 'heavy equipment spares',
      // SEO keywords
      'durable work lamp', 'waterproof work lamp', 'heavy duty work lamp', 'industrial work lamp', 'construction work lamp', 'agricultural work lamp'
    ]
  },

  // ASEL-3011
  {
    id: 'ASEL-3011',
    name: 'Work Lamp Square – Heavy Duty Universal',
    partNumber: 'ASEL-3011',
    category: '1',
    rating: 4.5,
    reviewCount: 169,
    featured: true,
    images: [
      'asel3011-1_xhukot.webp',
      'asel3011-2_vla92z.webp',
      'asel3011-3_hbqryb.webp',
      'asel3011-4_dwizmo.webp'
    ],
    description: 'Power through any worksite with the Heavy Duty Square 9-LED Work Lamp. Built for heavy machinery, it features a robust die-cast aluminium housing with waterproof design for maximum durability. Delivers bright, energy-efficient 24W illumination, ensuring clear visibility and safety during night operations or low-light conditions across construction, agricultural, industrial, and mining equipment.',
    specifications: {
      Voltage: '12V-24V DC',
      Power: '24W',
      'Bulb Type': 'LED',
      Housing: 'Die-cast aluminium',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C'
    },
    tags: [
      'Work Lamp',
      'Square LED Lamp',
      'Heavy Duty',
      'Energy Efficient',
      'Durable',
      'Waterproof',
      'Construction Equipment'
    ],
    references: [
      // Product codes
      'asel-3011', 'ASEL-3011', 'asel3011', 'ASEL3011',

      // Product variations
      'square work lamp', '9 led work lamp', '24w work lamp', 'universal work lamp', 'replacement work lamp', 'spare work lamp',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'mining equipment', 'heavy machinery',

      // Brands
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'bull', 'volvo', 'asus', 'mahindra',

      // Popular models
      'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx', 'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',
      'cat 424', 'cat 426', 'cat 428', 'cat 432', 'cat 442',
      'case 570', 'case 580', 'case 770', 'case 851',
      'l&t 491', 'l&t 580', 'l&t 770',
      'escorts digmax', 'escorts bh100',
      'terex 760', 'terex 770', 'terex 860', 'terex 970',
      'manitou 740', 'manitou 860',
      'ace ax124', 'ace backhoe',
      'bull champ', 'bull smart', 'bull hd76',
      'volvo bl60', 'volvo bl71',
      'mahindra gx', 'mahindra sx', 'mahindra vx',

      // Product + brand combos
      'jcb work lamp', 'cat work lamp', 'l&t work lamp', 'case work lamp', 'escorts work lamp', 'digimax work lamp', 'terex work lamp', 'manitou work lamp', 'ace work lamp', 'bull work lamp', 'volvo work lamp', 'asus work lamp', 'mahindra work lamp',

      // SEO keywords
      'durable work lamp', 'waterproof work lamp', 'heavy duty work lamp', 'industrial work lamp', 'construction work lamp', 'agricultural work lamp'
    ]
  },

  // ASEL-3012
  {
    id: 'ASEL-3012',
    name: 'Work Lamp Square LED – PVC Body',
    partNumber: 'ASEL-3012',
    category: '1',
    featured: false,
    rating: 4.8,
    reviewCount: 147,
    images: [
      'asel3012-1_h85tt3.webp'
    ],
    description: 'Upgrade your machinery with Asus’s Square 9-LED Work Lamp in durable PVC housing. Designed for universal heavy equipment, it delivers bright, energy-efficient illumination with waterproof protection. Perfect for construction, agricultural, industrial, and mining applications, ensuring safety and optimal visibility during night or low-light operations.',
    specifications: {
      Voltage: '12V DC',
      'Bulb Type': 'LED',
      Housing: 'PVC Body',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C'
    },
    tags: [
      'Work Lamp',
      'Square LED Lamp',
      'PVC Body',
      'Heavy Duty',
      'Energy Efficient',
      'Waterproof',
      'Construction Equipment'
    ],
    references: [
      // Product codes
      'asel-3012', 'ASEL-3012', 'asel3012', 'ASEL3012',

      // Product variations
      'square work lamp', '9 led work lamp', 'led work lamp', 'universal work lamp', 'replacement work lamp', 'spare work lamp', 'pvc body work lamp',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'mining equipment', 'heavy machinery',

      // Brands
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'bull', 'volvo', 'asus', 'mahindra',

      // Popular models
      'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx', 'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',
      'cat 424', 'cat 426', 'cat 428', 'cat 432', 'cat 442',
      'case 570', 'case 580', 'case 770', 'case 851',
      'l&t 491', 'l&t 580', 'l&t 770',
      'escorts digmax', 'escorts bh100',
      'terex 760', 'terex 770', 'terex 860', 'terex 970',
      'manitou 740', 'manitou 860',
      'ace ax124', 'ace backhoe',
      'bull champ', 'bull smart', 'bull hd76',
      'volvo bl60', 'volvo bl71',
      'mahindra gx', 'mahindra sx', 'mahindra vx',

      // Product + brand combos
      'jcb work lamp', 'cat work lamp', 'l&t work lamp', 'case work lamp', 'escorts work lamp', 'digimax work lamp', 'terex work lamp', 'manitou work lamp', 'ace work lamp', 'bull work lamp', 'volvo work lamp', 'asus work lamp', 'mahindra work lamp',

      // SEO keywords
      'durable work lamp', 'waterproof work lamp', 'heavy duty work lamp', 'industrial work lamp', 'construction work lamp', 'agricultural work lamp'
    ]
  },

  // ASEL-3013
  {
    id: 'ASEL-3013',
    name: 'Work Lamp Square - PVC Body with Bulb',
    partNumber: 'ASEL-3013',
    category: '1',
    featured: false,
    rating: 4.8,
    reviewCount: 172,
    images: [
      'asel3013-1_qesnma.jpg',
      'asel3013-2_alhedx.webp',
      'asel3013-3_u1cxun.webp'
    ],
    description: 'Upgrade your heavy machinery with Asus’s durable Square Work Lamp featuring a reliable halogen bulb and robust PVC body. Designed for universal applications, this lamp delivers bright, consistent illumination in night and low-light conditions. Its waterproof, industrial-grade housing ensures long-lasting performance across construction, agricultural, and industrial equipment, keeping your operations safe and efficient.',
    specifications: {
      'Bulb Type': 'Halogen Bulb',
      Housing: 'PVC Body',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C'
    },
    tags: [
      'Work Lamp',
      'Square Work Light',
      'Halogen Bulb',
      'PVC Body',
      'Durable',
      'Waterproof'
    ],
    references: [
      'asel-3013', 'ASEL-3013', 'asel3013', 'ASEL3013',
      'work lamp', 'square work lamp', 'halogen work lamp', 'pvc body work lamp', 'replacement work lamp', 'spare work lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus',
      'jcb work lamp', 'cat work lamp', 'l&t work lamp', 'case work lamp', 'escorts work lamp', 'digimax work lamp', 'terex work lamp', 'manitou work lamp', 'ace work lamp', 'asus work lamp'
    ]
  },

  // ASEL-3014
  {
    id: 'ASEL-3014',
    name: 'Work Lamp Rectangle 12V 40 LED - Aluminium Body',
    partNumber: 'ASEL-3014',
    category: '1',
    featured: true,
    rating: 4.8,
    reviewCount: 247,
    images: [
      'asel3014-1_l1zk7t.webp'
    ],
    description: 'Illuminate your worksite with Asus’s high-performance Rectangle 40-LED Work Lamp. Crafted with a durable aluminium body and waterproof housing, it delivers bright, energy-efficient lighting for heavy machinery. Perfect for construction, agricultural, industrial, and mining operations, it ensures safety and maximum visibility in night or low-light conditions.',
    specifications: {
      Voltage: '12V DC',
      'Bulb Type': 'LED',
      'Number of LEDs': '40',
      Housing: 'Aluminium Body',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C'
    },
    tags: [
      'Work Lamp',
      'Rectangle Work Light',
      '40 LED',
      'Aluminium Body',
      'Durable',
      'Waterproof'
    ],
    references: [
      'asel-3014', 'ASEL-3014', 'asel3014', 'ASEL3014',
      'work lamp', 'rectangle work lamp', '40 led work lamp', 'led work lamp', 'aluminium body work lamp', 'replacement work lamp', 'spare work lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus'
    ]
  },

  // asel3015
  {
    id: 'ASEL-3015',
    name: 'Work Lamp Rectangle 12V 12 LED - PVC Body',
    partNumber: 'ASEL-3015',
    category: '1',
    featured: true,
    rating: 4.8,
    reviewCount: 178,
    images: [
      'v1759567019/asel3015-1_tmiy1e.webp'
    ],
    description: 'Upgrade your heavy machinery lighting with Asus’s Rectangle 12-LED Work Lamp. Featuring a durable PVC body and waterproof design, it delivers bright, energy-efficient illumination for construction, agricultural, industrial, and mining equipment. Ensure safety and maximum visibility during night or low-light operations with this reliable, long-lasting lamp.',
    specifications: {
      Voltage: '12V DC',
      'Bulb Type': 'LED',
      'Number of LEDs': '12',
      Housing: 'PVC Body',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C'
    },
    tags: [
      'Work Lamp',
      'Rectangle Work Light',
      '12 LED',
      'PVC Body',
      'Durable',
      'Waterproof'
    ],
    references: [
      'asel-3015', 'ASEL-3015', 'asel3015', 'ASEL3015',
      'work lamp', 'rectangle work lamp', '12 led work lamp', 'led work lamp',
      'pvc body work lamp', 'replacement work lamp', 'spare work lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus'
    ]
  },

  // asel3016
  {
    id: 'ASEL-3016',
    name: 'Work Lamp Rectangle - PVC Body',
    partNumber: 'ASEL-3016',
    category: '1',
    featured: false,
    rating: 4.9,
    reviewCount: 156,
    images: [
      'asel3016_dpoqao.webp'
    ],
    description: 'Enhance your machinery with Asus’s Rectangle Halogen Work Lamp. Built with a durable PVC body and waterproof housing, it delivers powerful, reliable illumination for construction, agricultural, industrial, and mining equipment. Ensure maximum visibility and safety during night and low-light operations with this heavy-duty lamp.',
    specifications: {
      'Bulb Type': 'Halogen',
      Housing: 'PVC Body',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C'
    },
    tags: [
      'Work Lamp',
      'Rectangle Work Light',
      'Halogen Bulb',
      'PVC Body',
      'Durable',
      'Waterproof'
    ],
    references: [
      'asel-3016', 'ASEL-3016', 'asel3016', 'ASEL3016',
      'work lamp', 'rectangle work lamp', 'halogen work lamp', 'pvc body work lamp', 'replacement work lamp', 'spare work lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus'
    ]
  },

  // asel3017
  {
    id: 'ASEL-3017',
    name: 'Work Lamp Round - Aluminum Base',
    partNumber: 'ASEL-3017',
    category: '1',
    featured: true,
    rating: 4.9,
    reviewCount: 261,
    images: [
      'asel3017-1_kx8qye.webp',
      'asel3017-2_dgvgim.webp',
      'asel3017-3_osuouy.webp',
      'asel3017-4_ij0lqg.webp',
      'asel3017-5_xudrnd.webp'
    ],
    description: 'Upgrade your machinery with Asus’s Round 9-LED Work Lamp. Featuring a robust aluminum base and waterproof housing, it delivers bright, energy-efficient illumination for construction, agricultural, industrial, and mining equipment. Perfect for night operations, it ensures maximum safety and visibility under all conditions.',
    specifications: {
      Voltage: '12V-24V DC',
      'Bulb Type': 'LED',
      'Number of LEDs': '9',
      Housing: 'Aluminum Base',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C'
    },
    tags: [
      'Work Lamp',
      'Round Work Light',
      '9 LED',
      'Aluminum Base',
      'Durable',
      'Waterproof'
    ],
    references: [
      'asel-3017', 'ASEL-3017', 'asel3017', 'ASEL3017',
      'work lamp', 'round work lamp', '9 led work lamp', 'led work lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus'
    ]
  },

  // asel3018
  {
    id: 'ASEL-3018',
    name: 'Cabin Lamp - JCB 3DX',
    partNumber: 'ASEL-3018',
    category: '1',
    machine: 'jcb',
    featured: false,
    rating: 4.8,
    reviewCount: 185,
    images: [
      'asel3018_kclrwg.webp'
    ],
    description: 'Illuminate your JCB 3DX cabin with Asus’s premium Cabin Lamp. Designed for optimal brightness and durability, it ensures safe and comfortable operation during night or low-light conditions. Easy to install and built to last, this lamp is the perfect replacement for worn-out cabin lighting.',
    specifications: {
      Voltage: '12V DC',
      'Bulb Type': 'Halogen',
      Housing: 'PVC',
      'IP Rating': 'IP20',
      'Operating Temperature': '-20°C to +60°C'
    },
    tags: [
      'Cabin Lamp',
      'JCB 3DX',
      '12V',
      'Halogen Bulb',
      'Durable',
      'Replacement Lamp'
    ],
    references: [
      'asel-3018', 'ASEL-3018', 'asel3018', 'ASEL3018',
      'cabin lamp', 'jcb 3dx cabin lamp', 'replacement cabin lamp',
      'backhoe loader', 'construction equipment', 'industrial equipment', 'agricultural equipment',
      'jcb', 'asus'
    ]
  },

  //asel3019
  {
    id: 'ASEL-3019',
    name: 'Cabin Lamp - JCB 3D',
    partNumber: 'ASEL-3019',
    machine: 'jcb',
    category: '1',
    featured: false,
    rating: 4.8,
    reviewCount: 162,
    images: ['asel3019_bphw2w.webp'],
    description: "Upgrade your JCB 3D cabin with this premium halogen lamp featuring a durable PVC body. Delivers bright, reliable illumination for safe operations during night and low-light conditions. Easy to install, built to last, and perfect for construction, industrial, and agricultural machinery.",
    specifications: {
      'Bulb Type': 'Halogen',
      Housing: 'PVC die-cast',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP20',
      'Operating Temperature': '-20°C to +60°C'
    },
    tags: [
      'Cabin Lamp',
      'JCB 3D',
      'Halogen Bulb',
      'PVC Body',
      'Durable',
      'Replacement Lamp',
      'Construction Equipment',
      'Backhoe Loader',
      'Industrial Equipment'
    ],
    references: [
      'asel-3019', 'ASEL-3019', 'asel3019', 'ASEL3019',
      'jcb 3d cabin lamp', 'jcb 3d cabin light', 'cabin lamp', 'cabin light', 'replacement cabin lamp', 'spare cabin lamp',
      'halogen cabin lamp', 'pvc cabin lamp', 'durable cabin lamp',
      'jcb 3d backhoe cabin lamp', 'jcb 3d construction cabin lamp', 'jcb 3d industrial cabin lamp', 'jcb 3d agricultural cabin lamp',
      'jcb',
      'jcb 3d lamp', 'jcb 3d replacement lamp', 'jcb 3d spare lamp',
      'cabin lamp for jcb 3d', 'halogen cabin lamp jcb 3d', 'durable jcb 3d cabin lamp', 'replacement jcb 3d cabin lamp', 'jcb 3d cabin lamp for construction', 'industrial jcb 3d cabin lamp', 'agricultural jcb 3d cabin lamp'
    ]
  },

  //asel3020
  {
    id: 'ASEL-3020',
    name: 'Work Lamp - 20 LED Light Duty',
    partNumber: 'ASEL-3020',
    category: '1',
    featured: true,
    rating: 4.8,
    reviewCount: 257,
    images: ['asel3020_vhntcl.webp'],
    description: "Upgrade your machinery with this 20-LED light-duty work lamp featuring a durable aluminium body. Provides bright, energy-efficient illumination with waterproof housing, ensuring safe and reliable performance for construction, agricultural, and industrial equipment during low-light operations.",
    specifications: {
      Voltage: '12V DC',
      'Bulb Type': 'LED',
      'Number of LEDs': '20',
      Housing: 'Aluminium Body',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C'
    },
    tags: [
      'Work Lamp',
      '20 LED',
      'Light Duty',
      '12V',
      'Aluminium Body',
      'Durable',
      'Waterproof',
      'Industrial',
      'Construction',
      'Agricultural'
    ],
    references: [
      'asel-3020', 'ASEL-3020', 'asel3020', 'ASEL3020',
      '20 led work lamp', 'light duty work lamp', 'led work lamp', 'aluminium body work lamp', 'replacement work lamp', 'spare work lamp', 'durable 20 led lamp', 'waterproof work lamp',
      'backhoe loader work lamp', 'wheeled loader work lamp', 'excavator work lamp', 'construction equipment work lamp', 'agricultural equipment work lamp', 'industrial equipment work lamp', 'mining equipment work lamp', 'heavy machinery work lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',
      'jcb 2d work lamp', 'jcb 2dx work lamp', 'jcb 3d work lamp', 'jcb 3dx work lamp', 'jcb 3c work lamp', 'jcb 3cx work lamp', 'jcb 4d work lamp', 'jcb 4dx work lamp', 'jcb 4c work lamp', 'jcb 4cx work lamp',
      'cat 424 work lamp', 'cat 426 work lamp', 'cat 428 work lamp', 'cat 432 work lamp', 'cat 442 work lamp',
      'case 570 work lamp', 'case 580 work lamp', 'case 770 work lamp', 'case 851 work lamp',
      'terex 760 work lamp', 'terex 770 work lamp', 'terex 860 work lamp', 'terex 970 work lamp',
      'volvo bl60 work lamp', 'volvo bl71 work lamp',
      'jcb spares', 'cat spares', 'l&t spares', 'case spares', 'escorts spares', 'digimax spares', 'terex spares', 'manitou spares', 'ace spares', 'asus spares',
      'backhoe spares', 'construction spares', 'agricultural spares', 'industrial spares', 'heavy equipment spares',
      '20 led work lamp', 'light duty 12v work lamp', 'aluminium body work lamp', 'durable work lamp', 'waterproof work lamp', 'industrial work lamp', 'construction work lamp', 'agricultural work lamp'
    ]
  },

  //asel3021
  {
    id: 'ASEL-3021',
    name: 'Work Lamp - 20 LED Light Duty (Yellow)',
    partNumber: 'ASEL-3021',
    category: '1',
    featured: false,
    rating: 4.8,
    reviewCount: 178,
    images: ['asel3020_vhntcl.webp'],
    description: "Upgrade your machinery with this 20-LED light-duty work lamp featuring a durable yellow aluminium body. Provides bright, energy-efficient illumination with waterproof housing, ensuring safe and reliable performance for construction, agricultural, and industrial equipment during low-light operations.",
    specifications: {
      Voltage: '12V DC',
      'Bulb Type': 'LED',
      'Number of LEDs': '20',
      Housing: 'Aluminium Body',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C'
    },
    tags: [
      'Work Lamp',
      '20 LED',
      'Light Duty',
      '12V',
      'Aluminium Body',
      'Durable',
      'Waterproof',
      'Industrial',
      'Construction',
      'Agricultural'
    ],
    references: [
      'asel-3021', 'ASEL-3021', 'asel3021', 'ASEL3021',
      '20 led work lamp', 'light duty work lamp', 'led work lamp', 'yellow aluminium body work lamp', 'replacement work lamp', 'spare work lamp', 'durable 20 led lamp', 'waterproof work lamp',
      'backhoe loader work lamp', 'wheeled loader work lamp', 'excavator work lamp', 'construction equipment work lamp', 'agricultural equipment work lamp', 'industrial equipment work lamp', 'mining equipment work lamp', 'heavy machinery work lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',
      'jcb 2d work lamp', 'jcb 2dx work lamp', 'jcb 3d work lamp', 'jcb 3dx work lamp', 'jcb 3c work lamp', 'jcb 3cx work lamp', 'jcb 4d work lamp', 'jcb 4dx work lamp', 'jcb 4c work lamp', 'jcb 4cx work lamp',
      'cat 424 work lamp', 'cat 426 work lamp', 'cat 428 work lamp', 'cat 432 work lamp', 'cat 442 work lamp',
      'case 570 work lamp', 'case 580 work lamp', 'case 770 work lamp', 'case 851 work lamp',
      'terex 760 work lamp', 'terex 770 work lamp', 'terex 860 work lamp', 'terex 970 work lamp',
      'volvo bl60 work lamp', 'volvo bl71 work lamp',
      'jcb spares', 'cat spares', 'l&t spares', 'case spares', 'escorts spares', 'digimax spares', 'terex spares', 'manitou spares', 'ace spares', 'asus spares',
      'backhoe spares', 'construction spares', 'agricultural spares', 'industrial spares', 'heavy equipment spares',
      '20 led work lamp', 'light duty 12v work lamp', 'yellow aluminium body work lamp', 'durable work lamp', 'waterproof work lamp', 'industrial work lamp', 'construction work lamp', 'agricultural work lamp'
    ]
  },

  //asel3022
  {
    id: 'ASEL-3022',
    name: 'Work Lamp (L27) - 21 LED Light Duty',
    partNumber: 'ASEL-3022',
    category: '1',
    featured: true,
    rating: 4.7,
    reviewCount: 126,
    images: ['asel3022-1_hjq0sb.webp', 'asel3022-2_vk9dqe.webp'],
    description: "Upgrade your machinery with this 21-LED light-duty work lamp (L27) featuring a durable PVC body. Delivers 48W power and 4800 lumens for 12V/24V applications, providing bright, energy-efficient illumination with waterproof housing for safe and reliable performance in construction, agricultural, and industrial equipment during low-light operations.",
    specifications: {
      Voltage: '12V-24V DC',
      'Bulb Type': 'LED',
      'Number of LEDs': '21',
      Power: '48W',
      Lumen: '4800 lm',
      Housing: 'PVC Body',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C'
    },
    tags: [
      'Work Lamp',
      '21 LED',
      'Light Duty',
      'PVC Body',
      'L27'
    ],
    references: [
      'asel-3022', 'ASEL-3022', 'asel3022', 'ASEL3022',
      '21 led work lamp', 'light duty work lamp', 'led work lamp', 'pvc body work lamp', 'replacement work lamp', 'spare work lamp', 'durable 21 led lamp', 'waterproof work lamp', 'l27 work lamp', '48w work lamp', '4800lm work lamp',
      'backhoe loader work lamp', 'wheeled loader work lamp', 'excavator work lamp', 'construction equipment work lamp', 'agricultural equipment work lamp', 'industrial equipment work lamp', 'mining equipment work lamp', 'heavy machinery work lamp',
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment', 'agricultural equipment', 'industrial equipment', 'heavy machinery',
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',
      'jcb 2d work lamp', 'jcb 2dx work lamp', 'jcb 3d work lamp', 'jcb 3dx work lamp', 'jcb 3c work lamp', 'jcb 3cx work lamp', 'jcb 4d work lamp', 'jcb 4dx work lamp', 'jcb 4c work lamp', 'jcb 4cx work lamp',
      'cat 424 work lamp', 'cat 426 work lamp', 'cat 428 work lamp', 'cat 432 work lamp', 'cat 442 work lamp',
      'case 570 work lamp', 'case 580 work lamp', 'case 770 work lamp', 'case 851 work lamp',
      'terex 760 work lamp', 'terex 770 work lamp', 'terex 860 work lamp', 'terex 970 work lamp',
      'volvo bl60 work lamp', 'volvo bl71 work lamp',
      'jcb spares', 'cat spares', 'l&t spares', 'case spares', 'escorts spares', 'digimax spares', 'terex spares', 'manitou spares', 'ace spares', 'asus spares',
      'backhoe spares', 'construction spares', 'agricultural spares', 'industrial spares', 'heavy equipment spares',
      '21 led work lamp', 'light duty 12v 24v work lamp', 'pvc body work lamp', 'durable work lamp', 'waterproof work lamp', 'industrial work lamp', 'construction work lamp', 'agricultural work lamp', 'l27 led work lamp', '48w led work lamp', '4800lm led work lamp'
    ]
  },

  //asel3023
  {
    id: 'ASEL-3023',
    name: 'LED Tail Lamp - Old Model (24V, LH/RH)',
    partNumber: 'ASEL-3023',
    category: '1',
    rating: 4.7,
    reviewCount: 189,
    featured: false,
    images: ['asel3023_q0p7i2.webp'],
    description: 'High-quality LED tail lamp (old model) for 24V systems, compatible with both LH and RH configurations. Durable and reliable for construction, agricultural, and industrial equipment. Ensures visibility and safety with long-lasting performance.',
    specifications: {
      Voltage: '24V DC',
      'Bulb Type': 'LED',
      'Lamp Position': 'Tail Lamp',
      Configuration: 'LH / RH',
      Housing: 'Plastic / PVC',
      'IP Rating': 'IP65',
      'Operating Temperature': '-20°C to +60°C'
    },
    tags: [
      'LED Tail Lamp',
      'Old Model',
      '24V',
      'LH',
      'RH'
    ],
    references: [
      'asel-3023', 'ASEL-3023', 'asel3023', 'ASEL3023',
      'led tail lamp', 'tail lamp', 'old model tail lamp', '24v tail lamp', 'lh tail lamp', 'rh tail lamp',
      'replacement tail lamp', 'spare tail lamp',
      'backhoe loader tail lamp', 'wheeled loader tail lamp', 'excavator tail lamp',
      'construction equipment tail lamp', 'agricultural equipment tail lamp',
      'industrial equipment tail lamp', 'heavy machinery tail lamp',
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',
      'jcb 2d tail lamp', 'jcb 2dx tail lamp', 'jcb 3d tail lamp', 'jcb 3dx tail lamp',
      'jcb 3c tail lamp', 'jcb 3cx tail lamp', 'jcb 4d tail lamp', 'jcb 4dx tail lamp',
      'jcb 4c tail lamp', 'jcb 4cx tail lamp',
      'jcb spares', 'cat spares', 'l&t spares', 'case spares', 'escorts spares',
      'digimax spares', 'terex spares', 'manitou spares', 'ace spares', 'asus spares',
      'backhoe spares', 'construction spares', 'agricultural spares', 'industrial spares', 'heavy equipment spares',
      '24v led tail lamp', 'led tail lamp old model', 'lh rh tail lamp', 'durable tail lamp',
      'construction tail lamp', 'agricultural tail lamp', 'industrial tail lamp'
    ]
  },

  //asel3024
  {
    id: 'ASEL-3024',
    name: 'OWL LED Universal 4-in-1',
    partNumber: 'ASEL-3024',
    category: '1',
    featured: true,
    rating: 4.8,
    reviewCount: 269,
    images: ['asel3024_nik8ck.webp'],
    description: 'High-quality OWL LED Universal 4-in-1 light, designed for versatile applications across construction, agricultural, and industrial equipment. Combines multiple functions in a single unit for enhanced visibility and safety. Durable and waterproof housing ensures long-lasting performance in harsh working conditions.',
    specifications: {
      'Bulb Type': 'LED',
      Voltage: '12V-24V DC',
      Housing: 'PVC die-cast',
      'Beam Pattern': 'Combination',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C'
    },
    tags: [
      'OWL LED',
      'Universal Light',
      '4-in-1',
      '12V',
      '24V',
      'Durable',
      'Waterproof'
    ],
    references: [
      'asel-3024', 'ASEL-3024', 'asel3024', 'ASEL3024',
      'owl led', 'universal led light', '4-in-1 led light', 'led work lamp',
      'replacement led light', 'spare led light',
      'backhoe loader work lamp', 'wheeled loader work lamp', 'excavator work lamp',
      'construction equipment work lamp', 'agricultural equipment work lamp',
      'industrial equipment work lamp', 'heavy machinery work lamp',
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull'
    ]
  },

  //asel3025
  {
    id: 'ASEL-3025',
    name: 'Work Lamp - 20 LED Light Duty (24V)',
    partNumber: 'ASEL-3025',
    category: '1',
    featured: true,
    rating: 4.8,
    reviewCount: 95,
    images: ['asel3020_vhntcl.webp'],
    description: 'Boost visibility and safety on your worksite with the 20-LED Light Duty Work Lamp, designed for 24V systems. Its rugged aluminium body and waterproof construction ensure reliable performance in the toughest environments, from dusty construction sites to muddy agricultural fields. With bright, energy-efficient LED illumination, this lamp lights up your workspace, reducing downtime and enhancing productivity. Perfectly suited for backhoe loaders, excavators, wheeled loaders, and other heavy machinery, it combines durability, efficiency, and versatility in a compact, lightweight design. Keep your operations running smoothly, day or night, with this high-performance work lamp.',
    specifications: {
      Voltage: '24V DC',
      'Bulb Type': 'LED',
      'Number of LEDs': '20',
      Housing: 'Aluminium Body',
      'Beam Pattern': 'Flood',
      'IP Rating': 'IP67',
      'Operating Temperature': '-40°C to +85°C'
    },
    tags: [
      'Work Lamp',
      '20 LED',
      'Light Duty',
      '24V',
      'Aluminium Body',
      'Durable',
      'Waterproof',
      'Industrial',
      'Construction',
      'Agricultural'
    ],
    references: [
      'asel-3025', 'ASEL-3025', 'asel3025', 'ASEL3025',
      'work lamp', '20 led work lamp', '24v led work lamp', 'light duty work lamp',
      'aluminum body work lamp', 'replacement work lamp', 'spare work lamp',
      'durable 20 led lamp', 'waterproof work lamp',
      'backhoe loader work lamp', 'wheeled loader work lamp', 'excavator work lamp',
      'construction equipment work lamp', 'agricultural equipment work lamp',
      'industrial equipment work lamp', 'heavy machinery work lamp',
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',
      '20 led work lamp', '24v light duty work lamp', 'aluminum body work lamp',
      'durable work lamp', 'waterproof work lamp', 'industrial work lamp',
      'construction work lamp', 'agricultural work lamp'
    ]
  },

  //asel3026
  {
    "id": "ASEL-3026",
    "name": "Bullet Lamp - 12 LED 2-in-1 (12V)",
    "partNumber": "ASEL-3026",
    "category": "1",
    "featured": true,
    "rating": 4.8,
    "reviewCount": 102,
    "images": ["asel3026_dq1w3e.webp"],
    "description": "Illuminate your workspace with the Bullet Lamp 12 LED 2-in-1, designed for 12V systems and versatile heavy-duty applications. This dual-function lamp provides both flood and spot beam patterns, delivering powerful, energy-efficient illumination for construction sites, agricultural fields, industrial environments, and mining operations. Its rugged PVC housing and waterproof IP67 design ensure long-lasting performance even in harsh conditions. Perfect for backhoe loaders, excavators, wheeled loaders, and other machinery, this lamp enhances safety and productivity by offering reliable, bright light where you need it most.",
    "specifications": {
      "Voltage": "12V DC",
      "Bulb Type": "LED",
      "Number of LEDs": "12",
      "Function": "2-in-1",
      "Housing": "PVC Body",
      "Beam Pattern": "Flood/Spot Combination",
      "IP Rating": "IP67",
      "Operating Temperature": "-40°C to +85°C"
    },
    "tags": ["Bullet Lamp", "12 LED", "2-in-1", "12V", "Durable", "Waterproof", "Industrial", "Construction"],
    "references": ["asel-3026", "ASEL-3026", "asel3026", "ASEL3026", "bullet lamp", "12 led bullet lamp", "2-in-1 bullet lamp", "led work lamp", "replacement bullet lamp", "spare bullet lamp", "durable 12 led lamp", "waterproof bullet lamp", "backhoe loader work lamp", "wheeled loader work lamp", "excavator work lamp", "construction equipment lamp", "agricultural equipment lamp", "industrial equipment lamp", "mining equipment lamp", "heavy machinery lamp", "backhoe loader", "wheeled loader", "excavator", "construction equipment", "agricultural equipment", "industrial equipment", "heavy machinery"]
  },

  //asel3027
  {
    "id": "ASEL-3027",
    "name": "Work Lamp (G17) with Aluminium Base - 12V/24V",
    "partNumber": "ASEL-3027",
    "category": "1",
    "featured": true,
    "rating": 4.7,
    "reviewCount": 87,
    "images": ["asel3027_zerkym.webp"],
    "description": "Experience reliable illumination with the G17 Work Lamp featuring a robust aluminium base for superior heat dissipation and durability. Designed for 12V/24V systems, this versatile LED lamp is ideal for heavy-duty machinery, including backhoe loaders, excavators, wheeled loaders, and other construction, agricultural, industrial, and mining equipment. Engineered to withstand shock, vibration, and water exposure, it ensures consistent performance in harsh working conditions while enhancing safety and productivity with bright, focused light.",
    "specifications": {
      "Voltage": "12V / 24V DC",
      "Bulb Type": "LED",
      "Model": "G17",
      "Housing": "Aluminium Base",
      "IP Rating": "IP67",
      "Operating Temperature": "-40°C to +85°C",
      "Durability": "Shockproof, Waterproof, Vibration Resistant"
    },
    "tags": ["Work Lamp", "G17", "LED", "12V", "24V", "Aluminium Base", "Heavy Duty", "Waterproof", "Industrial", "Construction", "Agricultural", "Mining", "Durable"],
    "references": ["asel-3027", "ASEL-3027", "asel3027", "ASEL3027", "work lamp g17", "led work lamp g17", "12v work lamp", "24v work lamp", "aluminium base work lamp", "durable led work lamp", "backhoe loader work lamp", "wheeled loader work lamp", "excavator work lamp", "construction equipment work lamp", "agricultural equipment work lamp", "industrial equipment lamp", "mining work lamp", "heavy machinery work lamp"]
  },

  //asel3028
  {
    "id": "ASEL-3028",
    "name": "Work Lamp 39 LED with Aluminium Base - 24V",
    "partNumber": "ASEL-3028",
    "category": "1",
    "featured": true,
    "rating": 4.9,
    "reviewCount": 95,
    "images": ["asel3028_ksntdu.webp"],
    "description": "Illuminate your worksite with the high-performance 39-LED Work Lamp featuring a robust aluminium base for superior durability and efficient heat dissipation. Designed for 24V systems, this versatile lamp is ideal for heavy-duty machinery including backhoe loaders, excavators, wheeled loaders, and other construction, agricultural, industrial, and mining equipment. Engineered to endure shock, vibration, and water exposure, it delivers powerful, focused illumination with long-lasting performance, ensuring maximum safety and productivity even in extreme conditions.",
    "specifications": {
      "Voltage": "24V DC",
      "Bulb Type": "LED",
      "LEDs": "39 High-Intensity LEDs",
      "Housing": "Aluminium Base",
      "IP Rating": "IP67",
      "Operating Temperature": "-40°C to +85°C",
      "Durability": "Shockproof, Waterproof, Vibration Resistant",
      "Lumen Output": "High Brightness"
    },
    "tags": ["Work Lamp", "39 LED", "24V", "Aluminium Base", "Heavy Duty", "LED", "Waterproof", "Durable", "Industrial", "Construction", "Agricultural", "Mining", "High Brightness"],
    "references": ["asel-3028", "ASEL-3028", "asel3028", "ASEL3028", "39 led work lamp", "24v work lamp", "aluminium base work lamp", "led work lamp 39 led", "heavy duty 39 led lamp", "backhoe loader work lamp", "wheeled loader work lamp", "excavator work lamp", "construction equipment work lamp", "agricultural equipment work lamp", "industrial equipment work lamp", "mining work lamp", "heavy machinery work lamp"]
  },

  //asel3029
  {
    "id": "ASEL-3029",
    "name": "Work Lamp Round 9 LED Yellow with Aluminium Base - 12V/24V",
    "partNumber": "ASEL-3029",
    "category": "1",
    "featured": true,
    "rating": 4.6,
    "reviewCount": 64,
    "images": ["asel3029_nfjalv.webp"],
    "description": "Enhance visibility in challenging work environments with this premium round 9-LED work lamp featuring a yellow lens for improved performance in foggy, dusty, and low-light conditions. Built with a durable aluminium base for superior strength and efficient heat dissipation, it is compatible with both 12V and 24V systems. Ideal for construction, agricultural, industrial, and heavy machinery applications, this lamp delivers reliable, bright illumination, ensuring safety and productivity even in the harshest conditions.",
    "specifications": {
      "Voltage": "12V-24V DC",
      "Bulb Type": "LED",
      "Number of LEDs": "9",
      "Color": "Yellow Lens",
      "Housing": "Aluminium Base",
      "Beam Pattern": "Flood/Spot Combination",
      "IP Rating": "IP67",
      "Operating Temperature": "-40°C to +85°C",
      "Durability": "Shockproof, Waterproof, Vibration Resistant"
    },
    "tags": ["Work Lamp", "9 LED", "Round", "Yellow Lens", "12V", "24V", "Aluminium Base", "Durable", "Waterproof", "Construction", "Agricultural", "Industrial", "Heavy Machinery"],
    "references": ["asel-3029", "ASEL-3029", "asel3029", "ASEL3029", "round 9 led work lamp", "yellow work lamp", "9 led aluminium base lamp", "9 led fog work lamp", "9 led universal work lamp", "backhoe loader work lamp", "wheeled loader work lamp", "excavator work lamp", "construction equipment work lamp", "agricultural equipment work lamp", "industrial equipment work lamp", "heavy machinery work lamp"]
  },

  //asel3030
  {
    "id": "ASEL-3030",
    "name": "Work Lamp Rectangle 40 LED with Aluminium Base - 24V",
    "partNumber": "ASEL-3030",
    "category": "1",
    "featured": false,
    "rating": 4.5,
    "reviewCount": 58,
    "images": ["asel3014-1_l1zk7t.webp"],
    "description": "Illuminate your worksite with the premium rectangular 40-LED work lamp, engineered for maximum performance and durability. Featuring a robust aluminium base for efficient heat dissipation, this lamp operates on 24V systems and delivers powerful, wide-area illumination. Perfectly suited for heavy-duty construction, agricultural, industrial, and mining machinery, it ensures enhanced visibility and safety even in low-light or harsh conditions. Shockproof, waterproof, and vibration-resistant, it is built to withstand the toughest environments while maintaining long-lasting reliability and superior brightness.",
    "specifications": {
      "Voltage": "24V DC",
      "Bulb Type": "LED",
      "Number of LEDs": "40",
      "Shape": "Rectangle",
      "Housing": "Aluminium Base",
      "Beam Pattern": "Flood/Spot Combination",
      "Luminous Flux": "4800 lm",
      "IP Rating": "IP67",
      "Operating Temperature": "-40°C to +85°C",
      "Durability": "Shockproof, Waterproof, Vibration Resistant"
    },
    "tags": ["Work Lamp", "40 LED", "Rectangular", "24V", "Aluminium Base", "Durable", "Waterproof", "Industrial", "Construction", "Agricultural", "Heavy Machinery"],
    "references": ["asel-3030", "ASEL-3030", "asel3030", "ASEL3030", "rectangular work lamp", "40 led work lamp", "24v work lamp", "aluminium base work lamp", "durable 40 led lamp", "heavy duty led lamp"]
  },

  //asel3031
  {
    "id": "ASEL-3031",
    "name": "Tail Lamp New Model LED - 12V",
    "partNumber": "ASEL-3031",
    "category": "1",
    "featured": true,
    "rating": 4.7,
    "reviewCount": 78,
    "images": ["asel3031_jdheak.webp"],
    "description": "Upgrade your machinery with the high-performance New Model LED Tail Lamp, designed specifically for 12V systems. Engineered with durable PVC housing and advanced LED technology, this tail lamp delivers bright and consistent illumination, enhancing rear visibility and safety for construction, agricultural, and industrial equipment. Shockproof, waterproof, and vibration-resistant, it is built to withstand the toughest environments while providing long-lasting reliability. A perfect replacement for standard tail lamps, it ensures your heavy machinery remains safe, visible, and fully compliant during low-light and challenging conditions.",
    "specifications": {
      "Voltage": "12V DC",
      "Bulb Type": "LED",
      "Model": "New Model",
      "Housing": "Durable PVC Body",
      "IP Rating": "IP65",
      "Operating Temperature": "-20°C to +70°C",
      "Durability": "Shockproof, Waterproof, Vibration Resistant"
    },
    "tags": ["Tail Lamp", "New Model", "LED Tail Lamp", "12V", "Durable", "Waterproof", "Industrial", "Construction", "Agricultural", "Heavy Machinery"],
    "references": ["asel-3031", "ASEL-3031", "asel3031", "ASEL3031", "tail lamp", "led tail lamp", "new model tail lamp", "12v led tail lamp", "rear lamp", "rear light", "stop lamp", "brake light", "indicator lamp", "turn signal tail lamp"]
  },

  //asel3032
  {
    "id": "ASEL-3032",
    "name": "Work Lamp 20 LED Light Duty - 24V Yellow",
    "partNumber": "ASEL-3032",
    "category": "1",
    "featured": false,
    "rating": 4.6,
    "reviewCount": 55,
    "images": ["asel3020_vhntcl.webp"],
    "description": "Illuminate your workspace with the high-performance 20-LED Work Lamp in yellow, designed for 24V systems. Crafted with a durable aluminium body, this light-duty lamp delivers bright, focused yellow illumination for enhanced visibility in foggy, dusty, and low-light conditions. Perfectly suited for construction, agricultural, industrial, and heavy machinery applications, it combines energy-efficient LED performance with waterproof and shockproof features, ensuring long-lasting reliability and safety during every operation. Compact yet powerful, this lamp is your go-to solution for dependable lighting in challenging environments.",
    "specifications": {
      "Voltage": "24V DC",
      "Bulb Type": "LED",
      "Number of LEDs": "20",
      "Housing": "Aluminium Body",
      "Color": "Yellow",
      "Beam Pattern": "Flood",
      "IP Rating": "IP67",
      "Operating Temperature": "-40°C to +85°C",
      "Durability": "Shockproof, Waterproof, Vibration Resistant"
    },
    "tags": ["Work Lamp", "20 LED", "Light Duty", "24V", "Yellow Lamp", "Aluminium Body", "Durable", "Waterproof", "Industrial", "Construction", "Agricultural", "Heavy Machinery"],
    "references": ["asel-3032", "ASEL-3032", "asel3032", "ASEL3032", "work lamp", "20 led work lamp", "24v led work lamp", "light duty work lamp", "yellow led work lamp", "aluminium body work lamp"]
  },





  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //Electricals

  // ASES-3601
  {
    id: 'ASES-3601',
    name: 'Ignition Switch 3DX New Model 2017 (7 Pin)',
    partNumber: 'ASES-3601',
    machine: 'jcb',
    category: '2',
    featured: true,
    rating: 4.8,
    reviewCount: 148,
    images: [
      'ases3601-1_mcpdae.webp',
      'ases3601-2_odikab.webp'
    ],
    description: `
    Ensure your JCB 3DX (2017 onwards) backhoe loader starts reliably every time with this high-quality Asus ignition switch. 
    Designed specifically for the new model 2017 JCB 3DX, this 7-pin ignition switch provides secure electrical connectivity 
    and long-lasting durability. Constructed with a corrosion-resistant housing and metal key barrel, it meets OEM standards 
    for a perfect fit and seamless replacement. Ideal for construction equipment professionals seeking reliable, long-life 
    electrical components. 
  `,
    specifications: {
      CompatibleModels: 'JCB 3DX (2017 New Model)',
      Type: 'Ignition Switch',
      Connector: '7 Pin',
      Housing: 'Durable PVC with Metal Key Barrel',
      Features: 'Corrosion Resistant, Long Service Life, OEM Fitment'
    },
    tags: [
      'Ignition Switch',
      '3DX Ignition Switch',
      '7 Pin Switch',
      'JCB 3DX',
      '2017 Model',
      'Electrical Part',
      'OEM Replacement',
      'Durable',
      'Reliable',
      'Heavy Equipment'
    ],
    references: [
      'ases-3601', 'ASES-3601', 'ases3601', 'ASES3601',
      'ignition switch', 'jcb ignition switch', '3dx ignition switch',
      '7 pin ignition switch', 'jcb 3dx 7 pin switch', 'new model ignition switch',
      '2017 jcb ignition switch', 'replacement ignition switch',
      'jcb 3dx', 'jcb 3d', 'jcb 4dx',
      'backhoe loader ignition switch', 'excavator ignition switch',
      'construction equipment ignition switch', 'heavy machinery ignition switch',
      'jcb', 'jcb 3dx 7 pin ignition switch', 'jcb 3dx ignition switch replacement',
      'jcb spares', 'jcb electrical spares', 'jcb 3dx spares',
      'replacement ignition switch', 'ignition switch spares',
      '7 pin ignition switch jcb', 'jcb 3dx new model ignition switch',
      'durable ignition switch', 'replacement ignition switch',
      'heavy machinery ignition switch', 'jcb backhoe ignition switch'
    ],
  },


  //ases3602
  {
    id: 'ASES-3602',
    name: 'Ignition Switch 3DX (9 Pin)',
    partNumber: 'ASES-3602',
    machine: 'jcb',
    category: '2',
    images: [
      'ases3601-1_mcpdae.webp',
      'ases3601-2_odikab.webp'
    ],
    description: 'High-quality ignition switch designed exclusively for JCB 3DX models with 9-pin configuration. Provides reliable electrical connectivity and enhanced durability. Built to OEM specifications for direct replacement, ensuring long-lasting performance for JCB 3DX machines.',
    specifications: {
      CompatibleModels: 'JCB 3DX',
      Type: 'Ignition Switch',
      Connector: '9 Pin',
      Housing: 'Durable PVC with Metal Key Barrel',
      Features: 'Corrosion Resistant, Long Service Life, OEM Fitment'
    },
    featured: true,
    tags: [
      'Ignition Switch',
      '3DX Ignition Switch',
      '9 Pin Switch',
      'JCB 3DX',
      'Electrical Part',
      'OEM Replacement',
      'Durable',
      'Reliable',
      'Heavy Equipment'
    ],
    references: [
      // Product codes / variations
      'ases-3602', 'ASES-3602', 'ases3602', 'ASES3602',
      'ignition switch', 'jcb ignition switch', '3dx ignition switch',
      '9 pin ignition switch', 'replacement ignition switch', '3dx 9 pin ignition switch',

      // Equipment references
      'jcb 3dx', 'backhoe loader ignition switch', 'construction equipment ignition switch',
      'heavy machinery ignition switch',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3dx 9 pin ignition switch', 'jcb 3dx ignition switch replacement',

      // Generic spares / keyword searches
      'jcb spares', 'jcb electrical spares', 'jcb 3dx spares',
      'replacement ignition switch', 'ignition switch spares',

      // SEO / keywords
      '9 pin ignition switch jcb', '3dx ignition switch replacement',
      'durable ignition switch', 'corrosion resistant ignition switch',
      'jcb backhoe ignition switch'
    ]
  },

  //ases3603
  {
    id: 'ASES-3603',
    name: 'Ignition Switch 3D',
    partNumber: 'ASES-3603',
    machine: 'jcb',
    category: '2', // Electrical parts category
    price: 900, // adjust as needed
    images: [
      'v1759565808/ases3601-1_mcpdae.webp',
      'v1759565808/ases3601-2_odikab.webp'
    ],
    description: 'High-quality ignition switch designed exclusively for JCB 3D models. Provides reliable electrical connectivity and enhanced durability. Built to OEM specifications for direct replacement, ensuring long-lasting performance for JCB 3D machines.',
    specifications: {
      CompatibleModels: 'JCB 3D',
      Type: 'Ignition Switch',
      Connector: '7 Pin',
      Housing: 'Durable PVC with Metal Key Barrel',
      Features: 'Corrosion Resistant, Long Service Life, OEM Fitment'
    },
    featured: true,
    tags: [
      'Ignition Switch',
      '3D Ignition Switch',
      'JCB 3D',
      'Electrical Part',
      'OEM Replacement',
      'Durable',
      'Reliable',
      'Heavy Equipment'
    ],
    references: [
      // Product codes / variations
      'ases-3603', 'ASES-3603', 'ases3603', 'ASES3603',
      'ignition switch', 'jcb ignition switch', '3d ignition switch',
      'replacement ignition switch', 'jcb 3d 7 pin switch',

      // Equipment references
      'jcb 3d', 'backhoe loader ignition switch', 'excavator ignition switch',
      'construction equipment ignition switch', 'heavy machinery ignition switch',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3d ignition switch', 'jcb 3d replacement ignition switch',

      // Spares / keywords
      'jcb spares', 'jcb electrical spares', 'jcb 3d spares',
      'replacement ignition switch', 'ignition switch spares',

      // SEO / keywords
      'ignition switch jcb 3d', '3d ignition switch replacement',
      'durable ignition switch', 'heavy machinery ignition switch'
    ]
  },

  //ases3604
  {
    id: 'ASES-3604',
    name: 'Ignition Switch Steel',
    partNumber: 'ASES-3604',
    machine: 'jcb',
    category: '2', // Electrical parts category
    price: 850, // adjust as needed
    images: [
      'v1759565806/ases3604-1_d15xvs.webp'
    ],
    description: 'Durable steel ignition switch designed for JCB machines. Provides reliable electrical connectivity and long-lasting performance. Built to OEM specifications for direct replacement in heavy machinery.',
    specifications: {
      Type: 'Ignition Switch',
      Housing: 'Steel Body',
      Features: 'Corrosion Resistant, Heavy Duty, OEM Fitment',
    },
    featured: true,
    tags: [
      'Ignition Switch',
      'Steel Ignition Switch',
      'JCB Ignition Switch',
      'Electrical Part',
      'OEM Replacement',
      'Durable',
      'Heavy Duty',
      'Reliable',
      'Heavy Equipment'
    ],
    references: [
      // Product codes / variations
      'ases-3604', 'ASES-3604', 'ases3604', 'ASES3604',
      'ignition switch', 'jcb ignition switch', 'steel ignition switch',
      'replacement ignition switch', 'heavy duty ignition switch',

      // Equipment references
      'jcb backhoe loader', 'jcb excavator',
      'backhoe loader ignition switch', 'excavator ignition switch',
      'construction equipment ignition switch', 'heavy machinery ignition switch',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb ignition switch', 'jcb steel ignition switch', 'jcb replacement ignition switch',

      // Spares / keywords
      'jcb spares', 'jcb electrical spares', 'jcb ignition switch spares',
      'replacement ignition switch', 'ignition switch spares',

      // SEO / keywords
      'steel ignition switch jcb', 'heavy duty ignition switch', 'durable ignition switch',
      'jcb backhoe ignition switch', 'jcb excavator ignition switch'
    ]
  },

  //ases3605
  {
    id: 'ASES-3605',
    name: 'Transmission Solenoid Coil Blue 12V - JCB 3DX',
    partNumber: 'ASES-3605',
    machine: 'jcb',
    category: '2', // Electrical / Hydraulic parts
    price: 1150, // adjust as needed
    images: [
      'v1759565805/ases3605_f3vdx7.webp'
    ],
    description: 'High-quality blue transmission solenoid coil designed for JCB 3DX. Provides precise control of hydraulic flow and reliable operation of the transmission system. Built to OEM specifications for direct replacement and long-lasting performance in heavy machinery.',
    specifications: {
      CompatibleModels: 'JCB 3DX',
      Type: 'Transmission Solenoid Coil',
      Voltage: '12V DC',
      Color: 'Blue',
      Housing: 'Durable Steel and Copper Winding',
      Features: 'Corrosion Resistant, OEM Fitment, Long Service Life'
    },
    featured: true,
    tags: [
      'Transmission Solenoid Coil',
      '3DX Solenoid Coil',
      'Blue Solenoid Coil',
      'JCB 3DX',
      '12V Solenoid',
      'Hydraulic Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable'
    ],
    references: [
      // Product codes / variations
      'ases-3605', 'ASES-3605', 'ases3605', 'ASES3605',
      'transmission solenoid coil', '3dx solenoid coil', 'jcb 3dx solenoid',
      '12v transmission solenoid', 'blue solenoid coil', 'replacement solenoid coil',

      // Equipment references
      'jcb 3dx', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3dx transmission solenoid', '3dx transmission coil replacement',

      // Spares / keywords
      'jcb spares', 'jcb hydraulic spares', 'jcb 3dx spares',
      'transmission solenoid replacement', 'solenoid coil spares',

      // SEO / keywords
      'blue transmission solenoid coil', 'jcb 3dx 12v solenoid',
      'durable solenoid coil', 'heavy machinery solenoid coil'
    ]
  },

  //ases3606
  {
    id: 'ASES-3606',
    name: 'Transmission Solenoid Coil Black - JCB 3DX Latest Model',
    partNumber: 'ASES-3606',
    machine: 'jcb',
    category: '2', // Electrical / Hydraulic parts
    price: 1200, // adjust as needed
    images: [
      'v1759565803/ases3606_grpv0i.webp'
    ],
    description: 'High-quality black transmission solenoid coil designed for the latest JCB 3DX models. Provides precise hydraulic control and reliable operation of the transmission system. Built to OEM specifications for direct replacement, ensuring durability and long-lasting performance in heavy machinery.',
    specifications: {
      CompatibleModels: 'JCB 3DX Latest Model',
      Type: 'Transmission Solenoid Coil',
      Voltage: '12V DC',
      Color: 'Black',
      Housing: 'Durable Steel and Copper Winding',
      Features: 'Corrosion Resistant, OEM Fitment, Long Service Life'
    },
    featured: true,
    tags: [
      'Transmission Solenoid Coil',
      '3DX Solenoid Coil',
      'Black Solenoid Coil',
      'JCB 3DX',
      '12V Solenoid',
      'Hydraulic Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable'
    ],
    references: [
      // Product codes / variations
      'ases-3606', 'ASES-3606', 'ases3606', 'ASES3606',
      'transmission solenoid coil', '3dx solenoid coil', 'jcb 3dx solenoid',
      '12v transmission solenoid', 'black solenoid coil', 'latest model solenoid',
      'replacement solenoid coil',

      // Equipment references
      'jcb 3dx', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3dx latest transmission solenoid', '3dx transmission coil replacement',

      // Spares / keywords
      'jcb spares', 'jcb hydraulic spares', 'jcb 3dx spares',
      'transmission solenoid replacement', 'solenoid coil spares',

      // SEO / keywords
      'black transmission solenoid coil', 'jcb 3dx 12v solenoid',
      'durable solenoid coil', 'heavy machinery solenoid coil', 'latest model solenoid'
    ]
  },

  //ases3607
  {
    id: 'ASES-3607',
    name: 'Transmission Solenoid Coil Black - JCB 3DX',
    partNumber: 'ASES-3607',
    machine: 'jcb',
    category: '2', // Electrical / Hydraulic parts
    price: 1150, // adjust as needed
    images: [
      'v1759565802/ases3607_mdsatq.webp'
    ],
    description: 'High-quality black transmission solenoid coil designed for JCB 3DX models. Ensures precise control of hydraulic flow and reliable operation of the transmission system. Built to OEM specifications for direct replacement, providing long-lasting performance in heavy machinery.',
    specifications: {
      CompatibleModels: 'JCB 3DX',
      Type: 'Transmission Solenoid Coil',
      Color: 'Black',
      Housing: 'Durable Steel and Copper Winding',
      Features: 'Corrosion Resistant, OEM Fitment, Long Service Life'
    },
    featured: true,
    tags: [
      'Transmission Solenoid Coil',
      '3DX Solenoid Coil',
      'Black Solenoid Coil',
      'JCB 3DX',
      'Hydraulic Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable'
    ],
    references: [
      // Product codes / variations
      'ases-3607', 'ASES-3607', 'ases3607', 'ASES3607',
      'transmission solenoid coil', '3dx solenoid coil', 'jcb 3dx solenoid',
      '12v transmission solenoid', 'black solenoid coil', 'replacement solenoid coil',

      // Equipment references
      'jcb 3dx', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3dx transmission solenoid', '3dx transmission coil replacement',

      // Spares / keywords
      'jcb spares', 'jcb hydraulic spares', 'jcb 3dx spares',
      'transmission solenoid replacement', 'solenoid coil spares',

      // SEO / keywords
      'black transmission solenoid coil', 'jcb 3dx 12v solenoid',
      'durable solenoid coil', 'heavy machinery solenoid coil'
    ]
  },

  //ases3608
  {
    id: 'ASES-3608',
    name: 'Transmission Solenoid Coil Blue - JCB 3D',
    partNumber: 'ASES-3608',
    machine: 'jcb',
    category: '2', // Electrical / Hydraulic parts
    price: 1100, // adjust as needed
    images: [
      'v1759565801/ases3608_gizm3m.webp'
    ],
    description: 'High-quality blue transmission solenoid coil designed for JCB 3D models. Ensures precise control of hydraulic flow and reliable operation of the transmission system. Built to OEM specifications for direct replacement, providing long-lasting performance in heavy machinery.',
    specifications: {
      'Compatible Models': 'JCB 3D',
      Type: 'Transmission Solenoid Coil',
      Voltage: '12V DC',
      Power: '20W',
      Color: 'Blue',
      Housing: 'Durable Steel and Copper Winding',
      Features: 'Corrosion Resistant, OEM Fitment, Long Service Life'
    },
    featured: true,
    tags: [
      'Transmission Solenoid Coil',
      '3D Solenoid Coil',
      'Blue Solenoid Coil',
      'JCB 3D',
      '20W',
      '12V Solenoid',
      'Hydraulic Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable'
    ],
    references: [
      // Product codes / variations
      'ases-3608', 'ASES-3608', 'ases3608', 'ASES3608',
      'transmission solenoid coil', '3d solenoid coil', 'jcb 3d solenoid',
      '12v transmission solenoid', 'blue solenoid coil', 'replacement solenoid coil',

      // Equipment references
      'jcb 3d', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3d transmission solenoid', '3d transmission coil replacement',

      // Spares / keywords
      'jcb spares', 'jcb hydraulic spares', 'jcb 3d spares',
      'transmission solenoid replacement', 'solenoid coil spares',

      // SEO / keywords
      'blue transmission solenoid coil', 'jcb 3d 12v solenoid',
      'durable solenoid coil', 'heavy machinery solenoid coil'
    ]
  },

  //ases3609
  {
    id: 'ASES-3609',
    name: 'Transmission Solenoid Coil Black - JCB 3D',
    partNumber: 'ASES-3609',
    machine: 'jcb',
    category: '2', // Electrical / Hydraulic parts
    price: 1100, // adjust as needed
    images: [
      'v1759565801/ases3609_twskzs.webp'
    ],
    description: 'High-quality black transmission solenoid coil designed for JCB 3D models. Provides precise control of hydraulic flow and reliable operation of the transmission system. Built to OEM specifications for direct replacement, ensuring long-lasting performance in heavy machinery.',
    specifications: {
      CompatibleModels: 'JCB 3D',
      Type: 'Transmission Solenoid Coil',
      Voltage: '12V DC',
      Color: 'Black',
      Housing: 'Durable Steel and Copper Winding',
      Features: 'Corrosion Resistant, OEM Fitment, Long Service Life'
    },
    featured: true,
    tags: [
      'Transmission Solenoid Coil',
      '3D Solenoid Coil',
      'Black Solenoid Coil',
      'JCB 3D',
      '12V Solenoid',
      'Hydraulic Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable'
    ],
    references: [
      // Product codes / variations
      'ases-3609', 'ASES-3609', 'ases3609', 'ASES3609',
      'transmission solenoid coil', '3d solenoid coil', 'jcb 3d solenoid',
      '12v transmission solenoid', 'black solenoid coil', 'replacement solenoid coil',

      // Equipment references
      'jcb 3d', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3d transmission solenoid', '3d transmission coil replacement',

      // Spares / keywords
      'jcb spares', 'jcb hydraulic spares', 'jcb 3d spares',
      'transmission solenoid replacement', 'solenoid coil spares',

      // SEO / keywords
      'black transmission solenoid coil', 'jcb 3d 12v solenoid',
      'durable solenoid coil', 'heavy machinery solenoid coil'
    ]
  },

  //ases3610
  {
    id: 'ASES-3610',
    name: 'Nut Solenoid - JCB 3D',
    partNumber: 'ASES-3610',
    machine: 'jcb',
    category: '2', // Electrical / Hydraulic parts
    price: 250, // adjust as needed
    images: [
      'v1759565798/ases3610_gxw6rc.webp'
    ],
    description: 'High-quality nut solenoid designed for JCB 3D models. Provides secure and reliable fastening for solenoid assemblies, ensuring safe and efficient operation of the hydraulic system. Built to OEM standards for long-lasting performance.',
    specifications: {
      Type: 'Nut Solenoid',
      Material: 'Steel',
      Features: 'Corrosion Resistant, OEM Fitment, Durable'
    },
    featured: true,
    tags: [
      'Nut Solenoid',
      '3D Solenoid Nut',
      'JCB 3D',
      'Hydraulic Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable'
    ],
    references: [
      // Product codes / variations
      'ases-3610', 'ASES-3610', 'ases3610', 'ASES3610',
      'nut solenoid', '3d solenoid nut', 'jcb 3d solenoid nut',
      'replacement solenoid nut', 'solenoid assembly nut',

      // Equipment references
      'jcb 3d', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3d solenoid nut', '3d solenoid replacement nut',

      // Spares / keywords
      'jcb spares', 'jcb hydraulic spares', 'jcb 3d spares',
      'solenoid nut replacement', 'hydraulic system nut',

      // SEO / keywords
      'nut solenoid jcb 3d', 'durable solenoid nut', 'heavy machinery solenoid nut'
    ]
  },

  //ases3611
  {
    id: 'ASES-3611',
    name: 'Nut Solenoid - JCB 3DX',
    partNumber: 'ASES-3611',
    machine: 'jcb',
    category: '2', // Electrical / Hydraulic parts
    price: 250, // adjust as needed
    images: [
      'v1759565798/ases3610_gxw6rc.webp'
    ],
    description: 'High-quality nut solenoid designed for JCB 3DX models. Ensures secure fastening of solenoid assemblies, providing reliable and efficient operation of the hydraulic system. Built to OEM standards for durability and long-lasting performance.',
    specifications: {
      CompatibleModels: 'JCB 3DX',
      Type: 'Nut Solenoid',
      Material: 'Steel',
      Features: 'Corrosion Resistant, OEM Fitment, Durable'
    },
    featured: true,
    tags: [
      'Nut Solenoid',
      '3DX Solenoid Nut',
      'JCB 3DX',
      'Hydraulic Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable'
    ],
    references: [
      // Product codes / variations
      'ases-3611', 'ASES-3611', 'ases3611', 'ASES3611',
      'nut solenoid', '3dx solenoid nut', 'jcb 3dx solenoid nut',
      'replacement solenoid nut', 'solenoid assembly nut',

      // Equipment references
      'jcb 3dx', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3dx solenoid nut', '3dx solenoid replacement nut',

      // Spares / keywords
      'jcb spares', 'jcb hydraulic spares', 'jcb 3dx spares',
      'solenoid nut replacement', 'hydraulic system nut',

      // SEO / keywords
      'nut solenoid jcb 3dx', 'durable solenoid nut', 'heavy machinery solenoid nut'
    ]
  },

  //ases3612
  {
    id: 'ASES-3612',
    name: 'Solenoid Coupler - JCB 3DX',
    partNumber: 'ASES-3612',
    machine: 'jcb',
    category: '2', // Electrical / Hydraulic parts
    price: 450, // adjust as needed
    images: [
      'v1759565798/ases3612_n6lgoo.webp'
    ],
    description: 'High-quality solenoid coupler designed for JCB 3DX models. Ensures secure and reliable connection between solenoid coils and the hydraulic system, providing consistent and efficient performance. Built to OEM specifications for long-lasting durability.',
    specifications: {
      CompatibleModels: 'JCB 3DX',
      Type: 'Solenoid Coupler',
      Material: 'Steel and Durable Plastic',
      Features: 'Corrosion Resistant, OEM Fitment, Long Service Life'
    },
    featured: true,
    tags: [
      'Solenoid Coupler',
      '3DX Solenoid Coupler',
      'JCB 3DX',
      'Hydraulic Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable'
    ],
    references: [
      // Product codes / variations
      'ases-3612', 'ASES-3612', 'ases3612', 'ASES3612',
      'solenoid coupler', '3dx solenoid coupler', 'jcb 3dx solenoid coupler',
      'replacement solenoid coupler', 'hydraulic coupler',

      // Equipment references
      'jcb 3dx', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3dx solenoid coupler', '3dx hydraulic coupler replacement',

      // Spares / keywords
      'jcb spares', 'jcb hydraulic spares', 'jcb 3dx spares',
      'solenoid coupler replacement', 'hydraulic system coupler',

      // SEO / keywords
      'solenoid coupler jcb 3dx', 'durable solenoid coupler', 'heavy machinery coupler'
    ]
  },

  //ases3613
  {
    id: 'ASES-3613',
    name: 'Solenoid Coupler - JCB 3D',
    partNumber: 'ASES-3613',
    machine: 'jcb',
    category: '2', // Electrical / Hydraulic parts
    price: 450, // adjust as needed
    images: [
      'v1759565796/ases3613_mcn3cv.webp'
    ],
    description: 'High-quality solenoid coupler designed for JCB 3D models. Provides secure connection between solenoid coils and hydraulic systems, ensuring reliable and efficient operation. Built to OEM standards for durability and long-lasting performance.',
    specifications: {
      'Compatible Models': 'JCB 3D',
      Type: 'Solenoid Coupler',
      Material: 'Steel and Durable Plastic',
      Features: 'Corrosion Resistant, OEM Fitment, Long Service Life'
    },
    featured: true,
    tags: [
      'Solenoid Coupler',
      '3D Solenoid Coupler',
      'JCB 3D',
      'Hydraulic Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable'
    ],
    references: [
      // Product codes / variations
      'ases-3613', 'ASES-3613', 'ases3613', 'ASES3613',
      'solenoid coupler', '3d solenoid coupler', 'jcb 3d solenoid coupler',
      'replacement solenoid coupler', 'hydraulic coupler',

      // Equipment references
      'jcb 3d', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3d solenoid coupler', '3d hydraulic coupler replacement',

      // Spares / keywords
      'jcb spares', 'jcb hydraulic spares', 'jcb 3d spares',
      'solenoid coupler replacement', 'hydraulic system coupler',

      // SEO / keywords
      'solenoid coupler jcb 3d', 'durable solenoid coupler', 'heavy machinery coupler'
    ]
  },

  //ases3614
  {
    id: 'ASES-3614',
    name: 'Dump Switch with Knob and Wire',
    partNumber: 'ASES-3614',
    machine: 'jcb',
    category: '2', // Electrical parts
    price: 650, // adjust as needed
    images: [
      'v1759565795/ases3614_efqjkz.webp'
    ],
    description: 'High-quality dump switch designed for JCB 3DX models. Comes with a durable knob and pre-attached wiring for easy installation. Ensures reliable control of dump operations in backhoe loaders and other heavy machinery. Built to OEM standards for long-lasting performance and durability.',
    specifications: {
      Type: 'Dump Switch',
      Connector: 'Wired',
      Features: 'Durable Knob, OEM Fitment, Long Service Life, Corrosion Resistant'
    },
    featured: true,
    tags: [
      'Dump Switch',
      '3DX Dump Switch',
      'JCB 3DX',
      'Electrical Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable'
    ],
    references: [
      // Product codes / variations
      'ases-3614', 'ASES-3614', 'ases3614', 'ASES3614',
      'dump switch', '3dx dump switch', 'jcb 3dx dump switch',
      'dump control switch', 'replacement dump switch', 'wired dump switch', 'knob switch',

      // Equipment references
      'jcb 3dx', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3dx dump switch with wire', '3dx dump control switch',

      // Spares / keywords
      'jcb spares', 'jcb electrical spares', 'jcb 3dx spares',
      'dump switch replacement', 'heavy machinery dump control',

      // SEO / keywords
      'dump switch jcb 3dx', 'durable dump switch', 'backhoe loader dump switch'
    ]
  },

  //ases3615
  {
    id: 'ASES-3615',
    name: 'Fuse Box - JCB 3DX 2014',
    partNumber: 'ASES-3615',
    machine: 'jcb',
    category: '2', // Electrical parts
    price: 1200, // adjust as needed
    images: [
      'v1759565795/ases3615_nge0jp.webp'
    ],
    description: 'High-quality fuse box designed for JCB 3DX models. Provides organized and reliable protection for electrical circuits in backhoe loaders and heavy machinery. Built to OEM standards for durability and long-lasting performance.',
    specifications: {
      'Compatible Models': 'JCB 3DX',
      Type: 'Fuse Box',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'OEM Fitment, Corrosion Resistant, Long Service Life'
    },
    featured: true,
    tags: [
      'Fuse Box',
      '3DX Fuse Box',
      'JCB 3DX 2014',
      'Electrical Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable'
    ],
    references: [
      // Product codes / variations
      'ases-3615', 'ASES-3615', 'ases3615', 'ASES3615',
      'fuse box', '3dx fuse box', 'jcb 3dx fuse box',
      'electrical fuse box', 'replacement fuse box', 'backhoe fuse box',

      // Equipment references
      'jcb 3dx', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3dx 2014 fuse box', '3dx 2014 electrical fuse box',

      // Spares / keywords
      'jcb spares', 'jcb electrical spares', 'jcb 3dx spares',
      'fuse box replacement', 'heavy machinery fuse box',

      // SEO / keywords
      'fuse box jcb 3dx', 'durable fuse box', '3dx backhoe fuse box'
    ]
  },

  //ases3616
  {
    id: 'ASES-3616',
    name: 'Fuse Box - JCB 3DX',
    partNumber: 'ASES-3616',
    machine: 'jcb',
    category: '2', // Electrical parts
    price: 1250, // adjust as needed
    images: [
      'v1759565792/ases3616_tiwqyo.webp'
    ],
    description: 'High-quality fuse box designed for JCB 3DX models. Provides reliable protection for electrical circuits in backhoe loaders and heavy machinery. Built to OEM standards to ensure durability and long-lasting performance.',
    specifications: {
      'Compatible Models': 'JCB 3DX',
      Type: 'Fuse Box',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'OEM Fitment, Corrosion Resistant, Long Service Life'
    },
    featured: true,
    tags: [
      'Fuse Box',
      '3DX Fuse Box',
      'JCB 3DX',
      'Electrical Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable'
    ],
    references: [
      // Product codes / variations
      'ases-3616', 'ASES-3616', 'ases3616', 'ASES3616',
      'fuse box', '3dx fuse box', 'jcb 3dx fuse box',
      'electrical fuse box', 'replacement fuse box', 'backhoe fuse box',

      // Equipment references
      'jcb 3dx', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3dx fuse box', '3dx electrical fuse box',

      // Spares / keywords
      'jcb spares', 'jcb electrical spares', 'jcb 3dx spares',
      'fuse box replacement', 'heavy machinery fuse box',

      // SEO / keywords
      'fuse box jcb 3dx', 'durable fuse box', '3dx backhoe fuse box'
    ]
  },

  //ases3617
  {
    id: 'ASES-3617',
    name: 'Battery Fuse Box 60A - JCB 3DX',
    partNumber: 'ASES-3617',
    machine: 'jcb',
    category: '2', // Electrical parts
    price: 800, // adjust as needed
    images: [
      'v1759565792/ases3617_icanf3.webp'
    ],
    description: 'High-quality 60A battery fuse box designed for JCB 3DX models. Provides reliable circuit protection for the battery system, ensuring safe and efficient operation of heavy machinery. Built to OEM standards for durability and long-lasting performance.',
    specifications: {
      Type: 'Battery Fuse Box',
      Rating: '60A',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'OEM Fitment, Corrosion Resistant, Long Service Life'
    },
    featured: true,
    tags: [
      'Battery Fuse Box',
      '3DX Battery Fuse',
      'JCB 3DX',
      'Electrical Part',
      'OEM Replacement',
      'Durable',
      'Heavy Equipment',
      'Reliable',
      '60A Fuse Box'
    ],
    references: [
      // Product codes / variations
      'ases-3617', 'ASES-3617', 'ases3617', 'ASES3617',
      'battery fuse box', '3dx battery fuse box', 'jcb 3dx battery fuse box',
      '60a fuse box', 'replacement battery fuse box',

      // Equipment references
      'jcb 3dx', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand associations
      'jcb',

      // Model-specific combos
      'jcb 3dx 60a battery fuse box', '3dx battery fuse box replacement',

      // Spares / keywords
      'jcb spares', 'jcb electrical spares', 'jcb 3dx spares',
      'battery fuse replacement', 'heavy machinery fuse box',

      // SEO / keywords
      'battery fuse box jcb 3dx', 'durable 60a fuse box', '3dx backhoe fuse box'
    ]
  },

  //ases3618
  {
    id: 'ASES-3618',
    name: '10A Fuse - Imported',
    partNumber: 'ASES-3618',
    machine: 'all', // Compatible with multiple machines
    category: '2', // Electrical parts
    price: 50, // adjust as needed
    images: [
      'v1759565791/ases3618_fi3r6b.webp'
    ],
    description: 'High-quality 10A fuse suitable for various construction, agricultural, and industrial equipment. Provides reliable overcurrent protection for electrical circuits, ensuring safety and long-lasting performance. Compatible with multiple brands and models.',
    specifications: {
      Type: '10A Fuse',
      Rating: '10 Amps',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Universal Fit, Corrosion Resistant, Long Service Life'
    },
    featured: true,
    tags: [
      '10A Fuse',
      'Normal Fuse',
      'Electrical Part',
      'Durable',
      'Heavy Equipment',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3618', 'ASES-3618', 'ases3618', 'ASES3618',
      '10a fuse', '10 amp fuse', 'replacement fuse', 'electrical fuse', 'machine fuse',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare fuse', 'fuse replacement', 'electrical spare', 'heavy machinery fuse',

      // SEO / keywords
      '10a fuse heavy equipment', 'universal 10a fuse', 'durable 10a fuse'
    ]
  },

  //ases3619
  {
    id: 'ASES-3619',
    name: '15A Fuse - Imported',
    partNumber: 'ASES-3619',
    category: '2', // Electrical parts
    price: 70, // adjust as needed
    images: [
      'v1759565791/ases3619_edzvgj.webp'
    ],
    description: 'High-quality imported 15A fuse suitable for a wide range of construction, agricultural, and industrial equipment. Provides reliable overcurrent protection for electrical circuits, ensuring safety and long-lasting performance. Compatible with multiple brands and heavy machinery models.',
    specifications: {
      Type: '15A Fuse',
      Rating: '15 Amps',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Imported Quality, Universal Fit, Corrosion Resistant, Long Service Life'
    },
    featured: true,
    tags: [
      '15A Fuse',
      'Imported Fuse',
      'Electrical Part',
      'Durable',
      'Heavy Equipment',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3619', 'ASES-3619', 'ases3619', 'ASES3619',
      '15a fuse', '15 amp fuse', 'imported fuse', 'replacement fuse', 'electrical fuse', 'machine fuse',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare fuse', 'fuse replacement', 'electrical spare', 'heavy machinery fuse',

      // SEO / keywords
      '15a fuse heavy equipment', 'imported 15a fuse', 'universal 15a fuse', 'durable 15a fuse'
    ]
  },

  //ases3620
  {
    id: 'ASES-3620',
    name: '20A Fuse - Imported',
    partNumber: 'ASES-3620',
    category: '2', // Electrical parts
    price: 80, // adjust as needed
    images: [
      'v1759565788/ases3620_nywnbw.webp'
    ],
    description: 'High-quality imported 20A fuse suitable for a wide range of construction, agricultural, and industrial equipment. Provides reliable overcurrent protection for electrical circuits, ensuring safety and long-lasting performance. Compatible with multiple brands and heavy machinery models.',
    specifications: {
      Type: '20A Fuse',
      Rating: '20 Amps',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Imported Quality, Universal Fit, Corrosion Resistant, Long Service Life'
    },
    featured: true,
    tags: [
      '20A Fuse',
      'Imported Fuse',
      'Universal Fuse',
      'Electrical Part',
      'Durable',
      'Heavy Equipment',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3620', 'ASES-3620', 'ases3620', 'ASES3620',
      '20a fuse', '20 amp fuse', 'imported fuse', 'replacement fuse', 'electrical fuse', 'machine fuse',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare fuse', 'fuse replacement', 'electrical spare', 'heavy machinery fuse',

      // SEO / keywords
      '20a fuse heavy equipment', 'imported 20a fuse', 'universal 20a fuse', 'durable 20a fuse'
    ]
  },

  //ases3621
  {
    id: 'ASES-3621',
    name: '25A Fuse - Imported',
    partNumber: 'ASES-3621',
    category: '2', // Electrical parts
    price: 90, // adjust as needed
    images: [
      'v1759565788/ases3621_yyvmly.webp'
    ],
    description: 'High-quality imported 25A fuse suitable for various construction, agricultural, and industrial equipment. Provides reliable overcurrent protection for electrical circuits, ensuring safety and long-lasting performance. Compatible with multiple brands and heavy machinery models.',
    specifications: {
      Type: '25A Fuse',
      Rating: '25 Amps',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Imported Quality, Universal Fit, Corrosion Resistant, Long Service Life'
    },
    featured: true,
    tags: [
      '25A Fuse',
      'Imported Fuse',
      'Electrical Part',
      'Durable',
      'Heavy Equipment',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3621', 'ASES-3621', 'ases3621', 'ASES3621',
      '25a fuse', '25 amp fuse', 'imported fuse', 'replacement fuse', 'electrical fuse', 'machine fuse',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare fuse', 'fuse replacement', 'electrical spare', 'heavy machinery fuse',

      // SEO / keywords
      '25a fuse heavy equipment', 'imported 25a fuse', 'universal 25a fuse', 'durable 25a fuse'
    ]
  },

  //ases3622
  {
    id: 'ASES-3622',
    name: '30A Fuse - Imported',
    partNumber: 'ASES-3622',
    category: '2', // Electrical parts
    price: 100, // adjust as needed
    images: [
      'v1759565787/ases3622_yqegwc.webp'
    ],
    description: 'High-quality imported 30A fuse suitable for a wide range of construction, agricultural, and industrial equipment. Provides reliable overcurrent protection for electrical circuits, ensuring safety and long-lasting performance. Compatible with multiple brands and heavy machinery models.',
    specifications: {
      Type: '30A Fuse',
      Rating: '30 Amps',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Imported Quality, Universal Fit, Corrosion Resistant, Long Service Life'
    },
    featured: true,
    tags: [
      '30A Fuse',
      'Imported Fuse',
      'Electrical Part',
      'Durable',
      'Heavy Equipment',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3622', 'ASES-3622', 'ases3622', 'ASES3622',
      '30a fuse', '30 amp fuse', 'imported fuse', 'replacement fuse', 'electrical fuse', 'machine fuse',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare fuse', 'fuse replacement', 'electrical spare', 'heavy machinery fuse',

      // SEO / keywords
      '30a fuse heavy equipment', 'imported 30a fuse', 'universal 30a fuse', 'durable 30a fuse'
    ]
  },

  //ases3623
  {
    id: 'ASES-3623',
    name: '35A Fuse - Imported',
    partNumber: 'ASES-3623',
    category: '2', // Electrical parts
    price: 110, // adjust as needed
    images: [
      'v1759565785/ases3623_r9llg7.webp'
    ],
    description: 'High-quality imported 35A fuse suitable for various construction, agricultural, and industrial equipment. Provides reliable overcurrent protection for electrical circuits, ensuring safety and long-lasting performance. Compatible with multiple brands and heavy machinery models.',
    specifications: {
      Type: '35A Fuse',
      Rating: '35 Amps',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Imported Quality, Universal Fit, Corrosion Resistant, Long Service Life'
    },
    featured: true,
    tags: [
      '35A Fuse',
      'Imported Fuse',
      'Electrical Part',
      'Durable',
      'Heavy Equipment',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3623', 'ASES-3623', 'ases3623', 'ASES3623',
      '35a fuse', '35 amp fuse', 'imported fuse', 'replacement fuse', 'electrical fuse', 'machine fuse',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare fuse', 'fuse replacement', 'electrical spare', 'heavy machinery fuse',

      // SEO / keywords
      '35a fuse heavy equipment', 'imported 35a fuse', 'universal 35a fuse', 'durable 35a fuse'
    ]
  },

  //ases3624
  {
    id: 'ASES-3624',
    name: '40A Fuse - AS Type, Imported',
    partNumber: 'ASES-3624',
    category: '2', // Electrical parts
    price: 120, // adjust as needed
    images: [
      'v1759565783/ases3624_gkteqz.webp'
    ],
    description: 'High-quality imported 40A AS type fuse suitable for a wide range of construction, agricultural, and industrial equipment. Provides reliable overcurrent protection for electrical circuits, ensuring safety and long-lasting performance. Compatible with multiple brands and heavy machinery models.',
    specifications: {
      Type: 'AS Type Fuse',
      Rating: '40 Amps',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Imported Quality, Universal Fit, Corrosion Resistant, Long Service Life'
    },
    featured: true,
    tags: [
      '40A Fuse',
      'AS Type Fuse',
      'Imported Fuse',
      'Electrical Part',
      'Durable',
      'Heavy Equipment',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3624', 'ASES-3624', 'ases3624', 'ASES3624',
      '40a fuse', '40 amp fuse', 'as type fuse', 'imported fuse', 'replacement fuse', 'electrical fuse', 'machine fuse',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare fuse', 'fuse replacement', 'electrical spare', 'heavy machinery fuse',

      // SEO / keywords
      '40a as type fuse', 'as type 40a fuse', 'imported 40a fuse', 'universal 40a fuse', 'durable 40a fuse'
    ]
  },

  //ases3625
  {
    id: 'ASES-3625',
    name: '60A Fuse - AS Type, Imported',
    partNumber: 'ASES-3625',
    machine: 'all', // Compatible with multiple machines
    category: '2', // Electrical parts
    price: 180, // adjust as needed
    images: [
      'v1759565782/ases3625_sv8pem.webp'
    ],
    description: 'High-quality imported 60A AS type fuse suitable for a wide range of construction, agricultural, and industrial equipment. Provides reliable overcurrent protection for electrical circuits, ensuring safety and long-lasting performance. Compatible with multiple brands and heavy machinery models.',
    specifications: {
      Type: 'AS Type Fuse',
      Rating: '60 Amps',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Imported Quality, Universal Fit, Corrosion Resistant, Long Service Life'
    },
    featured: true,
    tags: [
      '60A Fuse',
      'AS Type Fuse',
      'Imported Fuse',
      'Electrical Part',
      'Durable',
      'Heavy Equipment',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3625', 'ASES-3625', 'ases3625', 'ASES3625',
      '60a fuse', '60 amp fuse', 'as type fuse', 'imported fuse', 'replacement fuse', 'electrical fuse', 'machine fuse',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare fuse', 'fuse replacement', 'electrical spare', 'heavy machinery fuse',

      // SEO / keywords
      '60a as type fuse', 'as type 60a fuse', 'imported 60a fuse', 'universal 60a fuse', 'durable 60a fuse'
    ]
  },

  //ases3626
  {
    id: 'ASES-3626',
    name: 'Push Pull Switch - Long',
    partNumber: 'ASES-3626',
    category: '2', // Electrical parts
    price: 250, // adjust as needed
    images: [
      'v1759565780/ases3626_ua5hiz.webp'
    ],
    description: 'High-quality long push-pull switch suitable for various construction, agricultural, and industrial equipment. Designed for reliable operation and long service life. Ideal for controlling electrical circuits in heavy machinery.',
    specifications: {
      Type: 'Push Pull Switch',
      Style: 'Long',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Reliable Operation, Corrosion Resistant, Long Service Life, Universal Fit'
    },
    featured: true,
    tags: [
      'Push Pull Switch',
      'Long Switch',
      'Electrical Switch',
      'Heavy Equipment Switch',
      'Durable',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3626', 'ASES-3626', 'ases3626', 'ASES3626',
      'push pull switch', 'long push pull switch', 'electrical switch', 'machine switch', 'replacement switch',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare switch', 'switch replacement', 'electrical spare', 'heavy machinery switch',

      // SEO / keywords
      'long push pull switch', 'push pull switch heavy equipment', 'durable push pull switch', 'universal push pull switch'
    ]
  },

  //ases3627
  {
    id: 'ASES-3627',
    name: 'Push Pull Switch - Short',
    partNumber: 'ASES-3627',
    category: '2', // Electrical parts
    price: 230, // adjust as needed
    images: [
      'v1759565779/ases3627_age4um.webp'
    ],
    description: 'High-quality short push-pull switch suitable for various construction, agricultural, and industrial equipment. Designed for reliable operation and long service life. Ideal for controlling electrical circuits in heavy machinery.',
    specifications: {
      Type: 'Push Pull Switch',
      Style: 'Short',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Reliable Operation, Corrosion Resistant, Long Service Life, Universal Fit'
    },
    featured: true,
    tags: [
      'Push Pull Switch',
      'Short Switch',
      'Electrical Switch',
      'Heavy Equipment Switch',
      'Durable',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3627', 'ASES-3627', 'ases3627', 'ASES3627',
      'push pull switch', 'short push pull switch', 'electrical switch', 'machine switch', 'replacement switch',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare switch', 'switch replacement', 'electrical spare', 'heavy machinery switch',

      // SEO / keywords
      'short push pull switch', 'push pull switch heavy equipment', 'durable push pull switch', 'universal push pull switch'
    ]
  },

  //ases3628
  {
    id: 'ASES-3628',
    name: 'Head Light Switch',
    partNumber: 'ASES-3628',
    category: '2', // Electrical parts
    price: 350, // adjust as needed
    images: [
      'v1759565779/ases3628_bwrlpe.webp'
    ],
    description: 'High-quality head light switch suitable for various construction, agricultural, and industrial equipment. Designed for reliable operation and long service life. Enables easy control of vehicle headlights, ensuring safety and proper illumination.',
    specifications: {
      Type: 'Head Light Switch',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Reliable Operation, Corrosion Resistant, Long Service Life, Universal Fit'
    },
    featured: true,
    tags: [
      'Head Light Switch',
      'Electrical Switch',
      'Heavy Equipment Switch',
      'Durable',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3628', 'ASES-3628', 'ases3628', 'ASES3628',
      'head light switch', 'headlamp switch', 'electrical switch', 'machine switch', 'replacement switch',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare switch', 'switch replacement', 'electrical spare', 'heavy machinery switch',

      // SEO / keywords
      'head light switch heavy equipment', 'durable headlamp switch', 'universal head light switch'
    ]
  },

  //ases3629
  {
    id: 'ASES-3629',
    name: 'Extra Fuse - Long',
    partNumber: 'ASES-3629',
    category: '2', // Electrical parts
    price: 90, // adjust as needed
    images: [
      'v1759565776/ases3629_ukdn6t.webp'
    ],
    description: 'High-quality long extra fuse suitable for construction, agricultural, and industrial equipment. Provides reliable overcurrent protection for electrical circuits. Designed for universal use across multiple heavy machinery models.',
    specifications: {
      Type: 'Extra Fuse',
      Style: 'Long',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Reliable Protection, Corrosion Resistant, Long Service Life, Universal Fit'
    },
    featured: true,
    tags: [
      'Extra Fuse',
      'Long Fuse',
      'Electrical Fuse',
      'Heavy Equipment Fuse',
      'Durable',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3629', 'ASES-3629', 'ases3629', 'ASES3629',
      'extra fuse', 'long extra fuse', 'electrical fuse', 'replacement fuse', 'machine fuse',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare fuse', 'fuse replacement', 'electrical spare', 'heavy machinery fuse',

      // SEO / keywords
      'extra fuse long heavy equipment', 'long extra fuse', 'durable extra fuse', 'universal extra fuse'
    ]
  },

  //ases3630
  {
    id: 'ASES-3630',
    name: 'Head Light Holder',
    partNumber: 'ASES-3630',
    category: '2', // Electrical parts
    price: 180, // adjust as needed
    images: [
      'v1759565776/ases3630_qpa3d9.webp'
    ],
    description: 'High-quality head light holder suitable for construction, agricultural, and industrial equipment. Designed to securely hold and mount headlight assemblies, ensuring proper alignment and stable performance under heavy-duty conditions.',
    specifications: {
      Type: 'Head Light Holder',
      Material: 'Durable PVC',
      Features: 'Strong Mounting, Corrosion Resistant, Long Service Life, Universal Fit'
    },
    featured: true,
    tags: [
      'Head Light Holder',
      'Electrical Part',
      'Heavy Equipment',
      'Durable',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3630', 'ASES-3630', 'ases3630', 'ASES3630',
      'head light holder', 'headlamp holder', 'light mounting bracket', 'replacement headlight holder',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare headlight holder', 'headlight replacement', 'electrical spare', 'heavy machinery headlight mount',

      // SEO / keywords
      'head light holder heavy equipment', 'durable headlight holder', 'universal head light holder'
    ]
  },

  //ases3631
  {
    id: 'ASES-3631',
    name: 'Electrical Tape',
    partNumber: 'ASES-3631',
    category: '2', // Electrical parts
    price: 50, // adjust as needed
    images: [
      'v1759565775/ases3631_lebsbd.webp'
    ],
    description: 'High-quality electrical tape suitable for insulation and protection of electrical wiring in construction, agricultural, and industrial equipment. Provides reliable adhesion, flexibility, and durability for long-lasting performance.',
    specifications: {
      Type: 'Electrical Tape',
      Material: 'PVC',
      Features: 'Insulating, Flexible, Durable, Heat and Weather Resistant'
    },
    featured: true,
    tags: [
      'Electrical Tape',
      'PVC Tape',
      'Insulation Tape',
      'Heavy Equipment',
      'Durable',
      'Reliable',
      'Electrical Spare',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3631', 'ASES-3631', 'ases3631', 'ASES3631',
      'electrical tape', 'pvc tape', 'insulation tape', 'wiring tape', 'machine electrical tape', 'replacement tape',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare electrical tape', 'electrical insulation', 'wire protection tape', 'heavy machinery wiring',

      // SEO / keywords
      'electrical tape heavy equipment', 'pvc electrical tape', 'durable insulation tape'
    ]
  },

  //ases3632
  {
    id: 'ASES-3632',
    name: '5A Fuse - Imported',
    partNumber: 'ASES-3632',
    category: '2', // Electrical parts
    price: 25, // adjust as needed
    images: [
      'v1759565775/ases3632_xabpq6.webp'
    ],
    description: 'High-quality 5A fuse suitable for construction, agricultural, and industrial equipment. Provides reliable overcurrent protection for electrical circuits, ensuring safety and long-lasting performance. Imported quality for durability and consistent performance.',
    specifications: {
      Type: 'Fuse',
      Rating: '5 Amps',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Imported Quality, Universal Fit, Corrosion Resistant, Long Service Life'
    },
    featured: true,
    tags: [
      '5A Fuse',
      'Electrical Fuse',
      'Imported Fuse',
      'Universal Fuse',
      'Durable',
      'Reliable',
      'Heavy Equipment',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3632', 'ASES-3632', 'ases3632', 'ASES3632',
      '5a fuse', '5 amp fuse', 'imported fuse', 'replacement fuse', 'electrical fuse', 'machine fuse',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare fuse', 'fuse replacement', 'electrical spare', 'heavy machinery fuse',

      // SEO / keywords
      '5a fuse heavy equipment', 'imported 5a fuse', 'durable 5a fuse', 'universal 5a fuse'
    ]
  },

  //ases3633
  {
    id: 'ASES-3633',
    name: 'Head Light Switch - 6 Pin',
    partNumber: 'ASES-3633',
    machine: 'all', // Compatible with multiple machines
    category: '2', // Electrical parts
    price: 400, // adjust as needed
    images: [
      'v1759565775/ases3633_lghlp5.webp'
    ],
    description: 'High-quality 6-pin head light switch suitable for construction, agricultural, and industrial equipment. Ensures reliable operation of vehicle headlights with long service life and corrosion-resistant design. Compatible with multiple heavy machinery models.',
    specifications: {
      Type: 'Head Light Switch',
      Pins: '6 Pin',
      Material: 'Durable Plastic with Metal Contacts',
      Features: 'Reliable Operation, Corrosion Resistant, Long Service Life, Universal Fit'
    },
    featured: true,
    tags: [
      'Head Light Switch',
      '6 Pin Switch',
      'Electrical Switch',
      'Heavy Equipment Switch',
      'Durable',
      'Reliable',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'ases-3633', 'ASES-3633', 'ases3633', 'ASES3633',
      'head light switch 6 pin', '6 pin headlight switch', 'headlamp switch', 'electrical switch', 'machine switch', 'replacement switch',

      // Equipment types
      'backhoe loader', 'wheeled loader', 'excavator', 'construction equipment',
      'agricultural equipment', 'industrial equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'l&t', 'case', 'escorts', 'digimax', 'terex', 'manitou', 'ace', 'asus', 'mahindra', 'volvo', 'bull',

      // Spares / keywords
      'spare headlight switch', 'headlight replacement', 'electrical spare', 'heavy machinery headlight switch',

      // SEO / keywords
      '6 pin head light switch heavy equipment', 'durable headlamp switch', 'universal head light switch'
    ]
  },



  ////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //Pre-Cleaners
  //asfp1001
  {
    id: 'ASFP-1001',
    name: 'Pre-Cleaner Assembly - JCB 3DX',
    partNumber: 'ASFP-1001',
    machine: 'jcb',
    category: '3', // Category 3 for air & fuel systems / filters
    price: 1800, // adjust as needed
    images: [
      'v1759565073/asfp1001_vegbjw.webp'
    ],
    description: 'High-quality pre-cleaner assembly designed for JCB 3DX backhoe loader. Protects the engine air intake by removing dust and debris before the air enters the air filter, ensuring longer engine life and optimal performance.',
    specifications: {
      Type: 'Pre-Cleaner Assembly',
      Application: 'JCB 3DX',
      Material: 'Durable Plastic & Metal Components',
      Features: 'Dust & Debris Removal, Easy Installation, OEM Fit, Long Service Life'
    },
    featured: true,
    tags: [
      'Pre-Cleaner',
      'Air Intake',
      'JCB 3DX',
      'Engine Protection',
      'Durable',
      'OEM Replacement',
      'Heavy Equipment',
      'Backhoe Loader'
    ],
    references: [
      // Product codes / variations
      'asfp-1001', 'ASFP-1001', 'asfp1001', 'ASFP1001',
      'pre cleaner', 'precleaner assembly', 'air intake pre cleaner', 'engine pre cleaner', 'replacement pre cleaner',

      // Equipment references
      'jcb 3dx', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'case', 'l&t', 'escorts', 'terex', 'volvo', 'ace', 'mahindra', 'bull', 'manitou', 'asus',

      // Spares / keywords
      'engine pre cleaner', 'air intake spare', 'pre cleaner replacement', 'heavy machinery air intake',

      // SEO / keywords
      'pre cleaner assembly jcb 3dx', 'engine protection pre cleaner', 'dust removal pre cleaner', 'backhoe loader pre cleaner'
    ]
  },

  //asfp1002
  {
    id: 'ASFP-1002',
    name: 'Pre-Cleaner Assembly - JCB 3DX 2017',
    partNumber: 'ASFP-1002',
    machine: 'jcb',
    category: '3', // Category 3 for air & fuel systems / filters
    price: 2000, // adjust as needed
    images: [
      'v1759565072/asfp1002_vp2cmo.webp'
    ],
    description: 'High-quality pre-cleaner assembly designed specifically for JCB 3DX 2017 model backhoe loader. Removes dust and debris before air enters the air filter, protecting the engine and ensuring optimal performance under harsh working conditions.',
    specifications: {
      Type: 'Pre-Cleaner Assembly',
      Application: 'JCB 3DX (2017 Model)',
      Material: 'Durable Plastic & Metal Components',
      Features: 'Dust & Debris Removal, Easy Installation, OEM Fit, Long Service Life'
    },
    featured: true,
    tags: [
      'Pre-Cleaner',
      'Air Intake',
      'JCB 3DX 2017',
      'Engine Protection',
      'Durable',
      'OEM Replacement',
      'Heavy Equipment',
      'Backhoe Loader'
    ],
    references: [
      // Product codes / variations
      'asfp-1002', 'ASFP-1002', 'asfp1002', 'ASFP1002',
      'pre cleaner', 'precleaner assembly', 'air intake pre cleaner', 'engine pre cleaner', 'replacement pre cleaner',

      // Equipment references
      'jcb 3dx', 'jcb 3dx 2017', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'case', 'l&t', 'escorts', 'terex', 'volvo', 'ace', 'mahindra', 'bull', 'manitou', 'asus',

      // Spares / keywords
      'engine pre cleaner', 'air intake spare', 'pre cleaner replacement', 'heavy machinery air intake',

      // SEO / keywords
      'pre cleaner assembly jcb 3dx 2017', 'engine protection pre cleaner', 'dust removal pre cleaner', 'backhoe loader pre cleaner'
    ]
  },

  //asfp1003
  {
    id: 'ASFP-1003',
    name: 'Pre-Cleaner Glass - JCB',
    partNumber: 'ASFP-1003',
    machine: 'jcb',
    category: '3', // Category 3 for air & fuel systems / filters
    price: 450, // adjust as needed
    images: [
      'v1759565041/asfp1003_dlofnt.webp'
    ],
    description: 'High-quality replacement pre-cleaner glass designed for JCB backhoe loaders and construction equipment. Ensures proper functioning of the pre-cleaner assembly by protecting the engine air intake from dust and debris, extending the service life of the air filter and engine.',
    specifications: {
      Type: 'Pre-Cleaner Glass',
      Application: 'JCB Backhoe Loader',
      Material: 'Durable Tempered Glass',
      Features: 'Clear Visibility, Impact Resistant, Easy Replacement, Long Service Life'
    },
    featured: true,
    tags: [
      'Pre-Cleaner Glass',
      'Air Intake Protection',
      'JCB',
      'Durable',
      'OEM Replacement',
      'Heavy Equipment',
      'Backhoe Loader'
    ],
    references: [
      // Product codes / variations
      'asfp-1003', 'ASFP-1003', 'asfp1003', 'ASFP1003',
      'pre cleaner glass', 'replacement pre cleaner glass', 'air intake glass', 'engine protection glass', 'precleaner spare glass',

      // Equipment references
      'jcb', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand references
      'jcb', 'cat', 'case', 'l&t', 'escorts', 'terex', 'volvo', 'ace', 'mahindra', 'bull', 'manitou', 'asus',

      // Spares / keywords
      'spare pre cleaner glass', 'pre cleaner replacement', 'engine air intake spare', 'heavy machinery air intake',

      // SEO / keywords
      'pre cleaner glass jcb', 'engine protection pre cleaner glass', 'dust removal pre cleaner glass', 'backhoe loader pre cleaner glass'
    ]
  },

  //asfp1004
  {
    id: 'ASFP-1004',
    name: 'Pre-Cleaner Glass - L&T',
    partNumber: 'ASFP-1004',
    machine: 'L&T',
    category: '3', // Category 3 for air & fuel systems / filters
    price: 500, // adjust as needed
    images: [
      'v1759565041/asfp1004_nfl8d9.webp'
    ],
    description: 'High-quality replacement pre-cleaner glass designed for L&T backhoe loaders and construction equipment. Protects the engine air intake by removing dust and debris before it reaches the air filter, ensuring longer engine life and optimal performance.',
    specifications: {
      Type: 'Pre-Cleaner Glass',
      Application: 'L&T Backhoe Loader',
      Material: 'Durable Tempered Glass',
      Features: 'Clear Visibility, Impact Resistant, Easy Replacement, Long Service Life'
    },
    featured: true,
    tags: [
      'Pre-Cleaner Glass',
      'Air Intake Protection',
      'L&T',
      'Durable',
      'OEM Replacement',
      'Heavy Equipment',
      'Backhoe Loader'
    ],
    references: [
      // Product codes / variations
      'asfp-1004', 'ASFP-1004', 'asfp1004', 'ASFP1004',
      'pre cleaner glass', 'replacement pre cleaner glass', 'air intake glass', 'engine protection glass', 'precleaner spare glass',

      // Equipment references
      'l&t', 'backhoe loader', 'construction equipment', 'heavy machinery',

      // Brand references
      'l&t', 'jcb', 'cat', 'case', 'escorts', 'terex', 'volvo', 'ace', 'mahindra', 'bull', 'manitou', 'asus',

      // Spares / keywords
      'spare pre cleaner glass', 'pre cleaner replacement', 'engine air intake spare', 'heavy machinery air intake',

      // SEO / keywords
      'pre cleaner glass lt', 'engine protection pre cleaner glass', 'dust removal pre cleaner glass', 'backhoe loader pre cleaner glass'
    ]
  },




  ///////////////////////////////////////////////////////////////////////////////////////////////////////////
  //Gear Parts

  //asgp4001
  {
    id: 'ASGP-4001',
    name: 'JCB Crown Wheel & Pinion - 13T/37T',
    partNumber: 'ASGP-4001',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 7500, // adjust as needed
    images: [
      'v1759564582/asgp4001_vfa0d9.webp'
    ],
    description: 'High-quality Crown Wheel & Pinion set (13T/37T) specifically designed for JCB 3D backhoe loaders. Ensures precise gear engagement and reliable power transmission for heavy-duty operations. Built to OEM specifications for long-lasting durability and efficient drivetrain performance.',
    specifications: {
      Type: 'Crown Wheel & Pinion Set',
      Application: 'JCB 3D Backhoe Loader',
      Teeth: '13T Pinion / 37T Crown Wheel',
      Material: 'High-Strength Alloy Steel',
      Features: 'Precision Machined, OEM Fit, Durable, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Crown Wheel & Pinion',
      'JCB 3D',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement',
      'Backhoe Loader'
    ],
    oeReference: ['453/00900'],
    compatibility: ['JCB 3D', 'JCB Backhoe Loader'],
    references: [
      // Product codes / variations
      'asgp-4001', 'ASGP-4001', 'asgp4001', 'ASGP4001',
      'crown wheel', 'pinion', 'crown wheel & pinion', '13t crown wheel', '37t pinion',
      'crown wheel pinion set', 'drivetrain spare', 'transmission spare', 'replacement crown wheel', 'replacement pinion',

      // Equipment references
      'jcb 3d', 'jcb 3d backhoe loader', 'jcb 3d drivetrain', 'backhoe loader',

      // Spares / keywords
      'crown wheel pinion replacement', 'drivetrain replacement', 'transmission replacement',
      'heavy machinery drivetrain', 'jcb 3d transmission spare',

      // SEO / keywords
      'crown wheel pinion jcb 3d', '13t 37t crown wheel pinion', 'jcb 3d drivetrain spare',
      'backhoe loader crown wheel pinion', 'OEM crown wheel pinion jcb 3d'
    ]
  },

  //asgp4002
  {
    id: 'ASGP-4002',
    name: 'JCB Pump Drive Shaft - 25mm',
    partNumber: 'ASGP-4002',
    machine: 'jcb',
    category: '4',
    price: 4200,
    images: [
      'v1759564582/asgp4002_ppfos2.webp'
    ],
    description: 'High-quality 25mm Pump Drive Shaft specifically designed for JCB 3D backhoe loaders. Ensures smooth power transmission to the hydraulic pump for efficient and reliable operation. Built to OEM specifications for durability and long service life under heavy-duty conditions.',
    specifications: {
      Type: 'Pump Drive Shaft',
      Application: 'JCB 3D Backhoe Loader',
      Diameter: '25mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Drive Shaft',
      'JCB 3D',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement',
      'Backhoe Loader'
    ],
    oeReference: ['914/60041'],
    compatibility: ['JCB 3D', 'JCB Backhoe Loader'],
    references: [
      // Product codes / variations
      'asgp-4002', 'ASGP-4002', 'asgp4002', 'ASGP4002',
      'pump drive shaft', '25mm pump drive shaft', 'jcb 3d pump shaft', 'hydraulic pump shaft',
      'drivetrain spare', 'transmission spare', 'replacement pump shaft',

      // OE codes and variations
      '914/60041', '91460041', '914-60041', 'JCB 914/60041', 'JCB 91460041', 'JCB 914-60041',

      // Equipment references
      'jcb 3d', 'jcb 3d backhoe loader', 'jcb 3d drivetrain', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'pump drive shaft replacement', 'drivetrain replacement', 'transmission replacement',
      'hydraulic pump drive shaft', 'jcb 3d transmission spare', 'jcb 3d pump shaft replacement',

      // SEO / keywords
      'jcb 3d pump drive shaft', '25mm pump drive shaft jcb 3d', 'hydraulic pump drive shaft for jcb 3d',
      'OEM pump drive shaft', 'heavy equipment drivetrain part', 'jcb 3d hydraulic pump shaft'
    ]
  },

  //asgp4003
  {
    id: 'ASGP-4003',
    name: 'JCB Pump Drive Shaft - 28mm',
    partNumber: 'ASGP-4003',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 4500, // adjust as needed
    images: [
      'v1759564582/asgp4002_ppfos2.webp'
    ],
    description: 'High-quality 28mm Pump Drive Shaft specifically designed for JCB 3D backhoe loaders. Ensures smooth power transmission to the hydraulic pump for efficient and reliable operation. Built to OEM specifications for durability and long service life under heavy-duty conditions.',
    specifications: {
      Type: 'Pump Drive Shaft',
      Application: 'JCB 3D Backhoe Loader',
      Diameter: '28mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Drive Shaft',
      'JCB 3D',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement',
      'Backhoe Loader'
    ],
    compatibility: ['JCB 3D', 'JCB Backhoe Loader'],
    references: [
      // Product codes / variations
      'asgp-4003', 'ASGP-4003', 'asgp4003', 'ASGP4003',
      'pump drive shaft', '28mm pump drive shaft', 'jcb 3d pump shaft', 'hydraulic pump shaft',
      'drivetrain spare', 'transmission spare', 'replacement pump shaft',

      // Equipment references
      'jcb 3d', 'jcb 3d backhoe loader', 'jcb 3d drivetrain', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'pump drive shaft replacement', 'drivetrain replacement', 'transmission replacement',
      'hydraulic pump drive shaft', 'jcb 3d transmission spare', 'jcb 3d pump shaft replacement',

      // SEO / keywords
      'jcb 3d pump drive shaft', '28mm pump drive shaft jcb 3d', 'hydraulic pump drive shaft for jcb 3d',
      'OEM pump drive shaft', 'heavy equipment drivetrain part', 'jcb 3d hydraulic pump shaft'
    ]
  },

  //asgp4004
  {
    id: 'ASGP-4004',
    name: 'JCB Planet Gear',
    partNumber: 'ASGP-4004',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 6800, // adjust as needed
    images: [
      'v1759564582/asgp4004_qnb4ru.webp'
    ],
    description: 'High-quality Planet Gear specifically designed for JCB 3DX backhoe loaders. Ensures precise rotation and smooth power transmission within the drivetrain. Built to OEM specifications for durability, long-lasting performance, and optimal compatibility.',
    specifications: {
      Type: 'Planet Gear',
      Application: 'JCB Backhoe Loader',
      Material: 'High-Strength Alloy Steel',
      Features: 'Precision Machined, OEM Fit, Durable, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Planet Gear',
      'JCB 3DX',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement',
      'Backhoe Loader'
    ],
    oeReference: ['450/10206'],
    compatibility: ['JCB Backhoe Loader'],
    references: [
      // Product codes / variations
      'asgp-4004', 'ASGP-4004', 'asgp4004', 'ASGP4004',
      'planet gear', 'jcb planet gear', 'drivetrain gear', 'transmission gear', 'replacement planet gear',

      // OE codes and variations
      '450/10206', '45010206', '450-10206', 'JCB 450/10206', 'JCB 45010206', 'JCB 450-10206',

      // Equipment references
      'jcb 3dx', 'jcb 3dx backhoe loader', 'backhoe loader', 'jcb 3dx drivetrain', 'heavy machinery',

      // Spares / keywords
      'planet gear replacement', 'drivetrain replacement', 'transmission replacement',
      'jcb 3dx drivetrain spare', 'jcb 3dx planet gear replacement',

      // SEO / keywords
      'jcb 3dx planet gear', 'planet gear for jcb 3dx', 'drivetrain gear jcb 3dx',
      'OEM planet gear', 'heavy equipment drivetrain part', 'jcb 3dx transmission gear'
    ]
  },

  //asgp4005
  {
    id: 'ASGP-4005',
    name: 'JCB Planet / Cylindrical Roller Bearing',
    partNumber: 'ASGP-4005',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 3200, // adjust as needed
    images: [
      'v1759564582/asgp4005_kzwzn0.webp'
    ],
    description: 'High-quality Planet / Cylindrical Roller Bearing designed for JCB 3D and 3DX backhoe loaders. Ensures smooth rotation, high load-carrying capacity, and durability in drivetrain and transmission systems. Manufactured to OEM specifications for reliable fit and long-lasting performance.',
    specifications: {
      Type: 'Planet / Cylindrical Roller Bearing',
      Application: 'JCB 3D / 3DX Backhoe Loader',
      Material: 'Hardened Alloy Steel',
      Features: 'High Load Capacity, Precision Engineered, OEM Fit, Durable and Reliable'
    },
    featured: true,
    tags: [
      'Planet Bearing',
      'Cylindrical Roller Bearing',
      'JCB 3D',
      'JCB 3DX',
      'Transmission Bearing',
      'Drivetrain Bearing',
      'OEM Replacement',
      'Heavy Duty',
      'Backhoe Loader'
    ],
    oeReference: ['907/50200'],
    compatibility: ['JCB Backhoe Loader'],
    references: [
      // Product codes / variations
      'asgp-4005', 'ASGP-4005', 'asgp4005', 'ASGP4005',
      'planet bearing', 'cylindrical roller bearing', 'planet roller bearing jcb',
      'drivetrain bearing', 'transmission bearing', 'roller bearing replacement',

      // OE references
      '907/50200', '90750200', '907-50200',

      // Equipment references
      'jcb 3d', 'jcb 3dx', 'jcb backhoe loader', 'jcb drivetrain bearing',
      'jcb transmission bearing',

      // SEO / keywords
      'jcb planet bearing', 'jcb cylindrical roller bearing',
      'jcb 907/50200 bearing', 'jcb drivetrain parts',
      'OEM roller bearing jcb', 'heavy machinery bearing'
    ]
  },

  //asgp4006
  {
    id: 'ASGP-4006',
    name: 'JCB Planet Circlip Lock Black',
    partNumber: 'ASGP-4006',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 250, // adjust as needed
    images: [
      'v1759564582/asgp4006_exyyjj.webp'
    ],
    description: 'High-quality Planet Circlip Lock (Black) designed for JCB backhoe loaders. Ensures secure locking of planetary gear components within the drivetrain assembly, preventing slippage and maintaining reliable transmission performance. Manufactured to OEM standards for durability and precise fit.',
    specifications: {
      Type: 'Planet Circlip Lock',
      Application: 'JCB Backhoe Loader',
      Material: 'Hardened Steel with Black Coating',
      Features: 'Corrosion Resistant, Precision Fit, Durable, OEM Quality'
    },
    featured: true,
    tags: [
      'Planet Circlip Lock',
      'Circlip Lock',
      'Planetary Circlip',
      'Drivetrain Part',
      'Transmission Part',
      'OEM Replacement',
      'Heavy Duty',
      'Backhoe Loader'
    ],
    oeReference: ['821/00209'],
    compatibility: ['JCB Backhoe Loader'],
    references: [
      // Product codes / variations
      'asgp-4006', 'ASGP-4006', 'asgp4006', 'ASGP4006',
      'planet circlip', 'planetary circlip', 'circlip lock',
      'planet circlip lock', 'gear circlip', 'locking circlip',
      'black circlip lock', 'jcb circlip lock', 'drivetrain circlip',

      // OE references
      '821/00209', '82100209', '821-00209',
      'jcb 821/00209', 'jcb part 821/00209',

      // JCB Backhoe Loader Models (all possible for SEO)
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx',

      // Generic Equipment Keywords
      'backhoe loader spare', 'jcb spare part', 'construction equipment spare',
      'heavy equipment part', 'drivetrain spare', 'transmission spare',
      'gearbox circlip', 'planetary gear circlip',

      // SEO Keywords
      'jcb planet circlip lock', 'jcb circlip 821/00209',
      'crown wheel circlip jcb', 'planetary gear circlip jcb',
      'replacement circlip jcb', 'OEM circlip jcb', 'aftermarket circlip jcb',
      'jcb spare parts india', 'jcb spare parts dealer',
      'buy jcb circlip online', 'jcb drivetrain circlip'
    ]
  },

  //asgp4007
  {
    id: 'ASGP-4007',
    name: 'JCB Planet Circlip Lock White',
    partNumber: 'ASGP-4007',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 300, // adjust as needed
    images: [
      'v1759564582/asgp4007_nq1oq6.webp'
    ],
    description: 'High-quality Planet Circlip Lock (White) designed for JCB backhoe loaders. Ensures secure locking of planetary gear assemblies in the drivetrain, offering durability and OEM-level fitment. Built with precision for reliable performance in heavy-duty applications.',
    specifications: {
      Type: 'Planet Circlip Lock',
      Application: 'JCB Backhoe Loaders',
      Color: 'White',
      Material: 'High-Strength Spring Steel',
      Features: 'Precision Machined, Durable, OEM Fit, Corrosion Resistant'
    },
    featured: true,
    tags: [
      'Planet Circlip',
      'Circlip Lock',
      'Planetary Gear Circlip',
      'JCB Circlip',
      'Transmission Spare',
      'Drivetrain Part',
      'OEM Replacement',
      'Backhoe Loader'
    ],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4007', 'ASGP-4007', 'asgp4007', 'ASGP4007',
      'planet circlip', 'planetary circlip', 'circlip lock',
      'planet circlip lock', 'gear circlip', 'locking circlip',
      'white circlip lock', 'jcb circlip lock', 'drivetrain circlip',

      // JCB Backhoe Loader Models (all major for SEO/search)
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx',

      // Generic Equipment Keywords
      'backhoe loader spare', 'jcb spare part', 'construction equipment spare',
      'heavy equipment part', 'drivetrain spare', 'transmission spare',
      'gearbox circlip', 'planetary gear circlip',

      // SEO Keywords
      'jcb planet circlip lock white', 'jcb circlip lock planetary gear',
      'jcb transmission circlip', 'crown wheel circlip jcb',
      'planetary gear circlip jcb', 'replacement circlip jcb',
      'OEM circlip jcb', 'aftermarket circlip jcb',
      'jcb spare parts india', 'jcb spare parts dealer',
      'buy jcb circlip online', 'jcb drivetrain circlip'
    ]
  },

  //asgp4008
  {
    id: 'ASGP-4008',
    name: 'JCB Sun Gear',
    partNumber: 'ASGP-4008',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 2500, // adjust as needed
    images: [
      'v1759564582/asgp4008_ou5bzt.webp'
    ],
    description: 'High-quality Sun Gear designed for JCB backhoe loaders. Provides smooth and efficient power transmission in the planetary gear system, ensuring reliability and durability under heavy-duty conditions. Manufactured to OEM specifications for perfect fit and long service life.',
    specifications: {
      Type: 'Sun Gear',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Alloy Steel',
      Features: 'Precision Machined, Heat Treated, Durable, OEM Fit'
    },
    featured: true,
    tags: [
      'Sun Gear',
      'JCB Planetary Gear',
      'Transmission Spare',
      'Drivetrain Part',
      'Heavy Duty',
      'OEM Replacement',
      'Backhoe Loader'
    ],
    oeReference: ['450/12403', '450/10210'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4008', 'ASGP-4008', 'asgp4008', 'ASGP4008',
      'sun gear', 'jcb sun gear', 'planetary gear',
      'jcb planetary gear', 'transmission gear', 'drivetrain gear',
      'replacement sun gear', 'gearbox sun gear',

      // OE references
      '450/12403', '45012403', '450-12403',
      '450/10210', '45010210', '450-10210',

      // JCB Backhoe Loader Models (all major for SEO/search)
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx',

      // Generic Equipment Keywords
      'backhoe loader spare', 'jcb spare part', 'construction equipment spare',
      'heavy equipment part', 'drivetrain spare', 'transmission spare',
      'planetary gear system', 'jcb gearbox part',

      // SEO Keywords
      'jcb planet gear 450/12403', 'jcb sun gear 450/10210',
      'jcb planetary gear replacement', 'oem sun gear jcb',
      'aftermarket sun gear jcb', 'jcb drivetrain gear',
      'jcb backhoe transmission gear', 'planetary gear jcb backhoe loader',
      'buy jcb sun gear online', 'jcb spare parts india'
    ]
  },

  //asgp4009
  {
    id: 'ASGP-4009',
    name: 'JCB Annulus Ring Black',
    partNumber: 'ASGP-4009',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 1800, // adjust as needed
    images: [
      'v1759564583/asgp4009_fvrybs.webp'
    ],
    description: 'High-quality Annulus Ring (Black) for JCB backhoe loaders. Designed for the planetary gear system to ensure proper engagement and reliable performance. Manufactured with precision and durable materials for long-lasting operation under heavy-duty conditions.',
    specifications: {
      Type: 'Annulus Ring',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Alloy Steel',
      Color: 'Black',
      Features: 'Precision Machined, Durable, OEM Fit, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Annulus Ring',
      'Transmission Spare',
      'Drivetrain Part',
      'OEM Replacement',
      'Heavy Duty',
      'Backhoe Loader'
    ],
    oeReference: ['450/10205'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4009', 'ASGP-4009', 'asgp4009', 'ASGP4009',
      'annulus ring', 'annulus ring black', 'planetary gear annulus',
      'jcb annulus ring', 'drivetrain annulus', 'transmission annulus',
      'replacement annulus ring', 'gearbox annulus ring',

      // OE reference
      '450/10205', '45010205', '450-10205',

      // JCB Backhoe Loader Models (all major for SEO/search)
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx',

      // Generic Equipment Keywords
      'backhoe loader spare', 'jcb spare part', 'construction equipment spare',
      'heavy equipment part', 'drivetrain spare', 'transmission spare',
      'planetary gear spare', 'gearbox annulus ring',

      // SEO Keywords
      'jcb annulus ring 450/10205', 'annulus ring jcb backhoe',
      'planetary gear annulus jcb', 'jcb drivetrain annulus',
      'OEM annulus ring jcb', 'replacement annulus ring jcb',
      'aftermarket annulus ring jcb', 'jcb spare parts india',
      'buy jcb annulus ring online'
    ]
  },

  //asgp4010
  {
    id: 'ASGP-4010',
    name: 'JCB Annulus Ring White',
    partNumber: 'ASGP-4010',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 1800, // adjust as needed
    images: [
      'v1759564582/asgp4010_dijxnc.webp'
    ],
    description: 'High-quality Annulus Ring (White) for JCB backhoe loaders. Designed for the planetary gear system to ensure proper engagement and reliable performance. Manufactured with precision and durable materials for long-lasting operation under heavy-duty conditions.',
    specifications: {
      Type: 'Annulus Ring',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Alloy Steel',
      Color: 'White',
      Features: 'Precision Machined, Durable, OEM Fit, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Annulus Ring',
      'Transmission Spare',
      'Drivetrain Part',
      'OEM Replacement',
      'Heavy Duty',
      'Backhoe Loader'
    ],
    oeReference: ['450/10205'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4010', 'ASGP-4010', 'asgp4010', 'ASGP4010',
      'annulus ring', 'annulus ring black', 'planetary gear annulus',
      'jcb annulus ring', 'drivetrain annulus', 'transmission annulus',
      'replacement annulus ring', 'gearbox annulus ring',

      // OE reference
      '450/10205', '45010205', '450-10205',

      // JCB Backhoe Loader Models (all major for SEO/search)
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx',

      // Generic Equipment Keywords
      'backhoe loader spare', 'jcb spare part', 'construction equipment spare',
      'heavy equipment part', 'drivetrain spare', 'transmission spare',
      'planetary gear spare', 'gearbox annulus ring',

      // SEO Keywords
      'jcb annulus ring 450/10205', 'annulus ring jcb backhoe',
      'planetary gear annulus jcb', 'jcb drivetrain annulus',
      'OEM annulus ring jcb', 'replacement annulus ring jcb',
      'aftermarket annulus ring jcb', 'jcb spare parts india',
      'buy jcb annulus ring online'
    ]
  },

  //asgp4011
  {
    id: 'ASGP-4011',
    name: 'JCB Annulus Carrier',
    partNumber: 'ASGP-4011',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 3200, // adjust as needed
    images: [
      'v1759564583/asgp4011_b6a1vb.webp'
    ],
    description: 'High-quality Annulus Carrier for JCB backhoe loaders. Designed for the planetary gear system to ensure smooth and reliable power transmission. Built from durable alloy steel for long-lasting performance under heavy-duty conditions.',
    specifications: {
      Type: 'Annulus Carrier',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Alloy Steel',
      Features: 'Precision Machined, Durable, OEM Fit, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Annulus Carrier',
      'Transmission Spare',
      'Drivetrain Part',
      'OEM Replacement',
      'Heavy Duty',
      'Backhoe Loader'
    ],
    oeReference: ['450/12702'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4011', 'ASGP-4011', 'asgp4011', 'ASGP4011',
      'annulus carrier', 'jcb annulus carrier', 'planetary gear carrier',
      'drivetrain spare', 'transmission spare', 'replacement annulus carrier',

      // OE reference
      '450/12702', '45012702', '450-12702',

      // JCB Backhoe Loader Models (all major for SEO/search)
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx',

      // Generic Equipment Keywords
      'backhoe loader spare', 'jcb spare part', 'construction equipment spare',
      'heavy equipment part', 'drivetrain spare', 'transmission spare',
      'planetary gear spare', 'gearbox carrier',

      // SEO Keywords
      'jcb annulus carrier 450/12702', 'annulus carrier jcb backhoe',
      'planetary gear carrier jcb', 'jcb drivetrain annulus carrier',
      'OEM annulus carrier jcb', 'replacement annulus carrier jcb',
      'aftermarket annulus carrier jcb', 'jcb spare parts india',
      'buy jcb annulus carrier online'
    ]
  },

  //asgp4012
  {
    id: 'ASGP-4012',
    name: 'JCB Planet Gear Assembly',
    partNumber: 'ASGP-4012',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 7200, // adjust as needed
    images: [
      'v1759564583/asgp4012_blwdsz.webp'
    ],
    description: 'High-quality Planet Gear with bearing fitted for JCB backhoe loaders. Designed for precise gear engagement and smooth power transmission within the planetary gear system. Manufactured from high-strength alloy steel for long-lasting durability and heavy-duty performance.',
    specifications: {
      Type: 'Planet Gear with Bearing',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Alloy Steel',
      Features: 'Precision Machined, Bearing Fitted, Durable, OEM Fit, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Planet Gear',
      'JCB Planet Gear Assembly',
      'Bearing Fitted',
      'Transmission Spare',
      'Drivetrain Part',
      'OEM Replacement',
      'Heavy Duty',
      'Backhoe Loader'
    ],
    oeReference: ['450/10206/AS'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4012', 'ASGP-4012', 'asgp4012', 'ASGP4012',
      'planet gear', 'planet gear with bearing', 'jcb planet gear', 'jcb planet gear with bearing',
      'drivetrain spare', 'transmission spare', 'replacement planet gear', 'planetary gear spare',

      // OE reference
      '450/10206/AS', '45010206AS', '450-10206-AS',

      // JCB Backhoe Loader Models (all major for SEO/search)
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx',

      // Generic Equipment Keywords
      'backhoe loader spare', 'jcb spare part', 'construction equipment spare',
      'heavy equipment part', 'drivetrain spare', 'transmission spare',
      'planetary gear replacement', 'gearbox spare',

      // SEO Keywords
      'jcb planet gear with bearing', 'planet gear jcb backhoe',
      'bearing fitted planet gear jcb', 'jcb drivetrain planet gear',
      'OEM planet gear jcb', 'replacement planet gear jcb',
      'aftermarket planet gear jcb', 'jcb spare parts india',
      'buy jcb planet gear online'
    ]
  },

  //asgp4013
  {
    id: 'ASGP-4013',
    name: 'JCB Annulus Ring Circlip',
    partNumber: 'ASGP-4013',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 1200, // adjust as needed
    images: [
      'v1759564585/asgp4013_xcblg2.webp'
    ],
    description: 'High-quality Annulus Ring Circlip for JCB backhoe loaders. Designed to secure planetary gear components within the drivetrain system, ensuring reliable and precise power transmission. Manufactured from durable steel for long-lasting performance under heavy-duty conditions.',
    specifications: {
      Type: 'Annulus Ring Circlip',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Steel',
      Features: 'Durable, OEM Fit, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Annulus Ring Circlip',
      'Ring Lock',
      'Transmission Spare',
      'Drivetrain Part',
      'OEM Replacement',
      'Heavy Duty',
      'Backhoe Loader'
    ],
    oeReference: ['821/00210'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4013', 'ASGP-4013', 'asgp4013', 'ASGP4013',
      'annulus ring circlip', 'jcb annulus circlip', 'planetary gear circlip',
      'drivetrain spare', 'transmission spare', 'replacement annulus circlip',

      // OE reference
      '821/00210', '82100210', '821-00210',

      // JCB Backhoe Loader Models (all major for SEO/search)
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx',

      // Generic Equipment Keywords
      'backhoe loader spare', 'jcb spare part', 'construction equipment spare',
      'heavy equipment part', 'drivetrain spare', 'transmission spare',
      'planetary gear circlip', 'gearbox circlip',

      // SEO Keywords
      'jcb annulus ring circlip', 'annulus circlip jcb backhoe',
      'planetary gear circlip jcb', 'jcb drivetrain circlip',
      'OEM annulus circlip jcb', 'replacement annulus circlip jcb',
      'aftermarket annulus circlip jcb', 'jcb spare parts india',
      'buy jcb annulus circlip online'
    ]
  },

  //asgp4014
  {
    id: 'ASGP-4014',
    name: 'JCB Planetary Hub - 5 Hole',
    partNumber: 'ASGP-4014',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 3800, // adjust as needed
    images: [
      'v1759564585/asgp4014_agdq2c.webp'
    ],
    description: 'High-quality Planetary Hub with 5-hole design for JCB backhoe loaders. Ensures secure attachment and precise alignment of planetary gear components for reliable drivetrain operation. Manufactured from durable alloy steel for heavy-duty performance and long service life.',
    specifications: {
      Type: 'Planetary Hub',
      Holes: '5-Hole',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Alloy Steel',
      Features: 'Durable, OEM Fit, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Planetary Hub',
      'JCB Backhoe Loader',
      'Transmission Part',
      'Drivetrain Part',
      'OEM Replacement'
    ],
    oeReference: ['450/10216'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4014', 'ASGP-4014', 'asgp4014', 'ASGP4014',
      'planetary hub', '5-hole planetary hub', 'jcb planetary hub',
      'drivetrain spare', 'transmission spare', 'replacement planetary hub',
      '450/10216', '45010216', '450-10216',
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx'
    ]
  },

  //asgp4015
  {
    id: 'ASGP-4015',
    name: 'JCB Planetary Hub - 10 Hole',
    partNumber: 'ASGP-4015',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 4200, // adjust as needed
    images: [
      'v1759564585/asgp4015_ozxpvw.webp'
    ],
    description: 'High-quality Planetary Hub with 10-hole design for JCB backhoe loaders. Provides secure attachment and precise alignment of planetary gear components for reliable drivetrain performance. Manufactured from durable alloy steel for heavy-duty operation and long service life.',
    specifications: {
      Type: 'Planetary Hub',
      Holes: '10-Hole',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Alloy Steel',
      Features: 'Durable, OEM Fit, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Planetary Hub',
      'JCB Backhoe Loader',
      'Transmission Part',
      'Drivetrain Part',
      'OEM Replacement'
    ],
    oeReference: ['458/M4231'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4015', 'ASGP-4015', 'asgp4015', 'ASGP4015',
      'planetary hub', '10-hole planetary hub', 'jcb planetary hub',
      'drivetrain spare', 'transmission spare', 'replacement planetary hub',
      '458/M4231', '458M4231', '458-M4231',
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx'
    ]
  },

  //asgp4016
  {
    id: 'ASGP-4016',
    name: 'JCB Differential Assembly',
    partNumber: 'ASGP-4016',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 18500, // adjust as needed
    images: [
      'v1759564586/asgp4016_zkgzcm.webp'
    ],
    description: 'High-quality Differential Assembly (Handi type) for JCB backhoe loaders. Ensures smooth torque distribution to the wheels for reliable operation under heavy-duty conditions. Manufactured from premium alloy steel for durability and long service life.',
    specifications: {
      Type: 'Differential Assembly',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Alloy Steel',
      Features: 'Durable, OEM Fit, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Differential Assembly',
      'JCB Backhoe Loader',
      'Drivetrain Part',
      'Transmission Part',
      'OEM Replacement'
    ],
    oeReference: ['450/10800'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4016', 'ASGP-4016', 'asgp4016', 'ASGP4016',
      'differential assembly', 'handi differential', 'jcb differential',
      'drivetrain spare', 'transmission spare', 'replacement differential',
      '450/10800', '45010800', '450-10800',
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx'
    ]
  },

  //asgp4017
  {
    id: 'ASGP-4017',
    name: 'JCB Pump Drive Shaft',
    partNumber: 'ASGP-4017',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 5200, // adjust as needed
    images: [
      'v1759564589/asgp4017-1_yyqq3m.webp',
      'v1759564586/asgp4017-2_mgy3rk.webp'
    ],
    description: 'High-quality Pump Drive Shaft for JCB backhoe loaders. Ensures smooth transmission of power to the hydraulic pump for reliable and efficient operation. Manufactured from high-strength alloy steel for durability and long service life under heavy-duty conditions.',
    specifications: {
      Type: 'Pump Drive Shaft',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Alloy Steel',
      Features: 'Durable, OEM Fit, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Drive Shaft',
      'JCB Backhoe Loader',
      'Drivetrain Part',
      'Transmission Part',
      'Hydraulic Pump',
      'OEM Replacement'
    ],
    oeReference: ['459/50431'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4017', 'ASGP-4017', 'asgp4017', 'ASGP4017',
      'pump drive shaft', 'jcb pump shaft', 'hydraulic pump drive shaft',
      'drivetrain spare', 'transmission spare', 'replacement pump shaft',
      '459/50431', '45950431', '459-50431',
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx'
    ]
  },

  //asgp4018
  {
    id: 'ASGP-4018',
    name: 'JCB Rear Axle Shaft',
    partNumber: 'ASGP-4018',
    machine: 'jcb',
    category: '4', // Category 4 for drivetrain / transmission parts
    price: 7800, // adjust as needed
    images: [
      'v1759564590/asgp4018_snfbw6.webp'
    ],
    description: 'High-quality Rear Axle Shaft for JCB backhoe loaders. Ensures reliable power transmission to the wheels, smooth operation, and long-lasting durability. Manufactured from premium alloy steel for heavy-duty performance and OEM fit.',
    specifications: {
      Type: 'Rear Axle Shaft',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Alloy Steel',
      Features: 'Durable, OEM Fit, Heavy-Duty, Precision Machined'
    },
    featured: true,
    tags: [
      'Rear Axle Shaft',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'OEM Replacement'
    ],
    oeReference: ['450/10209'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4018', 'ASGP-4018', 'asgp4018', 'ASGP4018',
      'rear axle shaft', 'jcb rear axle', 'axle shaft', 'drivetrain spare', 'transmission spare', 'replacement rear axle shaft',
      '450/10209', '45010209', '450-10209',
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx'
    ]
  },

  //asgp4019
  {
    id: 'ASGP-4019',
    name: 'JCB Bevel Gear Kit',
    partNumber: 'ASGP-4019',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 12500, // adjust as needed
    images: [
      'asgp4019_i8ntlz.webp',
      'asgp4019-2_kc3evf.webp'
    ],
    description: 'High-quality Bevel Gear Kit for JCB backhoe loaders. Ensures smooth and precise power transmission within the differential assembly. Manufactured to OEM specifications for durability, precision, and heavy-duty performance.',
    specifications: {
      Type: 'Differential Gear Kit',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Alloy Steel',
      Features: 'Durable, OEM Fit, Precision Machined, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Differential Gear Kit',
      'Bevel Gear',
      'Star Gear',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'OEM Replacement'
    ],
    oeReference: ['450/11000'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4019', 'ASGP-4019', 'asgp4019', 'ASGP4019',
      'differential gear kit', 'bevel gear', 'star gear', 'jcb differential', 'drivetrain spare', 'transmission spare', 'replacement differential gear kit',
      '450/11000', '45011000', '450-11000',
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx'
    ]
  },

  //asgp4020
  {
    id: 'ASGP-4020',
    name: 'JCB Bevel Pins',
    partNumber: 'ASGP-4020',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 3800, // adjust as needed
    images: [
      'v1759569558/asgp4020_ud6teh.webp'
    ],
    description: 'High-quality Bevel Pins for JCB backhoe loaders. Precision machined to ensure proper engagement within the differential and bevel gear assemblies. Manufactured from durable alloy steel for long-lasting performance under heavy-duty conditions.',
    specifications: {
      Type: 'Bevel Pins',
      Application: 'JCB Backhoe Loaders',
      Material: 'High-Strength Alloy Steel',
      Features: 'Durable, Precision Machined, OEM Fit, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Bevel Pins',
      'JCB Backhoe Loader',
      'Differential Spare',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4020', 'ASGP-4020', 'asgp4020', 'ASGP4020',
      'bevel pins', 'jcb bevel pins', 'differential pins', 'drivetrain spare', 'transmission spare', 'replacement bevel pins',
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx'
    ]
  },

  //asgp4021
  {
    id: 'ASGP-4021',
    name: 'JCB Bevel Washers - 0.8mm Copper',
    partNumber: 'ASGP-4021',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 650, // adjust as needed
    images: [
      'asgp4021_f1qaak.webp',
      'asgp4021-2_l6egw3.webp'
    ],
    description: 'High-quality 0.8mm copper washers for Bevel Gear Kits, designed for JCB backhoe loaders. Ensures proper spacing, alignment, and smooth operation of bevel gears in the drivetrain. Made from durable copper for corrosion resistance and long-lasting performance.',
    specifications: {
      Type: 'Bevel Gear Kit Washers',
      Material: 'Copper',
      Thickness: '0.8mm',
      Application: 'JCB Backhoe Loaders',
      Features: 'Durable, Corrosion Resistant, OEM Fit, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Bevel Gear Washers',
      '0.8mm Copper',
      'JCB Backhoe Loader',
      'Differential Spare',
      'Drivetrain',
      'Transmission',
      'OEM Replacement'
    ],
    oeReference: [], // No OE number
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4021', 'ASGP-4021', 'asgp4021', 'ASGP4021',
      'bevel gear washers', '0.8mm copper washers', 'jcb bevel gear washers',
      'differential washers', 'drivetrain spare', 'transmission spare', 'replacement washers',
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx'
    ]
  },

  //asgp4022
  {
    id: 'ASGP-4022',
    name: 'JCB Bevel Washers - 1mm Copper',
    partNumber: 'ASGP-4022',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 700, // adjust as needed
    images: [
      'asgp4021_f1qaak.webp',
      'asgp4021-2_l6egw3.webp'
    ],
    description: 'High-quality 1mm copper washers for Bevel Gear Kits, designed for JCB backhoe loaders. Provides precise spacing, alignment, and smooth operation of bevel gears in the drivetrain. Made from durable copper for corrosion resistance and long-lasting performance.',
    specifications: {
      Type: 'Bevel Gear Washers',
      Material: 'Copper',
      Thickness: '1mm',
      Application: 'JCB Backhoe Loaders',
      Features: 'Durable, Corrosion Resistant, OEM Fit, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Bevel Gear Washers',
      '1mm Copper',
      'JCB Backhoe Loader',
      'Differential Spare',
      'Drivetrain',
      'Transmission',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4022', 'ASGP-4022', 'asgp4022', 'ASGP4022',
      'bevel gear washers', '1mm copper washers', 'jcb bevel gear washers',
      'differential washers', 'drivetrain spare', 'transmission spare', 'replacement washers',
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx'
    ]
  },

  //asgp4023
  {
    id: 'ASGP-4023',
    name: 'JCB Bevel Washers - 1mm Bronze',
    partNumber: 'ASGP-4023',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 750, // adjust as needed
    images: [
      'asgp4021_f1qaak.webp',
      'asgp4021-2_l6egw3.webp'
    ],
    description: 'High-quality 1mm bronze washers for Bevel Gear Kits, designed for JCB backhoe loaders. Provides precise spacing, alignment, and smooth operation of bevel gears in the drivetrain. Made from durable bronze for corrosion resistance and long-lasting performance.',
    specifications: {
      Type: 'Bevel Gear Kit Washers',
      Material: 'Bronze',
      Thickness: '1mm',
      Application: 'JCB Backhoe Loaders',
      Features: 'Durable, Corrosion Resistant, OEM Fit, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Bevel Gear Washers',
      '1mm Bronze',
      'JCB Backhoe Loader',
      'Differential Spare',
      'Drivetrain',
      'Transmission',
      'OEM Replacement'
    ],
    oeReference: [], // No OE number
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4023', 'ASGP-4023', 'asgp4023', 'ASGP4023',
      'bevel gear washers', '1mm bronze washers', 'jcb bevel gear washers',
      'differential washers', 'drivetrain spare', 'transmission spare', 'replacement washers',
      'jcb backhoe loader',
      'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx',
      'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx'
    ]
  },

  //asgp4024
  {
    id: 'ASGP-4024',
    name: 'JCB Crown Wheel & Pinion - 11T/37T',
    partNumber: 'ASGP-4024',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 7800, // adjust as needed
    images: [
      'asgp4024_cxgjh7.webp'
    ],
    description: 'High-quality Crown Wheel & Pinion set (11T/37T) designed for JCB backhoe loaders. Ensures precise gear engagement and reliable power transmission for heavy-duty operations. Built to OEM specifications for long-lasting durability and efficient drivetrain performance.',
    specifications: {
      Type: 'Crown Wheel & Pinion Set',
      Application: 'JCB Backhoe Loader',
      Teeth: '11T Pinion / 37T Crown Wheel',
      Material: 'High-Strength Alloy Steel',
      Features: 'Precision Machined, OEM Fit, Durable, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Crown Wheel & Pinion',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: ['458/20672'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4024', 'ASGP-4024', 'asgp4024', 'ASGP4024',
      'crown wheel', 'pinion', 'crown wheel & pinion', '11t crown wheel', '37t pinion',
      'crown wheel pinion set', 'drivetrain spare', 'transmission spare', 'replacement crown wheel', 'replacement pinion',

      // OE
      '458/20672', '45820672', '458-20672',

      // Equipment references
      'jcb backhoe loader', 'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3c', 'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4c', 'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx', 'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx',

      // Spares / keywords
      'crown wheel pinion replacement', 'drivetrain replacement', 'transmission replacement',
      'heavy machinery drivetrain', 'jcb transmission spare',

      // SEO / keywords
      'crown wheel pinion jcb', '11t 37t crown wheel pinion', 'jcb drivetrain spare',
      'backhoe loader crown wheel pinion', 'OEM crown wheel pinion jcb'
    ]
  },

  //asgp4025
  {
    id: 'ASGP-4025',
    name: 'JCB Crown Wheel & Pinion - 13T/38T',
    partNumber: 'ASGP-4025',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 8000, // adjust as needed
    images: [
      'asgp4025_np3bvw.webp'
    ],
    description: 'High-quality Crown Wheel & Pinion set (13T/38T) designed for JCB backhoe loaders. Ensures precise gear engagement and reliable power transmission for heavy-duty operations. Built to OEM specifications for long-lasting durability and efficient drivetrain performance.',
    specifications: {
      Type: 'Crown Wheel & Pinion Set',
      Application: 'JCB Backhoe Loader',
      Teeth: '13T Pinion / 38T Crown Wheel',
      Material: 'High-Strength Alloy Steel',
      Features: 'Precision Machined, OEM Fit, Durable, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Crown Wheel & Pinion',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: ['458/70258', '458/70037'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4025', 'ASGP-4025', 'asgp4025', 'ASGP4025',
      'crown wheel', 'pinion', 'crown wheel & pinion', '13t crown wheel', '38t pinion',
      'crown wheel pinion set', 'drivetrain spare', 'transmission spare', 'replacement crown wheel', 'replacement pinion',

      // OE
      '458/70258', '45870258', '458-70258',

      // Equipment references (all JCB backhoes)
      'jcb backhoe loader', 'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3c', 'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4c', 'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx', 'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx',

      // Spares / keywords
      'crown wheel pinion replacement', 'drivetrain replacement', 'transmission replacement',
      'heavy machinery drivetrain', 'jcb transmission spare',

      // SEO / keywords
      'crown wheel pinion jcb', '13t 38t crown wheel pinion', 'jcb drivetrain spare',
      'backhoe loader crown wheel pinion', 'OEM crown wheel pinion jcb'
    ]
  },

  //asgp4026
  {
    id: 'ASGP-4026',
    name: 'JCB Crown Wheel & Pinion - 13T/33T',
    partNumber: 'ASGP-4026',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 7800, // adjust as needed
    images: [
      'v1759580848/asgp4026_rl4ubn.webp'
    ],
    description: 'High-quality Crown Wheel & Pinion set (13T/33T) designed for JCB backhoe loaders. Ensures precise gear engagement and reliable power transmission for heavy-duty operations. Built to OEM specifications for long-lasting durability and efficient drivetrain performance.',
    specifications: {
      Type: 'Crown Wheel & Pinion Set',
      Application: 'JCB Backhoe Loader',
      Teeth: '13T Pinion / 33T Crown Wheel',
      Material: 'High-Strength Alloy Steel',
      Features: 'Precision Machined, OEM Fit, Durable, Heavy-Duty Performance'
    },
    featured: true,
    tags: [
      'Crown Wheel & Pinion',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: ['458/70260', '458/70246'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4026', 'ASGP-4026', 'asgp4026', 'ASGP4026',
      'crown wheel', 'pinion', 'crown wheel & pinion', '13t crown wheel', '33t pinion',
      'crown wheel pinion set', 'drivetrain spare', 'transmission spare', 'replacement crown wheel', 'replacement pinion',

      // OE
      '458/70260', '45870260', '458-70260',

      // Equipment references (all JCB backhoes)
      'jcb backhoe loader', 'jcb 1cx', 'jcb 1cxt',
      'jcb 2d', 'jcb 2dx',
      'jcb 3d', 'jcb 3dx', 'jcb 3dx super',
      'jcb 3c', 'jcb 3cx', 'jcb 3cx plus', 'jcb 3cx pro', 'jcb 3cx super', 'jcb 3cx compact',
      'jcb 4d', 'jcb 4dx',
      'jcb 4c', 'jcb 4cx', 'jcb 4cx plus', 'jcb 4cx pro', 'jcb 4cx super',
      'jcb 5cx', 'jcb sitemaster 3cx', 'jcb sitemaster 4cx', 'jcb sitemaster 5cx',

      // Spares / keywords
      'crown wheel pinion replacement', 'drivetrain replacement', 'transmission replacement',
      'heavy machinery drivetrain', 'jcb transmission spare',

      // SEO / keywords
      'crown wheel pinion jcb', '13t 33t crown wheel pinion', 'jcb drivetrain spare',
      'backhoe loader crown wheel pinion', 'OEM crown wheel pinion jcb'
    ]
  },

  //asgp4027
  {
    id: 'ASGP-4027',
    name: 'JCB Pump Shaft - 25.3mm',
    partNumber: 'ASGP-4027',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 4500, // adjust as needed
    images: [
      'v1759581252/asgp4027_q95pjx.webp'
    ],
    description: 'High-quality 25.3mm Pump Shaft designed for JCB backhoe loaders. Ensures smooth power transmission to hydraulic pumps for efficient and reliable operation. Built to OEM specifications for durability and long service life under heavy-duty conditions.',
    specifications: {
      Type: 'Pump Shaft',
      Application: 'JCB Backhoe Loader',
      Diameter: '25.3mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Shaft',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4027', 'ASGP-4027', 'asgp4027', 'ASGP4027',
      'pump shaft', '25.3mm pump shaft', 'jcb pump shaft', 'hydraulic pump shaft',
      'drivetrain spare', 'transmission spare', 'replacement pump shaft',

      // Equipment references
      'jcb backhoe loader', 'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx',
      'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',

      // Generic spares / keyword searches
      'jcb spare parts', 'jcb backhoe spare', 'backhoe loader spare', 'hydraulic spare',
      'jcb hydraulic pump shaft', 'heavy machinery spare', 'heavy equipment shaft',

      // SEO / keywords
      'jcb pump shaft 25.3mm', '25.3mm hydraulic pump shaft jcb', 'OEM jcb pump shaft',
      'drivetrain shaft for jcb backhoe', 'replacement pump shaft jcb', 'heavy equipment drivetrain shaft'
    ]
  },

  //asgp4028
  {
    id: 'ASGP-4028',
    name: 'JCB Pump Shaft - 32mm',
    partNumber: 'ASGP-4028',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 4800, // adjust as needed
    images: [
      'v1759581252/asgp4027_q95pjx.webp'
    ],
    description: 'High-quality 32mm Pump Shaft designed for JCB backhoe loaders. Ensures smooth power transmission to hydraulic pumps for efficient and reliable operation. Built to OEM specifications for durability and long service life under heavy-duty conditions.',
    specifications: {
      Type: 'Pump Shaft',
      Application: 'JCB Backhoe Loader',
      Diameter: '32mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Shaft',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4028', 'ASGP-4028', 'asgp4028', 'ASGP4028',
      'pump shaft', '32mm pump shaft', 'jcb pump shaft', 'hydraulic pump shaft',
      'drivetrain spare', 'transmission spare', 'replacement pump shaft',

      // Equipment references
      'jcb backhoe loader', 'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx',
      'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',

      // Generic spares / keyword searches
      'jcb spare parts', 'jcb backhoe spare', 'backhoe loader spare', 'hydraulic spare',
      'jcb hydraulic pump shaft', 'heavy machinery spare', 'heavy equipment shaft',

      // SEO / keywords
      'jcb pump shaft 32mm', '32mm hydraulic pump shaft jcb', 'OEM jcb pump shaft',
      'drivetrain shaft for jcb backhoe', 'replacement pump shaft jcb', 'heavy equipment drivetrain shaft'
    ]
  },

  //asgp4029
  {
    id: 'ASGP-4029',
    name: 'JCB Pump Shaft - 36.5mm',
    partNumber: 'ASGP-4029',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 5200, // adjust as needed
    images: [
      'v1759581252/asgp4027_q95pjx.webp'
    ],
    description: 'High-quality 36.5mm Pump Shaft designed for JCB backhoe loaders. Ensures smooth power transmission to hydraulic pumps for efficient and reliable operation. Built to OEM specifications for durability and long service life under heavy-duty conditions.',
    specifications: {
      Type: 'Pump Shaft',
      Application: 'JCB Backhoe Loader',
      Diameter: '36.5mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Shaft',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4029', 'ASGP-4029', 'asgp4029', 'ASGP4029',
      'pump shaft', '36.5mm pump shaft', 'jcb pump shaft', 'hydraulic pump shaft',
      'drivetrain spare', 'transmission spare', 'replacement pump shaft',

      // Equipment references
      'jcb backhoe loader', 'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx',
      'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',

      // Generic spares / keyword searches
      'jcb spare parts', 'jcb backhoe spare', 'backhoe loader spare', 'hydraulic spare',
      'jcb hydraulic pump shaft', 'heavy machinery spare', 'heavy equipment shaft',

      // SEO / keywords
      'jcb pump shaft 36.5mm', '36.5mm hydraulic pump shaft jcb', 'OEM jcb pump shaft',
      'drivetrain shaft for jcb backhoe', 'replacement pump shaft jcb', 'heavy equipment drivetrain shaft'
    ]
  },

  //asgp4030
  {
    id: 'ASGP-4030',
    name: 'JCB Pump Shaft - 40.6mm',
    partNumber: 'ASGP-4030',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 5400, // adjust as needed
    images: [
      'v1759581252/asgp4027_q95pjx.webp'
    ],
    description: 'High-quality 40.6mm Pump Shaft designed for JCB backhoe loaders. Ensures smooth power transmission to hydraulic pumps for reliable operation. Built to OEM specifications for durability and long service life under heavy-duty conditions.',
    specifications: {
      Type: 'Pump Shaft',
      Application: 'JCB Backhoe Loader',
      Diameter: '40.6mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Shaft',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4030', 'ASGP-4030', 'asgp4030', 'ASGP4030',
      'pump shaft', '40.6mm pump shaft', 'jcb pump shaft', 'hydraulic pump shaft',
      'drivetrain spare', 'transmission spare', 'replacement pump shaft',

      // Equipment references
      'jcb backhoe loader', 'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx',
      'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',

      // Generic spares / keyword searches
      'jcb spare parts', 'jcb backhoe spare', 'backhoe loader spare', 'hydraulic spare',
      'jcb hydraulic pump shaft', 'heavy machinery spare', 'heavy equipment shaft',

      // SEO / keywords
      'jcb pump shaft 40.6mm', '40.6mm hydraulic pump shaft jcb', 'OEM jcb pump shaft',
      'drivetrain shaft for jcb backhoe', 'replacement pump shaft jcb', 'heavy equipment drivetrain shaft'
    ]
  },

  //asgp4031
  {
    id: 'ASGP-4031',
    name: 'JCB Pump Gear - 25.3mm Open',
    partNumber: 'ASGP-4031',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 4600, // adjust as needed
    images: [
      'asgp4031_bp1m4v.webp'
    ],
    description: 'High-quality 25.3mm Open Pump Gear designed for JCB backhoe loaders. Ensures precise transmission of hydraulic power and smooth operation. Built to OEM specifications for durability and long-lasting performance in heavy-duty conditions.',
    specifications: {
      Type: 'Pump Gear',
      Application: 'JCB Backhoe Loader',
      Diameter: '25.3mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Gear',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4031', 'ASGP-4031', 'asgp4031', 'ASGP4031',
      'pump gear', '25.3mm pump gear', 'jcb pump gear', 'hydraulic pump gear',
      'drivetrain spare', 'transmission spare', 'replacement pump gear',

      // Equipment references
      'jcb backhoe loader', 'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx',
      'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',

      // Generic spares / keyword searches
      'jcb spare parts', 'jcb backhoe spare', 'backhoe loader spare', 'hydraulic spare',
      'jcb hydraulic pump gear', 'heavy machinery spare', 'heavy equipment gear',

      // SEO / keywords
      'jcb pump gear 25.3mm', '25.3mm hydraulic pump gear jcb', 'OEM jcb pump gear',
      'drivetrain gear for jcb backhoe', 'replacement pump gear jcb', 'heavy equipment drivetrain gear'
    ]
  },

  //asgp4032
  {
    id: 'ASGP-4032',
    name: 'JCB Pump Gear - 25.3mm Close',
    partNumber: 'ASGP-4032',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 4600, // adjust as needed
    images: [
      'asgp4032_iwtu56.webp'
    ],
    description: 'High-quality 25.3mm Close Pump Gear designed for JCB backhoe loaders. Provides reliable hydraulic power transmission and smooth operation under heavy-duty conditions. Built to OEM specifications for long-lasting durability.',
    specifications: {
      Type: 'Pump Gear',
      Application: 'JCB Backhoe Loader',
      Diameter: '25.3mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Gear',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4032', 'ASGP-4032', 'asgp4032', 'ASGP4032',
      'pump gear', '25.3mm pump gear', 'jcb pump gear', 'hydraulic pump gear',
      'drivetrain spare', 'transmission spare', 'replacement pump gear',

      // Equipment references
      'jcb backhoe loader', 'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx',
      'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',

      // Generic spares / keyword searches
      'jcb spare parts', 'jcb backhoe spare', 'backhoe loader spare', 'hydraulic spare',
      'jcb hydraulic pump gear', 'heavy machinery spare', 'heavy equipment gear',

      // SEO / keywords
      'jcb pump gear 25.3mm', '25.3mm hydraulic pump gear jcb', 'OEM jcb pump gear',
      'drivetrain gear for jcb backhoe', 'replacement pump gear jcb', 'heavy equipment drivetrain gear'
    ]
  },

  //asgp4033
  {
    id: 'ASGP-4033',
    name: 'JCB Pump Gear - 32mm Open',
    partNumber: 'ASGP-4033',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 4800, // adjust as needed
    images: [
      'asgp4031_bp1m4v.webp'
    ],
    description: 'High-quality 32mm Open Pump Gear designed for JCB backhoe loaders. Ensures efficient hydraulic power transmission and smooth operation under heavy-duty conditions. Built to OEM specifications for durability and long service life.',
    specifications: {
      Type: 'Pump Gear',
      Application: 'JCB Backhoe Loader',
      Diameter: '32mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Gear',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4033', 'ASGP-4033', 'asgp4033', 'ASGP4033',
      'pump gear', '32mm pump gear', 'jcb pump gear', 'hydraulic pump gear',
      'drivetrain spare', 'transmission spare', 'replacement pump gear',
      'jcb backhoe loader', 'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx',
      'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',
      'jcb spare parts', 'jcb backhoe spare', 'backhoe loader spare', 'hydraulic spare',
      'jcb hydraulic pump gear', 'heavy machinery spare', 'heavy equipment gear',
      'jcb pump gear 32mm', '32mm hydraulic pump gear jcb', 'OEM jcb pump gear',
      'drivetrain gear for jcb backhoe', 'replacement pump gear jcb', 'heavy equipment drivetrain gear'
    ]
  },

  //asgp4034
  {
    id: 'ASGP-4034',
    name: 'JCB Pump Gear - 32mm Close',
    partNumber: 'ASGP-4034',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 4800, // adjust as needed
    images: [
      'asgp4032_iwtu56.webp'
    ],
    description: 'High-quality 32mm Close Pump Gear designed for JCB backhoe loaders. Ensures efficient hydraulic power transmission and smooth operation under heavy-duty conditions. Built to OEM specifications for durability and long service life.',
    specifications: {
      Type: 'Pump Gear',
      Application: 'JCB Backhoe Loader',
      Diameter: '32mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Gear',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4034', 'ASGP-4034', 'asgp4034', 'ASGP4034',
      'pump gear', '32mm pump gear', 'jcb pump gear', 'hydraulic pump gear',
      'drivetrain spare', 'transmission spare', 'replacement pump gear',
      'jcb backhoe loader', 'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx',
      'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',
      'jcb spare parts', 'jcb backhoe spare', 'backhoe loader spare', 'hydraulic spare',
      'jcb hydraulic pump gear', 'heavy machinery spare', 'heavy equipment gear',
      'jcb pump gear 32mm', '32mm hydraulic pump gear jcb', 'OEM jcb pump gear',
      'drivetrain gear for jcb backhoe', 'replacement pump gear jcb', 'heavy equipment drivetrain gear'
    ]
  },

  //asgp4035
  {
    id: 'ASGP-4035',
    name: 'JCB Pump Gear - 36.5mm Open',
    partNumber: 'ASGP-4035',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 5000, // adjust as needed
    images: [
      'asgp4031_bp1m4v.webp'
    ],
    description: 'High-quality 36.5mm Open Pump Gear designed for JCB backhoe loaders. Ensures efficient hydraulic power transmission and smooth operation under heavy-duty conditions. Built to OEM specifications for durability and long service life.',
    specifications: {
      Type: 'Pump Gear',
      Application: 'JCB Backhoe Loader',
      Diameter: '36.5mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Gear',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4035', 'ASGP-4035', 'asgp4035', 'ASGP4035',
      'pump gear', '36.5mm pump gear', 'jcb pump gear', 'hydraulic pump gear',
      'drivetrain spare', 'transmission spare', 'replacement pump gear',
      'jcb backhoe loader', 'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx',
      'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',
      'jcb spare parts', 'jcb backhoe spare', 'backhoe loader spare', 'hydraulic spare',
      'jcb hydraulic pump gear', 'heavy machinery spare', 'heavy equipment gear',
      'jcb pump gear 36.5mm', '36.5mm hydraulic pump gear jcb', 'OEM jcb pump gear',
      'drivetrain gear for jcb backhoe', 'replacement pump gear jcb', 'heavy equipment drivetrain gear'
    ]
  },

  //asgp4036
  {
    id: 'ASGP-4036',
    name: 'JCB Pump Gear - 36.5mm Close',
    partNumber: 'ASGP-4036',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 4800, // adjust as needed
    images: [
      'asgp4032_iwtu56.webp'
    ],
    description: 'High-quality 36.5mm Close Pump Gear designed for JCB backhoe loaders. Ensures efficient hydraulic power transmission and smooth operation under heavy-duty conditions. Built to OEM specifications for durability and long service life.',
    specifications: {
      Type: 'Pump Gear',
      Application: 'JCB Backhoe Loader',
      Diameter: '36.5mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Gear',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      'asgp-4036', 'ASGP-4036', 'asgp4036', 'ASGP4036',
      'pump gear', '36.5mm pump gear', 'jcb pump gear', 'hydraulic pump gear',
      'drivetrain spare', 'transmission spare', 'replacement pump gear',
      'jcb backhoe loader', 'jcb 2d', 'jcb 2dx', 'jcb 3d', 'jcb 3dx', 'jcb 3c', 'jcb 3cx',
      'jcb 4d', 'jcb 4dx', 'jcb 4c', 'jcb 4cx',
      'jcb spare parts', 'jcb backhoe spare', 'backhoe loader spare', 'hydraulic spare',
      'jcb hydraulic pump gear', 'heavy machinery spare', 'heavy equipment gear',
      'jcb pump gear 36.5mm', '36.5mm hydraulic pump gear jcb', 'OEM jcb pump gear',
      'drivetrain gear for jcb backhoe', 'replacement pump gear jcb', 'heavy equipment drivetrain gear'
    ]
  },

  //asgp4037
  {
    id: 'ASGP-4037',
    name: 'JCB Pump Gear - 40.6mm Open',
    partNumber: 'ASGP-4037',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 5200, // adjust as needed
    images: [
      'asgp4031_bp1m4v.webp'
    ],
    description: 'High-quality 40.6mm Open Pump Gear designed for JCB backhoe loaders. Ensures efficient hydraulic power transmission and smooth operation under heavy-duty conditions. Built to OEM specifications for durability and long service life.',
    specifications: {
      Type: 'Pump Gear',
      Application: 'JCB Backhoe Loader',
      Diameter: '40.6mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Gear',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4037', 'ASGP-4037', 'asgp4037', 'ASGP4037',
      'pump gear', 'pump gear 40.6mm', 'jcb pump gear', 'hydraulic pump gear',
      'drivetrain spare', 'transmission spare', 'replacement pump gear',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'hydraulic pump',

      // Spares / keywords
      'pump gear replacement', 'drivetrain replacement', 'transmission replacement',
      'heavy machinery drivetrain', 'jcb transmission spare',

      // SEO / keywords
      'jcb pump gear 40.6mm', 'pump gear for jcb backhoe', 'hydraulic pump gear jcb',
      'OEM pump gear jcb', 'heavy equipment pump gear'
    ]
  },

  //asgp4038
  {
    id: 'ASGP-4038',
    name: 'JCB Pump Gear - 40.6mm Close',
    partNumber: 'ASGP-4038',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 5200, // adjust as needed
    images: [
      'asgp4032_iwtu56.webp'
    ],
    description: 'High-quality 40.6mm Close Pump Gear designed for JCB backhoe loaders. Ensures smooth hydraulic power transmission and reliable operation under heavy-duty conditions. Built to OEM specifications for durability and long service life.',
    specifications: {
      Type: 'Pump Gear',
      Application: 'JCB Backhoe Loader',
      Diameter: '40.6mm',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Pump Gear',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: [],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4038', 'ASGP-4038', 'asgp4038', 'ASGP4038',
      'pump gear', 'pump gear 40.6mm', 'jcb pump gear', 'hydraulic pump gear',
      'drivetrain spare', 'transmission spare', 'replacement pump gear',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'hydraulic pump',

      // Spares / keywords
      'pump gear replacement', 'drivetrain replacement', 'transmission replacement',
      'heavy machinery drivetrain', 'jcb transmission spare',

      // SEO / keywords
      'jcb pump gear 40.6mm', 'pump gear for jcb backhoe', 'hydraulic pump gear jcb',
      'OEM pump gear jcb', 'heavy equipment pump gear'
    ]
  },

  //asgp4039
  {
    id: 'ASGP-4039',
    name: 'JCB Rear Propeller Shaft',
    partNumber: 'ASGP-4039',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 7800, // adjust as needed
    images: [
      'asgp4039_wycvgn.webp',
      'asgp4039-2_pei9cm.webp'
    ],
    description: 'High-quality Rear Propeller Shaft designed for JCB backhoe loaders. Provides reliable torque transmission between the gearbox and rear axle, ensuring smooth operation under heavy-duty conditions. Built to OEM specifications for long-lasting durability and optimal performance.',
    specifications: {
      Type: 'Rear Propeller Shaft',
      Application: 'JCB Backhoe Loader',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    featured: true,
    tags: [
      'Rear Propeller Shaft',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    oeReference: ['914/60265'],
    compatibility: [
      'JCB Backhoe Loaders'
    ],
    references: [
      // Product codes / variations
      'asgp-4039', 'ASGP-4039', 'asgp4039', 'ASGP4039',
      'rear propeller shaft', 'jcb rear propeller shaft', 'rear driveshaft', 'jcb driveshaft',
      'drivetrain spare', 'transmission spare', 'replacement propeller shaft',

      // OE
      '914/60265', '91460265', '914-60265',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'rear propeller shaft replacement', 'drivetrain replacement', 'transmission replacement',
      'heavy machinery drivetrain', 'jcb transmission spare',

      // SEO / keywords
      'jcb rear propeller shaft', 'propeller shaft jcb backhoe', 'rear driveshaft for jcb',
      'OEM rear propeller shaft', 'heavy equipment drivetrain part'
    ]
  },

  //asgp4040
  {
    id: 'ASGP-4040',
    name: 'JCB Rear Prop Shaft Half',
    partNumber: 'ASGP-4040',
    machine: 'jcb',
    category: '4',
    price: 4200,
    oeReference: ['914/60223'],
    featured: true,
    compatibility: [],
    images: [
      'asgp4040_kpnvx3.webp'
    ],
    description: 'High-quality Rear Prop Shaft Half designed for JCB backhoe loaders. Ensures reliable torque transmission for the rear drivetrain, providing smooth operation and durability under heavy-duty conditions. Built to OEM specifications for long-lasting performance.',
    specifications: {
      Type: 'Rear Prop Shaft Half',
      Application: 'JCB Backhoe Loader',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    tags: [
      'Rear Prop Shaft Half',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'asgp-4040', 'ASGP-4040', 'asgp4040', 'ASGP4040',
      'rear prop shaft half', 'jcb rear prop shaft half', 'rear driveshaft half', 'jcb driveshaft half',
      'drivetrain spare', 'transmission spare', 'replacement rear prop shaft half',

      // OE
      '914/60223', '91460223', '914-60223',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'rear prop shaft half replacement', 'drivetrain replacement', 'transmission replacement',
      'heavy machinery drivetrain', 'jcb transmission spare',

      // SEO / keywords
      'jcb rear prop shaft half', 'rear driveshaft half jcb', 'OEM rear prop shaft half',
      'heavy equipment drivetrain part'
    ]
  },

  //asgp4041
  {
    id: 'ASGP-4041',
    name: 'JCB Yoke Flange 35T',
    partNumber: 'ASGP-4041',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 1800, // adjust as needed
    featured: true,
    oeReference: ['459/70317'],
    compatibility: [],
    images: [
      'asgp4041_reygyw.webp'
    ],
    description: 'High-quality Yoke Flange 35T designed for JCB backhoe loaders. Ensures secure connection between driveshaft and gearbox components, providing reliable torque transmission and durability under heavy-duty operations. Built to OEM specifications for long-lasting performance.',
    specifications: {
      Type: 'Yoke Flange',
      Teeth: '35T',
      Application: 'JCB Backhoe Loader',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    tags: [
      'Yoke Flange',
      '35T',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'asgp-4041', 'ASGP-4041', 'asgp4041', 'ASGP4041',
      'yoke flange', 'yoke flange 35t', 'jcb yoke flange', 'yoke flange for jcb backhoe',
      'drivetrain spare', 'transmission spare', 'replacement yoke flange',

      // OE
      '459/70317', '45970317', '459-70317',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'yoke flange replacement', 'drivetrain replacement', 'transmission replacement',
      'heavy machinery drivetrain', 'jcb transmission spare',

      // SEO / keywords
      'jcb yoke flange 35t', 'yoke flange for jcb backhoe', 'OEM yoke flange',
      'heavy equipment drivetrain part'
    ]
  },

  //asgp4042
  {
    id: 'ASGP-4042',
    name: 'JCB U.J. Cross Rear',
    partNumber: 'ASGP-4042',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 1200, // adjust as needed
    featured: true,
    oeReference: ['998/10361'],
    compatibility: [],
    images: [
      'asgp4042_tsog8k.webp'
    ],
    description: 'High-quality Universal Joint (UJ) Cross Rear for JCB backhoe loaders. Ensures smooth rotation and torque transfer between drive shafts, providing reliable drivetrain performance under heavy-duty conditions. Built to OEM specifications for long-lasting durability.',
    specifications: {
      Type: 'Universal Joint Cross',
      Application: 'Rear Driveshaft - JCB Backhoe Loader',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    tags: [
      'UJ Cross',
      'Rear Driveshaft',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'asgp-4042', 'ASGP-4042', 'asgp4042', 'ASGP4042',
      'uj cross', 'universal joint cross', 'rear uj cross', 'jcb uj cross',
      'drivetrain spare', 'transmission spare', 'replacement uj cross',

      // OE
      '998/10361', '99810361', '998-10361',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'uj cross replacement', 'drivetrain replacement', 'transmission replacement',
      'heavy machinery drivetrain', 'jcb transmission spare',

      // SEO / keywords
      'jcb rear uj cross', 'universal joint cross jcb', 'OEM uj cross',
      'heavy equipment drivetrain part'
    ]
  },

  //asgp4043
  {
    id: 'ASGP-4043',
    name: 'JCB U.J. Cross Rear Bolts',
    partNumber: 'ASGP-4043',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 450, // adjust as needed
    featured: true,
    oeReference: ['826/11635'],
    compatibility: [],
    images: [
      'asgp4043_rqzbhc.webp'
    ],
    description: 'High-quality U.J. Cross Rear Bolts (MPS) for JCB backhoe loaders. Provides secure fastening for rear universal joint crosses, ensuring proper drivetrain alignment and reliable torque transfer. Manufactured to OEM standards for long-lasting durability.',
    specifications: {
      Type: 'UJ Cross Rear Bolts',
      Application: 'Rear Driveshaft - JCB Backhoe Loader',
      Material: 'High-Strength Steel',
      Features: 'OEM Fit, Durable, Precision Machined, Heavy-Duty Performance'
    },
    tags: [
      'UJ Cross Bolts',
      'Rear Driveshaft',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'asgp-4043', 'ASGP-4043', 'asgp4043', 'ASGP4043',
      'uj cross bolts', 'rear uj cross bolts', 'jcb uj cross bolts', 'drivetrain bolts',
      'transmission bolts', 'replacement bolts', 'uj cross fasteners',

      // OE
      '826/11635', '82611635', '826-11635',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'uj cross bolt replacement', 'drivetrain bolt replacement', 'transmission bolt replacement',
      'heavy machinery drivetrain parts', 'jcb drivetrain spare',

      // SEO / keywords
      'jcb rear uj cross bolts', 'uj cross rear fasteners jcb', 'OEM uj cross bolts',
      'heavy equipment drivetrain bolts'
    ]
  },

  //asgp4044
  {
    id: 'ASGP-4044',
    name: 'JCB U.J. Cross Rear Strap',
    partNumber: 'ASGP-4044',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 650, // adjust as needed
    featured: true,
    oeReference: ['116/00525'],
    compatibility: [],
    images: [
      'asgp4044_g7osxc.webp'
    ],
    description: 'High-quality U.J. Cross Rear Strap for JCB backhoe loaders. Provides secure support and alignment for the rear universal joint, ensuring reliable drivetrain performance and long-lasting durability. Manufactured to OEM specifications for heavy-duty applications.',
    specifications: {
      Type: 'UJ Cross Rear Strap',
      Application: 'Rear Driveshaft - JCB Backhoe Loader',
      Material: 'High-Strength Steel',
      Features: 'OEM Fit, Durable, Precision Machined, Heavy-Duty Performance'
    },
    tags: [
      'UJ Cross Strap',
      'Rear Driveshaft',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'asgp-4044', 'ASGP-4044', 'asgp4044', 'ASGP4044',
      'uj cross strap', 'rear uj cross strap', 'jcb uj cross strap', 'drivetrain strap',
      'transmission strap', 'replacement strap', 'uj cross support',

      // OE
      '116/00525', '11600525', '116-00525',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'uj cross strap replacement', 'drivetrain strap replacement', 'transmission strap replacement',
      'heavy machinery drivetrain parts', 'jcb drivetrain spare',

      // SEO / keywords
      'jcb rear uj cross strap', 'uj cross rear support jcb', 'OEM uj cross strap',
      'heavy equipment drivetrain strap'
    ]
  },

  //asgp4045
  {
    id: 'ASGP-4045',
    name: 'JCB Flywheel Ring Gear - 121T',
    partNumber: 'ASGP-4045',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 7200, // adjust as needed
    featured: true,
    oeReference: ['02/190008'],
    compatibility: [],
    images: [
      'asgp4045_lx3itd.webp'
    ],
    description: 'High-quality Flywheel Ring Gear with 121 teeth for JCB backhoe loaders. Ensures proper engagement with the starter motor for reliable engine starting and long-lasting performance. Manufactured to OEM specifications for durability and precision.',
    specifications: {
      Type: 'Flywheel Ring Gear',
      Application: 'Engine Starter - JCB Backhoe Loader',
      Teeth: '121T',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Precision Machined, Heavy-Duty Performance'
    },
    tags: [
      'Flywheel Ring Gear',
      '121T',
      'JCB Backhoe Loader',
      'Engine Starter',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'asgp-4045', 'ASGP-4045', 'asgp4045', 'ASGP4045',
      'flywheel ring gear', '121t flywheel ring gear', 'jcb flywheel ring gear', 'engine starter gear',
      'replacement flywheel gear', 'starter ring gear', 'heavy duty flywheel gear',

      // OE
      '02/190008', '02190008', '02-190008',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'flywheel ring gear replacement', 'starter ring gear replacement', 'drivetrain spare',
      'heavy machinery drivetrain part', 'jcb drivetrain spare',

      // SEO / keywords
      'jcb 121t flywheel ring gear', 'starter gear for jcb backhoe', 'OEM flywheel ring gear jcb',
      'heavy equipment flywheel gear'
    ]
  },

  //asgp4046
  {
    id: 'ASGP-4046',
    name: 'JCB Flywheel Ring Gear - 122T',
    partNumber: 'ASGP-4046',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 7300, // adjust as needed
    featured: true,
    oeReference: ['320/03102'],
    compatibility: [],
    images: [
      'asgp4045_lx3itd.webp'
    ],
    description: 'High-quality Flywheel Ring Gear with 122 teeth for JCB backhoe loaders. Ensures precise engagement with the starter motor for reliable engine starting and long-lasting performance. Manufactured to OEM specifications for durability and precision.',
    specifications: {
      Type: 'Flywheel Ring Gear',
      Application: 'Engine Starter - JCB Backhoe Loader',
      Teeth: '122T',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Precision Machined, Heavy-Duty Performance'
    },
    tags: [
      'Flywheel Ring Gear',
      '122T',
      'JCB Backhoe Loader',
      'Engine Starter',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'asgp-4046', 'ASGP-4046', 'asgp4046', 'ASGP4046',
      'flywheel ring gear', '122t flywheel ring gear', 'jcb flywheel ring gear', 'engine starter gear',
      'replacement flywheel gear', 'starter ring gear', 'heavy duty flywheel gear',

      // OE
      '320/03102', '32003102', '320-03102',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'flywheel ring gear replacement', 'starter ring gear replacement', 'drivetrain spare',
      'heavy machinery drivetrain part', 'jcb drivetrain spare',

      // SEO / keywords
      'jcb 122t flywheel ring gear', 'starter gear for jcb backhoe', 'OEM flywheel ring gear jcb',
      'heavy equipment flywheel gear'
    ]
  },

  //asgp4047
  {
    id: 'ASGP-4047',
    name: 'JCB Pinion Plate / Brake Disc',
    partNumber: 'ASGP-4047',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 4200, // adjust as needed
    featured: true,
    oeReference: ['458/20693'],
    compatibility: [],
    images: [
      'asgp4047_bt6pbm.webp',
      'asgp4047-2_jbigyo.webp'
    ],
    description: 'High-quality Pinion Plate / Brake Disc for JCB backhoe loaders. Designed to ensure reliable braking performance and precise engagement within the drivetrain system. Manufactured to OEM standards for durability and long-lasting use.',
    specifications: {
      Type: 'Pinion Plate / Brake Disc',
      Application: 'Hand Brake System - JCB Backhoe Loader',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Precision Machined, Heavy-Duty Performance'
    },
    tags: [
      'Pinion Plate',
      'Hand Brake Disc',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Transmission',
      'Heavy Duty',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'asgp-4047', 'ASGP-4047', 'asgp4047', 'ASGP4047',
      'pinion plate', 'hand brake disc', 'jcb pinion plate', 'jcb hand brake disc',
      'brake disc', 'drivetrain spare', 'transmission spare', 'replacement pinion plate', 'replacement brake disc',

      // OE
      '458/20693', '45820693', '458-20693',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'pinion plate replacement', 'hand brake disc replacement', 'drivetrain replacement',
      'heavy machinery brake parts', 'jcb brake spare',

      // SEO / keywords
      'jcb pinion plate hand brake disc', 'hand brake disc jcb backhoe', 'OEM pinion plate jcb',
      'heavy equipment brake disc'
    ]
  },

  //asgp4048
  {
    id: 'ASGP-4048',
    name: 'JCB Pump Flange',
    partNumber: 'ASGP-4048',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 3200, // adjust as needed
    featured: true,
    oeReference: ['550/43393'],
    compatibility: [],
    images: [
      'asgp4048_cuhvsh.webp'
    ],
    description: 'High-quality Pump Flange designed for JCB backhoe loaders. Ensures reliable connection to the hydraulic pump and maintains efficient hydraulic performance. Manufactured to OEM standards for durability and precision fit.',
    specifications: {
      Type: 'Pump Flange',
      Application: 'Hydraulic Pump - JCB Backhoe Loader',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Precision Machined, Heavy-Duty Performance'
    },
    tags: [
      'Pump Flange',
      'JCB Backhoe Loader',
      'Hydraulic Pump',
      'Heavy Duty',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'asgp-4048', 'ASGP-4048', 'asgp4048', 'ASGP4048',
      'pump flange', 'jcb pump flange', 'hydraulic pump flange',
      'drivetrain spare', 'hydraulic spare', 'replacement pump flange',

      // OE
      '550/43393', '55043393', '550-43393',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'pump flange replacement', 'hydraulic pump spare', 'drivetrain replacement',

      // SEO / keywords
      'jcb pump flange', 'pump flange for jcb backhoe', 'OEM pump flange jcb',
      'heavy equipment hydraulic part'
    ]
  },

  //asgp4049
  {
    id: 'ASGP-4049',
    name: 'JCB 4WD Center Joint Cross Holder',
    partNumber: 'ASGP-4049',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 2800, // adjust as needed
    featured: true,
    oeReference: ['914/83304'],
    compatibility: [],
    images: [
      'asgp4049_tsmydb.webp'
    ],
    description: 'High-quality 4WD Center Joint Cross Holder designed for JCB backhoe loaders. Provides robust support for the universal joint cross, ensuring smooth and reliable power transmission in four-wheel drive applications. Manufactured to OEM specifications for durability and precise fit.',
    specifications: {
      Type: '4WD Center Joint Cross Holder',
      Application: 'JCB Backhoe Loader - 4WD Drivetrain',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    tags: [
      '4WD Center Joint',
      'Cross Holder',
      'JCB Backhoe Loader',
      'Drivetrain',
      'Heavy Duty',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'asgp-4049', 'ASGP-4049', 'asgp4049', 'ASGP4049',
      '4wd center joint cross holder', 'jcb center joint holder', 'drivetrain spare',
      'replacement 4wd joint holder', 'jcb 4wd spare',

      // OE
      '914/83304', '91483304', '914-83304',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      '4wd cross holder replacement', 'drivetrain replacement', 'universal joint holder',

      // SEO / keywords
      'jcb 4wd center joint cross holder', 'OEM 4wd joint holder jcb',
      'heavy equipment drivetrain part'
    ]
  },

  //asgp4050
  {
    id: 'ASGP-4050',
    name: 'JCB 4WD Sun Shaft',
    partNumber: 'ASGP-4050',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 3200, // adjust as needed
    featured: true,
    oeReference: ['914/86203'],
    compatibility: [],
    images: [
      'asgp4050_zgls3q.webp'
    ],
    description: 'High-quality 4WD Sun Shaft designed for JCB backhoe loaders. Ensures precise power transmission in four-wheel drive applications and contributes to smooth and efficient drivetrain operation. Manufactured to OEM specifications for long-lasting durability and performance.',
    specifications: {
      Type: '4WD Sun Shaft',
      Application: 'JCB Backhoe Loader - 4WD Drivetrain',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty Performance, Precision Machined'
    },
    tags: [
      '4WD Sun Shaft',
      'Hub Side Axle',
      'JCB',
      '4X4',
      'Drivetrain',
      'Heavy Duty',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'asgp-4050', 'ASGP-4050', 'asgp4050', 'ASGP4050',
      '4wd sun shaft', 'jcb 4wd shaft', 'sun gear shaft', 'drivetrain spare',
      'replacement sun shaft', 'jcb 4wd spare',

      // OE
      '914/86203', '91486203', '914-86203',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      '4wd sun shaft replacement', 'drivetrain replacement', 'jcb drivetrain part',

      // SEO / keywords
      'jcb 4wd sun shaft', 'OEM 4wd shaft jcb', 'heavy equipment drivetrain part'
    ]
  },

  //asgp4051
  {
    id: 'ASGP-4051',
    name: 'JCB 4WD Front Propeller Shaft',
    partNumber: 'ASGP-4051',
    machine: 'jcb',
    category: '4', // Drivetrain / transmission parts
    price: 4800, // adjust as needed
    featured: true,
    oeReference: ['914/60181', '914/49100'],
    compatibility: [],
    images: [
      'asgp4051_swztf9.webp'
    ],
    description: 'High-quality front propeller shaft designed for 4WD JCB backhoe loaders. Ensures smooth power transmission to the front axle for reliable four-wheel drive operation. Manufactured to OEM specifications for durability, precision, and long-lasting performance.',
    specifications: {
      Type: 'Front Propeller Shaft',
      Application: 'JCB Backhoe Loader - 4WD Drivetrain',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty, Precision Machined'
    },
    tags: [
      'Front Propeller Shaft',
      'JCB Backhoe Loader',
      '4WD',
      'Drivetrain',
      'Heavy Duty',
      'OEM Replacement'
    ],
    references: [
      // Product codes / variations
      'asgp-4051', 'ASGP-4051', 'asgp4051', 'ASGP4051',
      'front propeller shaft', 'jcb front prop shaft', '4wd front shaft',
      'drivetrain spare', 'replacement propeller shaft', 'jcb 4wd spare',

      // OE
      '914/60181', '91460181', '914-60181',
      '914/49100', '91449100', '914-49100',

      // Equipment references
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',

      // Spares / keywords
      'front propeller shaft replacement', 'drivetrain replacement', 'jcb drivetrain part',

      // SEO / keywords
      'jcb front propeller shaft', '4wd prop shaft jcb', 'OEM drivetrain propeller shaft'
    ]
  },

  // ASGP-4052
  {
    id: 'ASGP-4052',
    name: 'JCB 4WD Crown Wheel & Pinion 13T/38T',
    partNumber: 'ASGP-4052',
    machine: 'jcb',
    category: '4',
    price: 7800,
    featured: true,
    oeReference: ['458/70188'],
    compatibility: [],
    images: ['asgp4052_zgwmz9.webp'],
    description: 'High-quality Crown Wheel & Pinion set (13T/38T) for 4WD JCB backhoe loaders. Ensures reliable drivetrain performance and precision power transmission.',
    specifications: {
      Type: 'Crown Wheel & Pinion Set',
      Application: 'JCB Backhoe Loader - 4WD',
      Teeth: '13T Pinion / 38T Crown Wheel',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty, Precision Machined'
    },
    tags: ['Crown Wheel & Pinion', 'JCB 4WD', 'Drivetrain', 'Transmission', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4052', 'ASGP-4052', 'asgp4052', 'ASGP4052',
      'crown wheel', 'pinion', 'crown wheel & pinion', '13t crown wheel', '38t pinion',
      '4wd crown wheel pinion', 'drivetrain spare', 'transmission spare', 'jcb drivetrain part',
      '458/70188', '45870188', '458-70188',
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',
      'crown wheel pinion jcb 4wd', '13t 38t crown wheel pinion', 'OEM crown wheel pinion jcb'
    ]
  },

  // ASGP-4053
  {
    id: 'ASGP-4053',
    name: 'JCB 4WD U.J. Cross / Spider Kit',
    partNumber: 'ASGP-4053',
    machine: 'jcb',
    category: '4',
    price: 4200,
    featured: true,
    oeReference: ['914/86202'],
    compatibility: [],
    images: ['asgp4053_g0pnsk.webp'],
    description: 'High-quality universal joint cross and spider kit for JCB 4WD backhoe loaders. Provides smooth power transmission and durability for heavy-duty operation.',
    specifications: {
      Type: 'U.J. Cross & Spider Kit',
      Application: 'JCB Backhoe Loader - 4WD',
      Material: 'High-Strength Alloy Steel',
      Features: 'OEM Fit, Durable, Precision Machined'
    },
    tags: ['U.J. Cross', 'Spider Kit', 'JCB 4WD', 'Drivetrain', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4053', 'ASGP-4053', 'asgp4053', 'ASGP4053',
      'u.j. cross', 'spider kit', '4wd uj cross', '4wd spider kit', 'drivetrain spare',
      '914/86202', '91486202', '914-86202',
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery',
      'u.j. cross jcb', 'spider kit jcb 4wd', 'OEM uj cross spider kit'
    ]
  },

  // ASGP-4054
  {
    id: 'ASGP-4054',
    name: 'JCB 4WD Bevel Gear Kit',
    partNumber: 'ASGP-4054',
    machine: 'jcb',
    category: '4',
    price: 5300,
    featured: true,
    oeReference: [],
    compatibility: [],
    images: ['asgp4054_ugmv4t.webp'],
    description: 'High-quality Bevel / Star Gear Kit for JCB 4WD backhoe loaders. Ensures precise engagement and smooth operation of the drivetrain.',
    specifications: {
      Type: 'Bevel / Star Gear Kit',
      Application: 'JCB Backhoe Loader - 4WD',
      Material: 'Alloy Steel',
      Features: 'Durable, OEM Fit, Heavy-Duty'
    },
    tags: ['Bevel Gear Kit', 'Star Gear Kit', 'JCB 4WD', 'Drivetrain', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4054', 'ASGP-4054', 'asgp4054', 'ASGP4054',
      'bevel gear', 'star gear', 'bevel star gear kit', '4wd bevel gear', '4wd star gear',
      'drivetrain spare', 'jcb drivetrain spare', 'replacement bevel star gear',
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery'
    ]
  },

  // ASGP-4055
  {
    id: 'ASGP-4055',
    name: 'JCB Yoke Flange 32T 4WD',
    partNumber: 'ASGP-4055',
    machine: 'jcb',
    category: '4',
    price: 2200,
    featured: true,
    description: 'High-quality yoke flange with 32 teeth for JCB 4WD backhoe loaders. Ensures reliable connection and smooth operation in drivetrain assembly.',
    oeReference: ['450/27200'],
    compatibility: [],
    images: ['asgp4055-1_ntyqk2.webp', 'asgp4055-2_hdbbbl.webp'],
    specifications: {
      Type: 'Yoke Flange',
      Teeth: '32T',
      Application: 'JCB Backhoe Loader - 4WD',
      Material: 'Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    tags: ['Yoke Flange', '32T', 'JCB 4WD', 'Drivetrain', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4055', 'ASGP-4055', 'asgp4055', 'ASGP4055',
      'yoke flange', '32t yoke flange', 'jcb yoke flange', '4wd yoke flange', 'drivetrain spare',
      '450/27200', '45027200', '450-27200',
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery'
    ]
  },

  // ASGP-4056
  {
    id: 'ASGP-4056',
    name: 'JCB 4WD Front Axle Shaft Assembly Short',
    partNumber: 'ASGP-4056',
    machine: 'jcb',
    category: '4',
    price: 5600,
    featured: true,
    images: ['asgp4056-1_azt4fa.webp', 'asgp4056-2_uazcnk.webp'],
    description: 'Front axle shaft assembly (short) for JCB 4WD backhoe loaders. Ensures proper power transmission to front wheels.',
    specifications: {
      Type: 'Front Axle Shaft Assembly',
      Length: 'Short',
      Application: 'JCB Backhoe Loader - 4WD',
      Material: 'Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['914/88200'],
    compatibility: ['JCB Backhoe Loaders 4WD'],
    tags: ['Front Axle Shaft', 'Short', 'JCB 4WD', 'Drivetrain', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4056', 'ASGP-4056', 'asgp4056', 'ASGP4056',
      'front axle shaft', 'short front axle shaft', 'jcb 4wd axle shaft', 'drivetrain spare',
      '914/88200', '91488200', '914-88200',
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery'
    ]
  },

  // ASGP-4057
  {
    id: 'ASGP-4057',
    name: 'JCB 4WD Front Axle Shaft Assembly Long',
    partNumber: 'ASGP-4057',
    machine: 'jcb',
    category: '4',
    price: 5800,
    featured: true,
    oeReference: ['914/88100'],
    compatibility: [],
    images: ['asgp4057_bbinbj.webp'],
    description: 'Front axle shaft assembly (long) for JCB 4WD backhoe loaders. Ensures reliable front wheel power transmission.',
    specifications: {
      Type: 'Front Axle Shaft Assembly',
      Length: 'Long',
      Application: 'JCB Backhoe Loader - 4WD',
      Material: 'Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    tags: ['Front Axle Shaft', 'Long', 'JCB 4WD', 'Drivetrain', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4057', 'ASGP-4057', 'asgp4057', 'ASGP4057',
      'front axle shaft', 'long front axle shaft', 'jcb 4wd axle shaft', 'drivetrain spare',
      '914/88100', '91488100', '914-88100',
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery'
    ]
  },

  // ASGP-4058
  {
    id: 'ASGP-4058',
    name: 'JCB 4WD Trunnion Axle Steering',
    partNumber: 'ASGP-4058',
    machine: 'jcb',
    category: '4',
    price: 9000,
    featured: true,
    oeReference: ['448/03902'],
    compatibility: [],
    images: ['asgp4058_zv7kmg.webp'],
    description: 'High-quality trunnion axle steering assembly for JCB 4WD backhoe loaders. Provides precise steering control and durability under heavy-duty conditions.',
    specifications: {
      Type: 'Trunnion Axle Steering',
      Application: 'JCB Backhoe Loader - 4WD',
      Material: 'Alloy Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty, Precision Machined'
    },
    tags: ['Trunnion Axle', 'Steering', 'JCB 4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4058', 'ASGP-4058', 'asgp4058', 'ASGP4058',
      'trunnion axle', 'trunnion axle steering', 'jcb 4wd steering', 'drivetrain spare',
      '448/03902', '44803902', '448-03902',
      'jcb', 'jcb backhoe loader', 'backhoe loader', 'heavy machinery'
    ]
  },



  // L&T/Case-------------------------------------------------------------------------------------------
  // ASGP-4501
  {
    id: 'ASGP-4501',
    name: 'L&T/Case Annulus Ring',
    partNumber: 'ASGP-4501',
    machine: 'l&t/case',
    category: '4',
    price: 0, // Price not provided, update accordingly
    featured: false,
    description: 'High-quality annulus ring for L&T and Case machinery. Ensures durability and precise operation in heavy-duty equipment.',
    oeReference: ['85808265'],
    compatibility: [],
    images: ['asgp4501_g42oty.webp'],
    specifications: {
      Type: 'Annulus Ring',
      Application: 'L&T / Case Machinery',
      Material: 'Steel', // Material assumed
      Features: 'Durable, OEM Replacement'
    },
    tags: ['Annulus Ring', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      // Part IDs
      'asgp-4501', 'ASGP-4501', 'asgp4501', 'ASGP4501',
      '85808265',

      // Part name variations
      'annulus ring', 'annulus-ring', 'annulusring',
      'l&t annulus ring', 'lt annulus ring', 'lt/case annulus ring',
      'l&t case annulus ring', 'L&T/Case annulus ring', 'L&T Case annulus ring',

      // Machine compatibility
      'l&t machinery', 'case machinery', 'l&t equipment', 'case equipment',
      'l&t machine', 'case machine', 'l&t heavy machinery', 'case heavy machinery',

      // OEM / replacement
      'OEM replacement', 'oem part', 'replacement part', 'heavy duty part',

      // Keywords for search
      'steel annulus ring', 'durable annulus ring', 'high-quality annulus ring',
      'machine spare part', 'construction machinery part', 'industrial equipment part',

      // Alternate formatting
      'Annulus Ring L&T', 'Annulus Ring LT', 'Annulus Ring Case',
      'Annulus Ring L&T/Case', 'Annulus Ring L&T Case'
    ]
  },

  // ASGP-4502
  {
    id: 'ASGP-4502',
    name: 'L&T/Case Annulus Carrier',
    partNumber: 'ASGP-4502',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['85817684'],
    compatibility: [],
    images: ['asgp4502_sq09nu.webp'],
    description: 'High-quality annulus carrier for L&T and Case machinery. Ensures durability and precise operation.',
    specifications: { Type: 'Annulus Carrier', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Annulus Carrier', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4502', 'ASGP-4502', 'asgp4502', 'ASGP4502', '85817684', 'annulus carrier', 'l&t case annulus carrier',
      'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel annulus carrier', 'durable annulus carrier',
      'high-quality annulus carrier'
    ]
  },

  // ASGP-4503
  {
    id: 'ASGP-4503',
    name: 'L&T/Case Planet Gear',
    partNumber: 'ASGP-4503',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['87542769'],
    compatibility: [],
    images: ['asgp4503_wvwquj.webp'],
    description: 'High-quality planet gear for L&T and Case machinery. Designed for durability and precision in heavy-duty equipment.',
    specifications: { Type: 'Planet Gear', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Planet Gear', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4503', 'ASGP-4503', 'asgp4503', 'ASGP4503', '87542769', 'planet gear', 'l&t case planet gear',
      'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel planet gear', 'durable planet gear',
      'high-quality planet gear'
    ]
  },

  // ASGP-4504
  {
    id: 'ASGP-4504',
    name: 'L&T/Case Planet Gear Bearing',
    partNumber: 'ASGP-4504',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['85808272'],
    compatibility: [],
    images: ['asgp4504_xt4fef.webp'],
    description: 'High-quality planet gear bearing for L&T and Case machinery. Ensures smooth operation and durability.',
    specifications: { Type: 'Planet Gear Bearing', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Planet Gear Bearing', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4504', 'ASGP-4504', 'asgp4504', 'ASGP4504', '85808272', 'planet gear bearing', 'l&t case planet gear bearing',
      'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel planet gear bearing', 'durable planet gear bearing',
      'high-quality planet gear bearing'
    ]
  },

  // ASGP-4505
  {
    id: 'ASGP-4505',
    name: 'L&T/Case Sun Shaft',
    partNumber: 'ASGP-4505',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['358286A1'],
    compatibility: [],
    images: ['asgp4505_shncsi.webp'],
    description: 'Durable sun shaft for L&T and Case machinery, designed for precision and long service life.',
    specifications: { Type: 'Sun Shaft', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Sun Shaft', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4505', 'ASGP-4505', 'asgp4505', 'ASGP4505', '358286A1', 'sun shaft', 'l&t case sun shaft',
      'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel sun shaft', 'durable sun shaft',
      'high-quality sun shaft'
    ]
  },

  // ASGP-4506
  {
    id: 'ASGP-4506',
    name: 'L&T/Case Bevel Gear Kit',
    partNumber: 'ASGP-4506',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4506_pqiuyd.webp'],
    description: 'Bevel gear kit for L&T and Case machinery. Ensures proper gear meshing and long-lasting performance.',
    specifications: { Type: 'Bevel Gear Kit', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Bevel Gear Kit', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4506', 'ASGP-4506', 'asgp4506', 'ASGP4506', 'bevel gear kit', 'l&t case bevel gear kit',
      'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel bevel gear kit', 'durable bevel gear kit',
      'high-quality bevel gear kit'
    ]
  },

  // ASGP-4507
  {
    id: 'ASGP-4507',
    name: 'L&T/Case Crown Wheel & Pinion 12T/33T',
    partNumber: 'ASGP-4507',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4507_gswbp6.webp', 'asgp4507-2_bcgrkv.webp'],
    description: 'Crown wheel and pinion set 12T/33T for L&T and Case machinery. High-quality gear set for reliable operation.',
    specifications: { Type: 'Crown Wheel & Pinion', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Crown Wheel & Pinion', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4507', 'ASGP-4507', 'asgp4507', 'ASGP4507', 'crown wheel & pinion 12T/33T', 'l&t case crown wheel & pinion',
      'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel crown wheel & pinion', 'durable crown wheel & pinion',
      'high-quality crown wheel & pinion'
    ]
  },

  // ASGP-4508
  {
    id: 'ASGP-4508',
    name: 'L&T/Case Crown Wheel & Pinion 15T/35T',
    partNumber: 'ASGP-4508',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    images: ['asgp4508_qqfzgg.webp'],
    description: 'Crown wheel and pinion set 15T/35T for L&T and Case machinery. High-quality gear set for reliable operation.',
    specifications: { Type: 'Crown Wheel & Pinion', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    oeReference: [],
    compatibility: ['L&T Machinery', 'Case Machinery'],
    tags: ['Crown Wheel & Pinion', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4508', 'ASGP-4508', 'asgp4508', 'ASGP4508', 'crown wheel & pinion 15T/35T', 'l&t case crown wheel & pinion',
      'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel crown wheel & pinion', 'durable crown wheel & pinion',
      'high-quality crown wheel & pinion'
    ]
  },

  // ASGP-4509
  {
    id: 'ASGP-4509',
    name: 'L&T/Case Crown Wheel & Pinion 15T/37T',
    partNumber: 'ASGP-4509',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4509_qmsiry.webp'],
    description: 'Crown wheel and pinion set 15T/37T for L&T and Case machinery. High-quality gear set for reliable operation.',
    specifications: { Type: 'Crown Wheel & Pinion', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Crown Wheel & Pinion', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4509', 'ASGP-4509', 'asgp4509', 'ASGP4509', 'crown wheel & pinion 15T/37T', 'l&t case crown wheel & pinion',
      'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel crown wheel & pinion', 'durable crown wheel & pinion',
      'high-quality crown wheel & pinion'
    ]
  },

  // ASGP-4510
  {
    id: 'ASGP-4510',
    name: 'L&T/Case Pinion Plate',
    partNumber: 'ASGP-4510',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['47481067'],
    compatibility: [],
    images: ['asgp4510-1_nuz9wd.webp', 'asgp4510-2_abwdrb.webp'],
    description: 'Pinion plate / hand brake disc for L&T and Case machinery. Ensures precise braking and durable performance.',
    specifications: { Type: 'Pinion Plate / Hand Brake Disc', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Pinion Plate', 'Hand Brake Disc', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4510', 'ASGP-4510', 'asgp4510', 'ASGP4510', '47481067',
      'pinion plate', 'hand brake disc', 'pinion plate / hand brake disc',
      'l&t case pinion plate', 'l&t case hand brake disc', 'l&t machinery', 'case machinery',
      'oem replacement', 'heavy machinery', 'steel pinion plate', 'durable hand brake disc'
    ]
  },

  // ASGP-4511
  {
    id: 'ASGP-4511',
    name: 'L&T/Case Rear Prop Shaft N/M',
    partNumber: 'ASGP-4511',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['BU4010015'],
    compatibility: [],
    images: ['asgp4511_rrsshz.webp'],
    description: 'Rear prop shaft N/M for L&T and Case machinery. Designed for durability and reliable power transmission.',
    specifications: { Type: 'Rear Prop Shaft', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Rear Prop Shaft', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4511', 'ASGP-4511', 'asgp4511', 'ASGP4511', 'BU4010015',
      'rear prop shaft', 'rear prop shaft N/M', 'l&t case rear prop shaft', 'l&t machinery', 'case machinery',
      'oem replacement', 'heavy machinery', 'steel rear prop shaft', 'durable rear prop shaft'
    ]
  },

  // ASGP-4512
  {
    id: 'ASGP-4512',
    name: 'L&T/Case Rear Prop Shaft 6 Hole',
    partNumber: 'ASGP-4512',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4512_eygwfu.webp'],
    description: 'Rear prop shaft 6 hole for L&T and Case machinery. High-quality component for reliable operation.',
    specifications: { Type: 'Rear Prop Shaft', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Rear Prop Shaft', '6 Hole', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4512', 'ASGP-4512', 'asgp4512', 'ASGP4512', 'rear prop shaft 6 hole', 'l&t case rear prop shaft',
      'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel rear prop shaft', 'durable rear prop shaft'
    ]
  },

  // ASGP-4513
  {
    id: 'ASGP-4513',
    name: 'L&T/Case Rear Prop Shaft 8 Hole',
    partNumber: 'ASGP-4513',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4513_tina59.webp'],
    description: 'Rear prop shaft 8 hole for L&T and Case machinery. Ensures durability and precise power transmission.',
    specifications: { Type: 'Rear Prop Shaft', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Rear Prop Shaft', '8 Hole', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4513', 'ASGP-4513', 'asgp4513', 'ASGP4513', 'rear prop shaft 8 hole', 'l&t case rear prop shaft',
      'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel rear prop shaft', 'durable rear prop shaft'
    ]
  },

  // ASGP-4514
  {
    id: 'ASGP-4514',
    name: 'L&T/Case Yoke Flange',
    partNumber: 'ASGP-4514',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4514_ppdrz0.webp'],
    description: 'Yoke flange for L&T and Case machinery. High-quality component ensuring durability and precise fit.',
    specifications: { Type: 'Yoke Flange', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Yoke Flange', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4514', 'ASGP-4514', 'asgp4514', 'ASGP4514', 'yoke flange', 'l&t case yoke flange',
      'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel yoke flange', 'durable yoke flange'
    ]
  },

  // ASGP-4515
  {
    id: 'ASGP-4515',
    name: 'L&T/Case U.J. Cross Rear',
    partNumber: 'ASGP-4515',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4515_qmeztz.webp'],
    description: 'U.J. Cross Rear for L&T and Case machinery. Ensures smooth rotation and durable performance.',
    specifications: { Type: 'U.J. Cross', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['U.J. Cross', 'Rear', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4515', 'ASGP-4515', 'asgp4515', 'ASGP4515', 'U.J. Cross Rear', 'l&t case u.j. cross rear',
      'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel u.j. cross', 'durable u.j. cross'
    ]
  },

  // ASGP-4516
  {
    id: 'ASGP-4516',
    name: 'L&T/Case Pump Flange 4 Hole (Parker)',
    partNumber: 'ASGP-4516',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4516_jzj337.webp'],
    description: 'Pump flange 4 hole (Parker) for L&T and Case machinery. Ensures secure connection and durability.',
    specifications: { Type: 'Pump Flange', Application: 'L&T / Case Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Pump Flange', '4 Hole', 'Parker', 'L&T', 'Case', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4516', 'ASGP-4516', 'asgp4516', 'ASGP4516', 'pump flange 4 hole', 'pump flange parker',
      'l&t case pump flange', 'l&t machinery', 'case machinery', 'oem replacement', 'heavy machinery', 'steel pump flange', 'durable pump flange'
    ]
  },

  // ASGP-4517
  {
    id: 'ASGP-4517',
    name: 'L&T/Case 4WD Annulus Ring',
    partNumber: 'ASGP-4517',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['85806008'],
    compatibility: [],
    images: ['asgp4517_nparp4.webp'],
    description: 'High-quality annulus ring for L&T and Case 4WD machinery. Ensures durability and precise operation.',
    specifications: { Type: 'Annulus Ring', Application: 'L&T / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Annulus Ring', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4517', 'ASGP-4517', 'asgp4517', 'ASGP4517', '85806008', 'annulus ring 4wd', 'l&t case 4wd annulus ring',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel annulus ring', 'durable annulus ring'
    ]
  },

  // ASGP-4518
  {
    id: 'ASGP-4518',
    name: 'L&T/Case 4WD Annulus Carrier',
    partNumber: 'ASGP-4518',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['85817698'],
    compatibility: [],
    images: ['asgp4518_wpvlfu.webp'],
    description: 'High-quality annulus carrier for L&T and Case 4WD machinery. Ensures durability and precise operation.',
    specifications: { Type: 'Annulus Carrier', Application: 'L&T / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Annulus Carrier', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4518', 'ASGP-4518', 'asgp4518', 'ASGP4518', '85817698', 'annulus carrier 4wd', 'l&t case 4wd annulus carrier',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel annulus carrier', 'durable annulus carrier'
    ]
  },

  // ASGP-4519
  {
    id: 'ASGP-4519',
    name: 'L&T/Case 4WD Planet Gear',
    partNumber: 'ASGP-4519',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['85806014'],
    compatibility: [],
    images: ['asgp4519_euaukz.webp', 'asgp4519-2_ck5xpo.webp'],
    description: 'High-quality planet gear for L&T and Case 4WD machinery. Designed for durability and precision.',
    specifications: { Type: 'Planet Gear', Application: 'L&T / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Planet Gear', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4519', 'ASGP-4519', 'asgp4519', 'ASGP4519', '85806014', 'planet gear 4wd', 'l&t case 4wd planet gear',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel planet gear', 'durable planet gear'
    ]
  },

  //ASGP-4520
  {
    id: 'ASGP-4520',
    name: 'L&T/Case 4WD Planet Bearing',
    partNumber: 'ASGP-4520',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['85806015'],
    compatibility: [],
    images: ['asgp4504_xt4fef.webp'],
    description: 'Planet bearing for L&T and Case 4WD machinery. Ensures smooth rotation and durable operation.',
    specifications: { Type: 'Planet Bearing', Application: 'L&T / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Planet Bearing', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4520', 'ASGP-4520', 'asgp4520', 'ASGP4520', '85806015', 'planet bearing 4wd', 'l&t case 4wd planet bearing',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel planet bearing', 'durable planet bearing'
    ]
  },

  // ASGP-4521
  {
    id: 'ASGP-4521',
    name: 'L&T/Case 4WD Sun Yoke',
    partNumber: 'ASGP-4521',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['87306929'],
    compatibility: [],
    images: ['asgp4521_yrxacz.webp'],
    description: 'Sun yoke for L&T and Case 4WD machinery. High-quality component for durable performance.',
    specifications: { Type: 'Sun Yoke', Application: 'L&T / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Sun Yoke', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4521', 'ASGP-4521', 'asgp4521', 'ASGP4521', '87306929', 'sun yoke 4wd', 'l&t case 4wd sun yoke',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel sun yoke', 'durable sun yoke'
    ]
  },

  // ASGP-4522
  {
    id: 'ASGP-4522',
    name: 'L&T/Case 4WD Bevel Gear Kit',
    partNumber: 'ASGP-4522',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4522_aucwm0.webp'],
    description: 'Bevel / star gear kit for L&T and Case 4WD machinery. Ensures reliable gear performance and durability.',
    specifications: { Type: 'Bevel / Star Gear Kit', Application: 'L&T / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Bevel Gear Kit', 'Star Gear Kit', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4522', 'ASGP-4522', 'asgp4522', 'ASGP4522', 'bevel gear kit', 'star gear kit', 'l&t case 4wd bevel star gear kit',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel bevel gear kit', 'durable star gear kit'
    ]
  },

  // ASGP-4523
  {
    id: 'ASGP-4523',
    name: 'L&T/Case 4WD Propeller Shaft',
    partNumber: 'ASGP-4523',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4523_qeexj5.webp'],
    description: 'Prop shaft for L&T and Case 4WD machinery. Designed for reliable power transmission and durability.',
    specifications: { Type: 'Prop Shaft', Application: 'L&T / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Prop Shaft', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4523', 'ASGP-4523', 'asgp4523', 'ASGP4523', 'prop shaft 4wd', 'l&t case 4wd prop shaft',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel prop shaft', 'durable prop shaft'
    ]
  },

  // ASGP-4524
  {
    id: 'ASGP-4524',
    name: 'L&T/Case 4WD Female Yoke',
    partNumber: 'ASGP-4524',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4524_o9iug4.webp'],
    description: 'Female yoke for L&T and Case 4WD machinery. Ensures precise fit and reliable operation.',
    specifications: { Type: 'Female Yoke', Application: 'L&T / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Female Yoke', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4524', 'ASGP-4524', 'asgp4524', 'ASGP4524', 'female yoke 4wd', 'l&t case 4wd female yoke',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel female yoke', 'durable female yoke'
    ]
  },

  // ASGP-4525
  {
    id: 'ASGP-4525',
    name: 'L&T/Case 851 4WD Trunnion Set of 2',
    partNumber: 'ASGP-4525',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    images: ['asgp4525_xdbf2s.webp'],
    description: 'Trunnion set of 2 for L&T 851 in 4WD machinery. High-quality replacement for reliable performance.',
    specifications: { Type: 'Trunnion Set', Application: 'L&T 851 / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    oeReference: [],
    compatibility: ['L&T 851 4WD', 'Case 4WD'],
    tags: ['Trunnion Set', 'L&T 851', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4525', 'ASGP-4525', 'asgp4525', 'ASGP4525', 'trunnion set 4wd', 'l&t 851 trunnion set', 'l&t case 4wd trunnion set',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel trunnion set', 'durable trunnion set'
    ]
  },

  // ASGP-4526
  {
    id: 'ASGP-4526',
    name: 'L&T/Case 770 4WD Trunnion Set of 2',
    partNumber: 'ASGP-4526',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4526_ubrdzv.webp'],
    description: 'Trunnion set of 2 for L&T 770 in 4WD machinery. Durable and precise OEM replacement.',
    specifications: { Type: 'Trunnion Set', Application: 'L&T 770 / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Trunnion Set', 'L&T 770', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4526', 'ASGP-4526', 'asgp4526', 'ASGP4526', 'trunnion set 4wd', 'l&t 770 trunnion set', 'l&t case 4wd trunnion set',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel trunnion set', 'durable trunnion set'
    ]
  },

  // ASGP-4527
  {
    id: 'ASGP-4527',
    name: 'L&T/Case 851 4WD Trunnion Bush',
    partNumber: 'ASGP-4527',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4527_qmrotc.webp'],
    description: 'Trunnion bush for L&T 851 4WD machinery. Ensures smooth rotation and durability.',
    specifications: { Type: 'Trunnion Bush', Application: 'L&T 851 / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Trunnion Bush', 'L&T 851', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4527', 'ASGP-4527', 'asgp4527', 'ASGP4527', 'trunnion bush 4wd', 'l&t 851 trunnion bush', 'l&t case 4wd trunnion bush',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel trunnion bush', 'durable trunnion bush'
    ]
  },

  // ASGP-4528
  {
    id: 'ASGP-4528',
    name: 'L&T/Case 770 4WD Trunnion Bush',
    partNumber: 'ASGP-4528',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['84529088'],
    compatibility: [],
    images: ['asgp4527_qmrotc.webp'],
    description: 'Trunnion bush for L&T 770 4WD machinery. High-quality OEM replacement part.',
    specifications: { Type: 'Trunnion Bush', Application: 'L&T 770 / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Trunnion Bush', 'L&T 770', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4528', 'ASGP-4528', 'asgp4528', 'ASGP4528', '84529088', 'trunnion bush 4wd', 'l&t 770 trunnion bush', 'l&t case 4wd trunnion bush',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel trunnion bush', 'durable trunnion bush'
    ]
  },

  // ASGP-4529
  {
    id: 'ASGP-4529',
    name: 'L&T/Case 851 4WD Trunnion Bearing',
    partNumber: 'ASGP-4529',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4529_qe6na2.webp'],
    description: 'Trunnion bearing for L&T 851 4WD machinery. High-quality component for reliable performance.',
    specifications: { Type: 'Trunnion Bearing', Application: 'L&T 851 / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Trunnion Bearing', 'L&T 851', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4529', 'ASGP-4529', 'asgp4529', 'ASGP4529', '86998145', 'trunnion bearing 4wd', 'l&t 851 trunnion bearing', 'l&t case 4wd trunnion bearing',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel trunnion bearing', 'durable trunnion bearing'
    ]
  },

  // ASGP-4530
  {
    id: 'ASGP-4530',
    name: 'L&T/Case 770 4WD Trunnion Bearing',
    partNumber: 'ASGP-4530',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['86998145'],
    compatibility: [],
    images: ['asgp4529_qe6na2.webp'],
    description: 'Trunnion bearing for L&T 770 4WD machinery. Durable and precise OEM replacement.',
    specifications: { Type: 'Trunnion Bearing', Application: 'L&T 770 / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Trunnion Bearing', 'L&T 770', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4530', 'ASGP-4530', 'asgp4530', 'ASGP4530', '86998145', 'trunnion bearing 4wd', 'l&t 770 trunnion bearing', 'l&t case 4wd trunnion bearing',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel trunnion bearing', 'durable trunnion bearing'
    ]
  },

  // ASGP-4531
  {
    id: 'ASGP-4531',
    name: 'L&T/Case 4WD Cross Holder',
    partNumber: 'ASGP-4531',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['85827070'],
    compatibility: [],
    images: ['asgp4531_slae36.webp'],
    description: 'Cross holder for L&T and Case 4WD machinery. Ensures reliable performance and durability.',
    specifications: { Type: 'Cross Holder', Application: 'L&T / Case 4WD Machinery', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Cross Holder', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4531', 'ASGP-4531', 'asgp4531', 'ASGP4531', '85827070', 'cross holder 4wd', 'l&t case 4wd cross holder',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel cross holder', 'durable cross holder'
    ]
  },

  // ASGP-4532
  {
    id: 'ASGP-4532',
    name: 'L&T/Case 4WD UJ Cross',
    partNumber: 'ASGP-4532',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4053_g0pnsk.webp'],
    description: 'Universal Joint (UJ) Cross for L&T and Case 4WD machinery. Ensures smooth torque transmission and flexibility in the drivetrain.',
    specifications: {
      Type: 'UJ Cross',
      Application: 'L&T / Case 4WD Machinery',
      Material: 'Steel',
      Features: 'Durable, OEM Replacement'
    },
    tags: ['UJ Cross', 'Universal Joint', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4532', 'ASGP-4532', 'asgp4532', 'ASGP4532',
      'uj cross', 'universal joint cross', 'l&t case 4wd uj cross',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel uj cross', 'durable uj cross'
    ]
  },

  // ASGP-4533
  {
    id: 'ASGP-4533',
    name: 'L&T/Case 4WD Crown Wheel & Pinion 14T/32T',
    partNumber: 'ASGP-4533',
    machine: 'l&t/case',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4533_atrcim.webp'],
    description: 'Crown Wheel & Pinion (14T/32T) for L&T and Case 4WD machinery. Provides proper torque transfer and smooth final drive operation.',
    specifications: {
      Type: 'Crown Wheel & Pinion',
      Application: 'L&T / Case 4WD Machinery',
      Material: 'Steel',
      Features: 'Durable, OEM Replacement'
    },
    tags: ['Crown Wheel', 'Pinion', 'L&T', 'Case', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-4533', 'ASGP-4533', 'asgp4533', 'ASGP4533',
      'crown wheel pinion 14t 32t', 'l&t case 4wd crown wheel pinion',
      'l&t 4wd', 'case 4wd', 'oem replacement', 'heavy machinery', 'steel crown wheel pinion', 'durable crown wheel pinion'
    ]
  },



  // Escorts -----------------------------------------------------------------------------------------
  // ASGP-5001
  {
    id: 'ASGP-5001',
    name: 'Escorts Annulus Ring',
    partNumber: 'ASGP-5001',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['C7601570.077'],
    compatibility: [],
    images: ['asgp4009_fvrybs.webp'],
    description: 'Annulus ring for Escorts Digimax machinery. Ensures proper torque distribution in planetary gears.',
    specifications: { Type: 'Annulus Ring', Application: 'Escorts Digimax', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Annulus Ring', 'Escorts', 'Digimax', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5001', 'ASGP-5001', 'asgp5001', 'ASGP5001', 'C7601570.077',
      'annulus ring', 'escorts digimax annulus ring', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5002
  {
    id: 'ASGP-5002',
    name: 'Escorts Annulus Carrier',
    partNumber: 'ASGP-5002',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['C7601570.074'],
    compatibility: [],
    images: ['asgp4502_sq09nu.webp'],
    description: 'Annulus carrier for Escorts Digimax machinery. Supports planetary gear operation for torque distribution.',
    specifications: { Type: 'Annulus Carrier', Application: 'Escorts Digimax', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Annulus Carrier', 'Escorts', 'Digimax', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5002', 'ASGP-5002', 'asgp5002', 'ASGP5002', 'C7601570.074',
      'annulus carrier', 'escorts digimax annulus carrier', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5003
  {
    id: 'ASGP-5003',
    name: 'Escorts Planet Gear',
    partNumber: 'ASGP-5003',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['C7601570.084'],
    compatibility: [],
    images: ['asgp4503_wvwquj.webp'],
    description: 'Planet gear for Escorts Digimax machinery. High-quality gear for reliable power distribution.',
    specifications: { Type: 'Planet Gear', Application: 'Escorts Digimax', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Planet Gear', 'Escorts', 'Digimax', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5003', 'ASGP-5003', 'asgp5003', 'ASGP5003', 'C7601570.084',
      'planet gear', 'escorts digimax planet gear', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5004
  {
    id: 'ASGP-5004',
    name: 'Escorts Planet Gear Bearing',
    partNumber: 'ASGP-5004',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['C7601570.083'],
    compatibility: [],
    images: ['asgp4504_xt4fef.webp'],
    description: 'Planet bearing for Escorts Digimax machinery. Ensures smooth gear rotation and durability.',
    specifications: { Type: 'Planet Bearing', Application: 'Escorts Digimax', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Planet Bearing', 'Escorts', 'Digimax', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5004', 'ASGP-5004', 'asgp5004', 'ASGP5004', 'C7601570.083',
      'planet bearing', 'escorts digimax planet bearing', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5005
  {
    id: 'ASGP-5005',
    name: 'Escorts Sun Shaft',
    partNumber: 'ASGP-5005',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['C7602100.004'],
    compatibility: [],
    images: ['asgp4505_shncsi.webp'],
    description: 'Sun shaft for Escorts Digimax machinery. Central component in planetary gear system for torque transmission.',
    specifications: { Type: 'Sun Shaft', Application: 'Escorts Digimax', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Sun Shaft', 'Escorts', 'Digimax', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5005', 'ASGP-5005', 'asgp5005', 'ASGP5005', 'C7602100.004',
      'sun shaft', 'escorts digimax sun shaft', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5006
  {
    id: 'ASGP-5006',
    name: 'Escorts Bevel Gear Kit',
    partNumber: 'ASGP-5006',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4506_pqiuyd.webp'],
    description: 'Bevel / Star gear kit for Escorts Digimax machinery. Provides proper gear meshing for torque transfer.',
    specifications: { Type: 'Bevel / Star Gear Kit', Application: 'Escorts Digimax', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Bevel Gear Kit', 'Star Gear Kit', 'Escorts', 'Digimax', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5006', 'ASGP-5006', 'asgp5006', 'ASGP5006',
      'bevel gear kit', 'star gear kit', 'escorts digimax bevel star gear kit', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5007
  {
    id: 'ASGP-5007',
    name: 'Escorts Crown Wheel & Pinion 12T/33T',
    partNumber: 'ASGP-5007',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4509_qmsiry.webp'],
    description: 'Crown wheel & pinion (12T/33T) for Escorts Digimax machinery. Ensures correct final drive ratio.',
    specifications: { Type: 'Crown Wheel & Pinion', Application: 'Escorts Digimax', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Crown Wheel', 'Pinion', 'Escorts', 'Digimax', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5007', 'ASGP-5007', 'asgp5007', 'ASGP5007',
      'crown wheel pinion 12t 33t', 'escorts digimax crown wheel pinion', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5008
  {
    id: 'ASGP-5008',
    name: 'Escorts Pinion Plate',
    partNumber: 'ASGP-5008',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['C7601570.041'],
    compatibility: [],
    images: ['asgp4510-1_nuz9wd.webp', 'asgp4510-2_abwdrb.webp'],
    description: 'Pinion plate / hand brake disc for Escorts Digimax machinery. Part of the braking system and torque transmission.',
    specifications: { Type: 'Pinion Plate / Hand Brake Disc', Application: 'Escorts Digimax', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Pinion Plate', 'Hand Brake Disc', 'Escorts', 'Digimax', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5008', 'ASGP-5008', 'asgp5008', 'ASGP5008', 'C7601570.041',
      'pinion plate', 'hand brake disc', 'escorts digimax pinion plate', 'escorts digimax hand brake disc', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5009
  {
    id: 'ASGP-5009',
    name: 'Escorts Rear Propeller Shaft',
    partNumber: 'ASGP-5009',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4039_wycvgn.webp', 'asgp4039-2_pei9cm.webp'],
    description: 'Rear propeller shaft for Escorts Digimax machinery. Transmits power from the gearbox to the rear axle.',
    specifications: { Type: 'Rear Propeller Shaft', Application: 'Escorts Digimax', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Propeller Shaft', 'Rear Shaft', 'Escorts', 'Digimax', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5009', 'ASGP-5009', 'asgp5009', 'ASGP5009',
      'rear propeller shaft', 'escorts digimax rear shaft', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5010
  {
    id: 'ASGP-5010',
    name: 'Escorts Yoke Flange',
    partNumber: 'ASGP-5010',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4514_ppdrz0.webp'],
    description: 'Yoke flange for Escorts Digimax machinery. Connects propeller shaft to the differential for torque transmission.',
    specifications: { Type: 'Yoke Flange', Application: 'Escorts Digimax', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Yoke Flange', 'Escorts', 'Digimax', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5010', 'ASGP-5010', 'asgp5010', 'ASGP5010',
      'yoke flange', 'escorts digimax yoke flange', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5011
  {
    id: 'ASGP-5011',
    name: 'Escorts U.J. Cross Rear',
    partNumber: 'ASGP-5011',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4042_tsog8k.webp'],
    description: 'Universal joint (UJ) cross for the rear of Escorts Digimax machinery. Provides flexibility in torque transmission.',
    specifications: { Type: 'UJ Cross', Application: 'Escorts Digimax', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['UJ Cross', 'Universal Joint', 'Rear', 'Escorts', 'Digimax', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5011', 'ASGP-5011', 'asgp5011', 'ASGP5011',
      'uj cross rear', 'escorts digimax uj cross', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5012
  {
    id: 'ASGP-5012',
    name: 'Escorts Pump Flange 4 Hole Parker',
    partNumber: 'ASGP-5012',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4516_jzj337.webp'],
    description: 'Pump flange 4 hole (Parker) for Escorts Digimax machinery. Ensures proper fluid transfer in hydraulic systems.',
    specifications: { Type: 'Pump Flange', Application: 'Escorts Digimax', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Pump Flange', 'Parker', 'Escorts', 'Digimax', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5012', 'ASGP-5012', 'asgp5012', 'ASGP5012',
      'pump flange 40 hole', 'parker pump flange', 'escorts digimax pump flange', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5013
  {
    id: 'ASGP-5013',
    name: 'Escorts 4WD Annulus Ring',
    partNumber: 'ASGP-5013',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['C7602086.053'],
    compatibility: [],
    images: ['asgp4501_g42oty.webp'],
    description: 'Annulus ring for Escorts Digimax 4WD machinery. Supports proper torque distribution in planetary gears.',
    specifications: { Type: 'Annulus Ring', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Annulus Ring', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5013', 'ASGP-5013', 'asgp5013', 'ASGP5013', 'C7602086.053',
      'annulus ring', 'escorts digimax 4wd annulus ring', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5014
  {
    id: 'ASGP-5014',
    name: 'Escorts 4WD Annulus Carrier',
    partNumber: 'ASGP-5014',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['C7602086.054'],
    compatibility: [],
    images: ['asgp4518_wpvlfu.webp'],
    description: 'Annulus carrier for Escorts Digimax 4WD machinery. Supports planetary gear operation.',
    specifications: { Type: 'Annulus Carrier', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Annulus Carrier', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5014', 'ASGP-5014', 'asgp5014', 'ASGP5014', 'C7602086.054',
      'annulus carrier', 'escorts digimax 4wd annulus carrier', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5015
  {
    id: 'ASGP-5015',
    name: 'Escorts 4WD Planet Gear',
    partNumber: 'ASGP-5015',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['C7602086.069'],
    compatibility: [],
    images: ['asgp4519_euaukz.webp', 'asgp4519-2_ck5xpo.webp'],
    description: 'Planet gear for Escorts Digimax 4WD machinery. High-quality gear for torque distribution.',
    specifications: { Type: 'Planet Gear', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Planet Gear', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5015', 'ASGP-5015', 'asgp5015', 'ASGP5015', 'C7602086.069',
      'planet gear', 'escorts digimax 4wd planet gear', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5016
  {
    id: 'ASGP-5016',
    name: 'Escorts 4WD Planet Gear Bearing',
    partNumber: 'ASGP-5016',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['C7601570.088'],
    compatibility: [],
    images: ['asgp4504_xt4fef.webp'],
    description: 'Planet bearing for Escorts Digimax 4WD machinery. Ensures smooth gear rotation.',
    specifications: { Type: 'Planet Bearing', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Planet Bearing', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5016', 'ASGP-5016', 'asgp5016', 'ASGP5016', 'C7601570.088',
      'planet bearing', 'escorts digimax 4wd planet bearing', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5017
  {
    id: 'ASGP-5017',
    name: 'Escorts 4WD Sun Shaft',
    partNumber: 'ASGP-5017',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['C7602086.012'],
    compatibility: [],
    images: ['asgp4521_yrxacz.webp'],
    description: 'Sun shaft for Escorts Digimax 4WD machinery. Central component of planetary gear system.',
    specifications: { Type: 'Sun Shaft', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Sun Shaft', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5017', 'ASGP-5017', 'asgp5017', 'ASGP5017', 'C7602086.012',
      'sun shaft', 'escorts digimax 4wd sun shaft', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5018
  {
    id: 'ASGP-5018',
    name: 'Escorts 4WD Bevel Gear Kit',
    partNumber: 'ASGP-5018',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4522_aucwm0.webp'],
    description: 'Bevel gear kit for Escorts Digimax 4WD machinery. Ensures proper meshing and torque transfer in the drivetrain.',
    specifications: { Type: 'Bevel Gear Kit', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Bevel Gear Kit', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5018', 'ASGP-5018', 'asgp5018', 'ASGP5018',
      'bevel gear kit', 'escorts digimax 4wd bevel gear kit', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5019
  {
    id: 'ASGP-5019',
    name: 'Escorts 4WD Propeller Shaft',
    partNumber: 'ASGP-5019',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4523_qeexj5.webp'],
    description: 'Propeller shaft for Escorts Digimax 4WD machinery. Transmits torque from the gearbox to the rear differential.',
    specifications: { Type: 'Propeller Shaft', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Propeller Shaft', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5019', 'ASGP-5019', 'asgp5019', 'ASGP5019',
      'propeller shaft', 'escorts digimax 4wd propeller shaft', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5020
  {
    id: 'ASGP-5020',
    name: 'Escorts 4WD Propeller Shaft Half',
    partNumber: 'ASGP-5020',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4524_o9iug4.webp'],
    description: 'Propeller shaft half for Escorts Digimax 4WD machinery. Ensures smooth torque transfer in segmented driveshaft systems.',
    specifications: { Type: 'Propeller Shaft Half', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Propeller Shaft Half', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5020', 'ASGP-5020', 'asgp5020', 'ASGP5020',
      'propeller shaft half', 'escorts digimax 4wd propeller shaft half', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5021
  {
    id: 'ASGP-5021',
    name: 'Escorts 4WD Trunnion Set',
    partNumber: 'ASGP-5021',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['C7602086.049', 'C7602086.050'],
    compatibility: [],
    images: ['asgp4525_xdbf2s.webp'],
    description: 'Trunnion set for Escorts Digimax 4WD machinery. Provides stable rotational support for planetary gears.',
    specifications: { Type: 'Trunnion Set', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Trunnion Set', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5021', 'ASGP-5021', 'asgp5021', 'ASGP5021', 'C7602086.049', 'C7602086.050',
      'trunnion set', 'escorts digimax 4wd trunnion set', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5022
  {
    id: 'ASGP-5022',
    name: 'Escorts 4WD Trunnion Bush',
    partNumber: 'ASGP-5022',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4527_qmrotc.webp'],
    description: 'Trunnion bush for Escorts Digimax 4WD machinery. Provides bearing surface for trunnion pins.',
    specifications: { Type: 'Trunnion Bush', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Trunnion Bush', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5022', 'ASGP-5022', 'asgp5022', 'ASGP5022',
      'trunnion bush', 'escorts digimax 4wd trunnion bush', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5023
  {
    id: 'ASGP-5023',
    name: 'Escorts 4WD Trunnion Bearing',
    partNumber: 'ASGP-5023',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4529_qe6na2.webp'],
    description: 'Trunnion bearing for Escorts Digimax 4WD machinery. Ensures smooth rotation and support of trunnion pins.',
    specifications: { Type: 'Trunnion Bearing', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Trunnion Bearing', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5023', 'ASGP-5023', 'asgp5023', 'ASGP5023',
      'trunnion bearing', 'escorts digimax 4wd trunnion bearing', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5024
  {
    id: 'ASGP-5024',
    name: 'Escorts 4WD Cross Holder',
    partNumber: 'ASGP-5024',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4531_slae36.webp'],
    description: 'Cross holder for Escorts Digimax 4WD machinery. Supports universal joint assembly and ensures stability.',
    specifications: { Type: 'Cross Holder', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Cross Holder', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5024', 'ASGP-5024', 'asgp5024', 'ASGP5024',
      'cross holder', 'escorts digimax 4wd cross holder', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5025
  {
    id: 'ASGP-5025',
    name: 'Escorts 4WD U.J. Cross',
    partNumber: 'ASGP-5025',
    machine: 'escorts',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4053_g0pnsk.webp'],
    description: 'Universal joint (UJ) cross for Escorts Digimax 4WD machinery. Ensures flexibility in torque transmission.',
    specifications: { Type: 'UJ Cross', Application: 'Escorts Digimax 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['UJ Cross', 'Universal Joint', 'Escorts', 'Digimax', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5025', 'ASGP-5025', 'asgp5025', 'ASGP5025',
      'uj cross', 'escorts digimax 4wd uj cross', 'escorts machinery', 'digimax machinery', 'oem replacement', 'heavy machinery'
    ]
  },



  //Terex----------------------------------------------------------------------------------------------
  // ASGP-5501
  {
    id: 'ASGP-5501',
    name: 'Terex Annulus Ring',
    partNumber: 'ASGP-5501',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: true,
    oeReference: ['6193410M1'],
    compatibility: [],
    images: ['asgp4501_g42oty.webp'],
    description: 'Annulus ring for Terex machinery. Supports proper torque distribution in planetary gear system.',
    specifications: { Type: 'Annulus Ring', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Annulus Ring', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5501', 'ASGP-5501', 'asgp5501', 'ASGP5501', '6193410M1',
      'annulus ring', 'terex annulus ring', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5502
  {
    id: 'ASGP-5502',
    name: 'Terex Annulus Carrier',
    partNumber: 'ASGP-5502',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6193411M1'],
    compatibility: [],
    images: ['asgp4502_sq09nu.webp'],
    description: 'Annulus carrier for Terex machinery. Supports planetary gear operation for torque distribution.',
    specifications: { Type: 'Annulus Carrier', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Annulus Carrier', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5502', 'ASGP-5502', 'asgp5502', 'ASGP5502', '6193411M1',
      'annulus carrier', 'terex annulus carrier', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5503
  {
    id: 'ASGP-5503',
    name: 'Terex Planet Gear',
    partNumber: 'ASGP-5503',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6193419M1'],
    compatibility: [],
    images: ['asgp4503_wvwquj.webp'],
    description: 'Planet gear for Terex machinery. High-quality gear for reliable torque distribution.',
    specifications: { Type: 'Planet Gear', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Planet Gear', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5503', 'ASGP-5503', 'asgp5503', 'ASGP5503', '6193419M1',
      'planet gear', 'terex planet gear', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5504
  {
    id: 'ASGP-5504',
    name: 'Terex Planet Gear Bearing',
    partNumber: 'ASGP-5504',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6193414M1'],
    compatibility: [],
    images: ['asgp4504_xt4fef.webp'],
    description: 'Planet bearing for Terex machinery. Ensures smooth rotation and durability in planetary gear system.',
    specifications: { Type: 'Planet Bearing', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Planet Bearing', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5504', 'ASGP-5504', 'asgp5504', 'ASGP5504', '6193414M1',
      'planet bearing', 'terex planet bearing', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5505
  {
    id: 'ASGP-5505',
    name: 'Terex Sun Shaft',
    partNumber: 'ASGP-5505',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6193422M1'],
    compatibility: [],
    images: ['asgp4505_shncsi.webp'],
    description: 'Sun shaft for Terex machinery. Central component of planetary gear system for torque transfer.',
    specifications: { Type: 'Sun Shaft', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Sun Shaft', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5505', 'ASGP-5505', 'asgp5505', 'ASGP5505', '6193422M1',
      'sun shaft', 'terex sun shaft', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5506
  {
    id: 'ASGP-5506',
    name: 'Terex Bevel Gear Kit',
    partNumber: 'ASGP-5506',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4506_pqiuyd.webp'],
    description: 'Bevel gear kit for Terex machinery. Provides proper meshing and torque transfer in drivetrain.',
    specifications: { Type: 'Bevel Gear Kit', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Bevel Gear Kit', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5506', 'ASGP-5506', 'asgp5506', 'ASGP5506',
      'bevel gear kit', 'terex bevel gear kit', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5507
  {
    id: 'ASGP-5507',
    name: 'Terex Crown Pinion 15T/35T',
    partNumber: 'ASGP-5507',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['61933449M91'],
    compatibility: [],
    images: ['asgp4508_qqfzgg.webp'],
    description: 'Crown pinion 15T/35T for Terex machinery. Ensures correct final drive ratio.',
    specifications: { Type: 'Crown Pinion', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Crown Pinion', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5507', 'ASGP-5507', 'asgp5507', 'ASGP5507', '61933449M91',
      'crown pinion 15t 35t', 'terex crown pinion', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5508
  {
    id: 'ASGP-5508',
    name: 'Terex Crown Pinion 15T/37T',
    partNumber: 'ASGP-5508',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6194510M91'],
    compatibility: [],
    images: ['asgp4509_qmsiry.webp'],
    description: 'Crown pinion 15T/37T for Terex machinery. Ensures correct final drive ratio.',
    specifications: { Type: 'Crown Pinion', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Crown Pinion', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5508', 'ASGP-5508', 'asgp5508', 'ASGP5508', '6194510M91',
      'crown pinion 15t 37t', 'terex crown pinion', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5509
  {
    id: 'ASGP-5509',
    name: 'Terex Crown Pinion 15T/37T N/M',
    partNumber: 'ASGP-5509',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4507-2_bcgrkv.webp'],
    description: 'Crown pinion 15T/37T N/M for Terex machinery. Final drive component for torque transfer.',
    specifications: { Type: 'Crown Pinion', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Crown Pinion', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5509', 'ASGP-5509', 'asgp5509', 'ASGP5509',
      'crown pinion 15t 37t nm', 'terex crown pinion nm', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5510
  {
    id: 'ASGP-5510',
    name: 'Terex Pinion Plate',
    partNumber: 'ASGP-5510',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6193362M1'],
    compatibility: [],
    images: ['asgp4047_bt6pbm.webp'],
    description: 'Pinion plate / hand brake disc for Terex machinery. Part of braking and torque transfer system.',
    specifications: { Type: 'Pinion Plate / Hand Brake Disc', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Pinion Plate', 'Hand Brake Disc', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5510', 'ASGP-5510', 'asgp5510', 'ASGP5510', '6193362M1',
      'pinion plate', 'hand brake disc', 'terex pinion plate', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5511
  {
    id: 'ASGP-5511',
    name: 'Terex Rear Prop Shaft',
    partNumber: 'ASGP-5511',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6106483M91'],
    compatibility: [],
    images: ['asgp4511_rrsshz.webp'],
    description: 'Rear propeller shaft for Terex machinery. Transmits torque from gearbox to the rear axle.',
    specifications: { Type: 'Rear Prop Shaft', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Rear Prop Shaft', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5511', 'ASGP-5511', 'asgp5511', 'ASGP5511', '6106483M91',
      'rear prop shaft', 'terex rear prop shaft', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5512
  {
    id: 'ASGP-5512',
    name: 'Terex Yoke Flange',
    partNumber: 'ASGP-5512',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4055-1_ntyqk2.webp'],
    description: 'Yoke flange for Terex machinery. Connects propeller shaft to differential for torque transmission.',
    specifications: { Type: 'Yoke Flange', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Yoke Flange', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5512', 'ASGP-5512', 'asgp5512', 'ASGP5512',
      'yoke flange', 'terex yoke flange', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5513
  {
    id: 'ASGP-5513',
    name: 'Terex U.J. Cross Rear',
    partNumber: 'ASGP-5513',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4515_qmeztz.webp'],
    description: 'Universal joint (UJ) cross for rear of Terex machinery. Provides flexible torque transmission.',
    specifications: { Type: 'UJ Cross', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['UJ Cross Rear', 'Universal Joint', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5513', 'ASGP-5513', 'asgp5513', 'ASGP5513',
      'uj cross rear', 'terex uj cross', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5514
  {
    id: 'ASGP-5514',
    name: 'Terex Pump Flange 4 Hole (Parker)',
    partNumber: 'ASGP-5514',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4516_jzj337.webp'],
    description: 'Pump flange 4 hole (Parker) for Terex machinery. Ensures proper hydraulic fluid transfer.',
    specifications: { Type: 'Pump Flange', Application: 'Terex', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Pump Flange', 'Parker', 'Terex', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5514', 'ASGP-5514', 'asgp5514', 'ASGP5514',
      'pump flange', 'pump flange parker', 'terex pump flange', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5515
  {
    id: 'ASGP-5515',
    name: 'Terex 4WD Annulus Ring',
    partNumber: 'ASGP-5515',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6194925M1'],
    compatibility: [],
    images: ['asgp4009_fvrybs.webp'],
    description: 'Annulus ring for Terex 4WD machinery. Supports planetary gear system in 4WD configuration.',
    specifications: { Type: 'Annulus Ring', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Annulus Ring', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5515', 'ASGP-5515', 'asgp5515', 'ASGP5515', '6194925M1',
      'annulus ring', 'terex 4wd annulus ring', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5516
  {
    id: 'ASGP-5516',
    name: 'Terex 4WD Annulus Carrier',
    partNumber: 'ASGP-5516',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6194924M1'],
    compatibility: [],
    images: ['asgp4518_wpvlfu.webp'],
    description: 'Annulus carrier for Terex 4WD machinery. Ensures proper planetary gear operation.',
    specifications: { Type: 'Annulus Carrier', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Annulus Carrier', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5516', 'ASGP-5516', 'asgp5516', 'ASGP5516', '6194924M1',
      'annulus carrier', 'terex 4wd annulus carrier', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5517
  {
    id: 'ASGP-5517',
    name: 'Terex 4WD Planet Gear',
    partNumber: 'ASGP-5517',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6194930M1'],
    compatibility: [],
    images: ['asgp4519-2_ck5xpo.webp'],
    description: 'Planet gear for Terex 4WD machinery. Ensures torque distribution in planetary gear system.',
    specifications: { Type: 'Planet Gear', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Planet Gear', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5517', 'ASGP-5517', 'asgp5517', 'ASGP5517', '6194930M1',
      'planet gear', 'terex 4wd planet gear', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5518
  {
    id: 'ASGP-5518',
    name: 'Terex 4WD Planet Bearing',
    partNumber: 'ASGP-5518',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6193417M1'],
    compatibility: [],
    images: ['asgp4504_xt4fef.webp'],
    description: 'Planet bearing for Terex 4WD machinery. Supports smooth rotation in planetary gear system.',
    specifications: { Type: 'Planet Bearing', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Planet Bearing', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5518', 'ASGP-5518', 'asgp5518', 'ASGP5518', '6193417M1',
      'planet bearing', 'terex 4wd planet bearing', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5519
  {
    id: 'ASGP-5519',
    name: 'Terex 4WD Sun Yoke',
    partNumber: 'ASGP-5519',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6194916M1'],
    compatibility: [],
    images: ['asgp4521_yrxacz.webp'],
    description: 'Sun yoke for Terex 4WD machinery. Provides stable connection for planetary gear rotation.',
    specifications: { Type: 'Sun Yoke', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Sun Yoke', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5519', 'ASGP-5519', 'asgp5519', 'ASGP5519', '6194916M1',
      'sun yoke', 'terex 4wd sun yoke', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5520
  {
    id: 'ASGP-5520',
    name: 'Terex 4WD Bevel Gear Kit',
    partNumber: 'ASGP-5520',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4522_aucwm0.webp'],
    description: 'Bevel gear kit for Terex 4WD machinery. Ensures proper torque transfer in drivetrain.',
    specifications: { Type: 'Bevel Gear Kit', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Bevel Gear Kit', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5520', 'ASGP-5520', 'asgp5520', 'ASGP5520',
      'bevel gear kit', 'terex 4wd bevel gear kit', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5521
  {
    id: 'ASGP-5521',
    name: 'Terex 4WD Prop Shaft',
    partNumber: 'ASGP-5521',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4523_qeexj5.webp'],
    description: 'Propeller shaft for Terex 4WD machinery. Transfers torque from gearbox to axle.',
    specifications: { Type: 'Prop Shaft', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Prop Shaft', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5521', 'ASGP-5521', 'asgp5521', 'ASGP5521',
      'prop shaft', 'terex 4wd prop shaft', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5522
  {
    id: 'ASGP-5522',
    name: 'Terex 4WD Prop Shaft Half',
    partNumber: 'ASGP-5522',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4524_o9iug4.webp'],
    description: 'Propeller shaft half for Terex 4WD machinery. Ensures smooth torque transmission in segmented driveshafts.',
    specifications: { Type: 'Prop Shaft Half', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Prop Shaft Half', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5522', 'ASGP-5522', 'asgp5522', 'ASGP5522',
      'prop shaft half', 'terex 4wd prop shaft half', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5523
  {
    id: 'ASGP-5523',
    name: 'Terex 4WD Trunnion Set',
    partNumber: 'ASGP-5523',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: ['6190565M1', '6190566M1'],
    compatibility: [],
    images: ['asgp4525_xdbf2s.webp'],
    description: 'Trunnion set for Terex 4WD machinery. Provides support for planetary gear rotation.',
    specifications: { Type: 'Trunnion Set', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Trunnion Set', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5523', 'ASGP-5523', 'asgp5523', 'ASGP5523', '6190565M1', '6190566M1',
      'trunnion set', 'terex 4wd trunnion set', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5524
  {
    id: 'ASGP-5524',
    name: 'Terex 4WD Trunnion Bush',
    partNumber: 'ASGP-5524',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4527_qmrotc.webp'],
    description: 'Trunnion bush for Terex 4WD machinery. Supports trunnion pins in planetary gear assembly.',
    specifications: { Type: 'Trunnion Bush', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Trunnion Bush', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5524', 'ASGP-5524', 'asgp5524', 'ASGP5524',
      'trunnion bush', 'terex 4wd trunnion bush', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5525
  {
    id: 'ASGP-5525',
    name: 'Terex 4WD Trunnion Bearing',
    partNumber: 'ASGP-5525',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4529_qe6na2.webp'],
    description: 'Trunnion bearing for Terex 4WD machinery. Ensures smooth rotation and support for trunnion pins.',
    specifications: { Type: 'Trunnion Bearing', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['Trunnion Bearing', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5525', 'ASGP-5525', 'asgp5525', 'ASGP5525',
      'trunnion bearing', 'terex 4wd trunnion bearing', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5526
  {
    id: 'ASGP-5526',
    name: 'Terex 4WD Cross Holder',
    partNumber: 'ASGP-5526',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    images: ['asgp4049_tsmydb.webp'],
    description: 'Cross holder for Terex 4WD machinery. Supports universal joint assembly for torque transfer.',
    specifications: { Type: 'Cross Holder', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    oeReference: ['6194915M1'],
    compatibility: ['Terex 4WD'],
    tags: ['Cross Holder', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5526', 'ASGP-5526', 'asgp5526', 'ASGP5526', '6194915M1',
      'cross holder', 'terex 4wd cross holder', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },

  // ASGP-5527
  {
    id: 'ASGP-5527',
    name: 'Terex 4WD U.J. Cross',
    partNumber: 'ASGP-5527',
    machine: 'terex',
    category: '4',
    price: 0,
    featured: false,
    oeReference: [],
    compatibility: [],
    images: ['asgp4053_g0pnsk.webp'],
    description: 'Universal joint (U.J.) cross for Terex 4WD machinery. Provides flexibility in torque transmission.',
    specifications: { Type: 'UJ Cross', Application: 'Terex 4WD', Material: 'Steel', Features: 'Durable, OEM Replacement' },
    tags: ['UJ Cross', 'Terex', '4WD', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'asgp-5527', 'ASGP-5527', 'asgp5527', 'ASGP5527',
      'uj cross', 'terex 4wd uj cross', 'terex machinery', 'oem replacement', 'heavy machinery'
    ]
  },




  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  //Hydraulic Seal kits



  ///JCB ---------------------------------------------------------------------------------
  // ASHS-6001
  {
    id: 'ASHS-6001',
    name: 'JCB 3DX Boom Kit',
    partNumber: 'ASHS-6001',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    oeReference: ['550/42854', '550/42085'],
    compatibility: ['JCB 3DX Backhoe Loader'],
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'High-quality boom kit for JCB 3DX backhoe loader. Ensures strength and reliability for heavy-duty operations.',
    specifications: {
      Type: 'Boom Kit', Application: 'JCB 3DX', Features: 'Durable, OEM Replacement, Heavy-Duty'
    },
    tags: ['Boom Kit', 'JCB 3DX', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6001', 'ASHS-6001', 'ashs6001', 'jcb 3dx boom kit', '550/42854', '42085', 'jcb 3dx', 'boom kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6002
  {
    id: 'ASHS-6002',
    name: 'JCB 3DX Arm/Dipper Kit',
    partNumber: 'ASHS-6002',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'High-quality arm/dipper kit for JCB 3DX backhoe loader. Ensures strength and reliable operation under heavy loads.',
    specifications: { Type: 'Arm/Dipper Kit', Application: 'JCB 3DX', Material: 'Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['550/42847', '42098'],
    compatibility: ['JCB 3DX Backhoe Loader'],
    tags: ['Arm/Dipper Kit', 'JCB 3DX', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6002', 'ASHS-6002', 'ashs6002', 'jcb 3dx arm/dipper kit', '550/42847', '42098', 'jcb 3dx', 'arm/dipper kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6003
  {
    id: 'ASHS-6003',
    name: 'JCB 3DX Bucket Kit',
    partNumber: 'ASHS-6003',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'High-quality bucket kit for JCB 3DX backhoe loader. Provides durability and precise operation under heavy-duty conditions.',
    specifications: { Type: 'Bucket Kit', Application: 'JCB 3DX', Material: 'Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['550/42855', '42112'],
    compatibility: ['JCB 3DX Backhoe Loader'],
    tags: ['Bucket Kit', 'JCB 3DX', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6003', 'ASHS-6003', 'ashs6003', 'jcb 3dx bucket kit', '550/42855', '42112', 'jcb 3dx', 'bucket kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6004
  {
    id: 'ASHS-6004',
    name: 'JCB 3DX Slew Kit',
    partNumber: 'ASHS-6004',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'High-quality slew kit for JCB 3DX backhoe loader. Ensures smooth rotation and heavy-duty reliability.',
    specifications: { Type: 'Slew Kit', Application: 'JCB 3DX', Material: 'Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['550/41004'],
    compatibility: ['JCB 3DX Backhoe Loader'],
    tags: ['Slew Kit', 'JCB 3DX', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6004', 'ASHS-6004', 'ashs6004', 'jcb 3dx slew kit', '550/41004', 'jcb 3dx', 'slew kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6005
  {
    id: 'ASHS-6005',
    name: 'JCB 3DX Tilt/Shovel Kit',
    partNumber: 'ASHS-6005',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'High-quality tilt/shovel kit for JCB 3DX backhoe loader. Ensures precise tilting and reliable heavy-duty operation.',
    specifications: { Type: 'Tilt/Shovel Kit', Application: 'JCB 3DX', Material: 'Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['550/42835'],
    compatibility: ['JCB 3DX Backhoe Loader'],
    tags: ['Tilt/Shovel Kit', 'JCB 3DX', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6005', 'ASHS-6005', 'ashs6005', 'jcb 3dx tilt/shovel kit', '550/42835', 'jcb 3dx', 'tilt/shovel kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6006
  {
    id: 'ASHS-6006',
    name: 'JCB 3DX Lift Kit',
    partNumber: 'ASHS-6006',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'High-quality lift kit for JCB 3DX backhoe loader. Provides strong lifting performance and reliability.',
    specifications: { Type: 'Lift Kit', Application: 'JCB 3DX', Material: 'Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['550/42842'],
    compatibility: ['JCB 3DX Backhoe Loader'],
    tags: ['Lift Kit', 'JCB 3DX', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6006', 'ASHS-6006', 'ashs6006', 'jcb 3dx lift kit', '550/42842', 'jcb 3dx', 'lift kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6007
  {
    id: 'ASHS-6007',
    name: 'JCB 3DX Stabilizer Kit',
    partNumber: 'ASHS-6007',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Durable stabilizer kit for JCB 3DX. Provides stability and reliability during excavation operations.',
    specifications: { Type: 'Stabilizer Kit', Application: 'JCB 3DX', Material: 'Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['550/42849'],
    compatibility: ['JCB 3DX Backhoe Loader'],
    tags: ['Stabilizer Kit', 'JCB 3DX', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6007', 'ASHS-6007', 'ashs6007', 'jcb 3dx stabilizer kit', '550/42849', 'jcb 3dx', 'stabilizer kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6008
  {
    id: 'ASHS-6008',
    name: 'JCB 3DX Steering Kit',
    partNumber: 'ASHS-6008',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'High-quality steering kit for JCB 3DX. Ensures smooth control and precision steering under heavy-duty conditions.',
    specifications: { Type: 'Steering Kit', Application: 'JCB 3DX', Material: 'Steel', Features: 'Durable, OEM Replacement, Precision Machined' },
    oeReference: ['550/42383'],
    compatibility: ['JCB 3DX Backhoe Loader'],
    tags: ['Steering Kit', 'JCB 3DX', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6008', 'ASHS-6008', 'ashs6008', 'jcb 3dx steering kit', '550/42383', 'jcb 3dx', 'steering kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6009
  {
    id: 'ASHS-6009',
    name: 'JCB 3DX Slew Kit',
    partNumber: 'ASHS-6009',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Slew kit for JCB 3DX designed for durability and smooth rotation under demanding work conditions.',
    specifications: { Type: 'Slew Kit', Application: 'JCB 3DX', Material: 'Steel', Features: 'Durable, OEM Replacement, Smooth Operation' },
    oeReference: ['550/42261'],
    compatibility: ['JCB 3DX Backhoe Loader'],
    tags: ['Slew Kit', 'JCB 3DX', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6009', 'ASHS-6009', 'ashs6009', 'jcb 3dx slew kit', '550/42261', 'jcb 3dx', 'slew kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6010
  {
    id: 'ASHS-6010',
    name: 'JCB 3DX 2008 Stabilizer Kit',
    partNumber: 'ASHS-6010',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Stabilizer kit for JCB 3DX 2008 model. Provides solid stability and performance in heavy-duty use.',
    specifications: { Type: 'Stabilizer Kit', Application: 'JCB 3DX 2008', Material: 'Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['332/Y3519', '5599'],
    compatibility: ['JCB 3DX 2008 Backhoe Loader'],
    tags: ['Stabilizer Kit', 'JCB 3DX 2008', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6010', 'ASHS-6010', 'ashs6010', 'jcb 3dx 2008 stab kit', '332/Y3519', '5599', 'jcb 3dx', 'stabilizer kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6011
  {
    id: 'ASHS-6011',
    name: 'JCB 3DX 2008 Lift Kit',
    partNumber: 'ASHS-6011',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'High-quality lift kit designed for JCB 3DX 2008 model backhoe loader.',
    specifications: { Type: 'Lift Kit', Application: 'JCB 3DX 2008', Material: 'Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['332/Y2186', '43774'],
    compatibility: ['JCB 3DX 2008 Backhoe Loader'],
    tags: ['Lift Kit', 'JCB 3DX 2008', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6011', 'ASHS-6011', 'ashs6011', 'jcb 3dx 2008 lift kit', '332/Y2186', '43774', 'jcb 3dx', 'lift kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6012
  {
    id: 'ASHS-6012',
    name: 'JCB 3DX 2011 Boom Kit',
    partNumber: 'ASHS-6012',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'OEM-quality boom kit for JCB 3DX 2011 backhoe loader. Built for strength and long service life.',
    specifications: { Type: 'Boom Kit', Application: 'JCB 3DX 2011', Material: 'Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['332/Y6440', '6954'],
    compatibility: ['JCB 3DX 2011 Backhoe Loader'],
    tags: ['Boom Kit', 'JCB 3DX 2011', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6012', 'ASHS-6012', 'ashs6012', 'jcb 3dx 2011 boom kit', '332/Y6440', '6954', 'jcb 3dx', 'boom kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6013
  {
    id: 'ASHS-6013',
    name: 'JCB 3DX 2011 Arm/Dipper Kit',
    partNumber: 'ASHS-6013',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Heavy-duty arm/dipper kit for JCB 3DX 2011 model, providing excellent strength and precision.',
    specifications: { Type: 'Arm/Dipper Kit', Application: 'JCB 3DX 2011', Material: 'Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['332/Y6462'],
    compatibility: ['JCB 3DX 2011 Backhoe Loader'],
    tags: ['Arm/Dipper Kit', 'JCB 3DX 2011', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6013', 'ASHS-6013', 'ashs6013', 'jcb 3dx 2011 arm kit', '332/Y6462', 'jcb 3dx', 'arm/dipper kit', 'heavy machinery', 'oem replacement']
  },

  // ASHS-6014
  {
    id: 'ASHS-6014',
    name: 'JCB 3DX 2011 Bucket Kit',
    partNumber: 'ASHS-6014',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Durable bucket kit for JCB 3DX 2011 model. Provides smooth operation and reliability in heavy-duty digging applications.',
    specifications: { Type: 'Bucket Kit', Application: 'JCB 3DX 2011 Model', Material: 'Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['332/Y6519'],
    compatibility: ['JCB 3DX 2011 Backhoe Loader'],
    tags: ['Bucket Kit', 'JCB 3DX 2011', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6014', 'ASHS-6014', 'ashs6014', 'jcb 3dx 2011 bucket kit', '332/Y6519', 'bucket hydraulic kit', 'backhoe loader']
  },

  // ASHS-6015
  {
    id: 'ASHS-6015',
    name: 'JCB 3DX 2011 Tilt Kit',
    partNumber: 'ASHS-6015',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'High-performance tilt kit for JCB 3DX 2011 backhoe loader. Ensures smooth hydraulic function and control.',
    specifications: { Type: 'Tilt Kit', Application: 'JCB 3DX 2011 Model', Material: 'Steel', Features: 'Durable, OEM Fit, Precision Machined' },
    oeReference: ['332/Y3543'],
    compatibility: ['JCB 3DX 2011 Backhoe Loader'],
    tags: ['Tilt Kit', 'JCB 3DX 2011', 'OEM Replacement', 'Hydraulic Kit'],
    references: ['ashs-6015', 'ASHS-6015', 'ashs6015', 'jcb 3dx 2011 tilt kit', '332/Y3543', 'tilt hydraulic kit', 'backhoe loader']
  },

  // ASHS-6016
  {
    id: 'ASHS-6016',
    name: 'JCB 3DX 2013 Steering Kit',
    partNumber: 'ASHS-6016',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Reliable steering kit for JCB 3DX 2013 model. Ensures smooth and precise control for all terrains.',
    specifications: { Type: 'Steering Kit', Application: 'JCB 3DX 2013 Model', Material: 'Steel', Features: 'Heavy-Duty, Long-lasting, OEM Fit' },
    oeReference: ['332/Y9235', '332/0302'],
    compatibility: ['JCB 3DX 2013 Backhoe Loader'],
    tags: ['Steering Kit', 'JCB 3DX 2013', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6016', 'ASHS-6016', 'ashs6016', 'jcb 3dx 2013 steering kit', '332/Y9235', '332/0302', 'hydraulic steering kit', 'backhoe loader']
  },

  // ASHS-6017
  {
    id: 'ASHS-6017',
    name: 'JCB 3DX XTRA Boom Kit',
    partNumber: 'ASHS-6017',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Heavy-duty boom kit for JCB 3DX XTRA model. Built for strength and durability in demanding applications.',
    specifications: { Type: 'Boom Kit', Application: 'JCB 3DX XTRA', Material: 'Steel', Features: 'Durable, OEM Replacement, Long Life' },
    oeReference: ['336/F1981'],
    compatibility: ['JCB 3DX XTRA Backhoe Loader'],
    tags: ['Boom Kit', 'JCB 3DX XTRA', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6017', 'ASHS-6017', 'ashs6017', 'jcb 3dx xtra boom kit', '336/F1981', 'boom hydraulic kit', 'backhoe loader']
  },

  // ASHS-6018
  {
    id: 'ASHS-6018',
    name: 'JCB 3DX XTRA Arm Kit',
    partNumber: 'ASHS-6018',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Durable arm kit for JCB 3DX XTRA backhoe loader. Provides smooth performance and high strength.',
    specifications: { Type: 'Arm Kit', Application: 'JCB 3DX XTRA', Material: 'Steel', Features: 'OEM Replacement, Durable, Heavy-Duty' },
    oeReference: ['336/E8026'],
    compatibility: ['JCB 3DX XTRA Backhoe Loader'],
    tags: ['Arm Kit', 'JCB 3DX XTRA', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6018', 'ASHS-6018', 'ashs6018', 'jcb 3dx xtra arm kit', '336/E8026', 'arm hydraulic kit', 'dipper kit', 'backhoe loader']
  },

  // ASHS-6019
  {
    id: 'ASHS-6019',
    name: 'JCB 3DX XTRA Bucket Kit',
    partNumber: 'ASHS-6019',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'High-quality bucket kit for JCB 3DX XTRA. Designed for performance and long life in rugged applications.',
    specifications: { Type: 'Bucket Kit', Application: 'JCB 3DX XTRA', Material: 'Steel', Features: 'Durable, OEM Fit, Heavy-Duty' },
    oeReference: ['336/F3940'],
    compatibility: ['JCB 3DX XTRA Backhoe Loader'],
    tags: ['Bucket Kit', 'JCB 3DX XTRA', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6019', 'ASHS-6019', 'ashs6019', 'jcb 3dx xtra bucket kit', '336/F3940', 'backhoe loader', 'heavy machinery']
  },

  // ASHS-6020
  {
    id: 'ASHS-6020',
    name: 'JCB 3DX XTRA Tilt Kit',
    partNumber: 'ASHS-6020',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Precise tilt kit for JCB 3DX XTRA. Ensures smooth hydraulic tilt operation under heavy load conditions.',
    specifications: { Type: 'Tilt Kit', Application: 'JCB 3DX XTRA', Material: 'Steel', Features: 'Durable, OEM Fit, Heavy-Duty' },
    oeReference: ['336/F6230'],
    compatibility: ['JCB 3DX XTRA Backhoe Loader'],
    tags: ['Tilt Kit', 'JCB 3DX XTRA', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6020', 'ASHS-6020', 'ashs6020', 'jcb 3dx xtra tilt kit', '336/F6230', 'backhoe loader', 'hydraulic kit']
  },

  // ASHS-6021
  {
    id: 'ASHS-6021',
    name: 'JCB 3DX XTRA Lift Kit',
    partNumber: 'ASHS-6021',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Lift kit for JCB 3DX XTRA. Provides strong lifting capacity and reliable operation.',
    specifications: { Type: 'Lift Kit', Application: 'JCB 3DX XTRA', Material: 'Steel', Features: 'Durable, Heavy-Duty, OEM Replacement' },
    oeReference: ['336/F8020'],
    compatibility: ['JCB 3DX XTRA Backhoe Loader'],
    tags: ['Lift Kit', 'JCB 3DX XTRA', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6021', 'ASHS-6021', 'ashs6021', 'jcb 3dx xtra lift kit', '336/F8020', 'backhoe loader', 'hydraulic kit']
  },

  // ASHS-6022
  {
    id: 'ASHS-6022',
    name: 'JCB 3DX XTRA Stabilizer Kit',
    partNumber: 'ASHS-6022',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Stabilizer kit for JCB 3DX XTRA. Ensures stability and precision during excavation and lifting.',
    specifications: { Type: 'Stabilizer Kit', Application: 'JCB 3DX XTRA', Material: 'Steel', Features: 'Durable, OEM Fit, Heavy-Duty' },
    oeReference: ['336/F9122'],
    compatibility: ['JCB 3DX XTRA Backhoe Loader'],
    tags: ['Stabilizer Kit', 'JCB 3DX XTRA', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6022', 'ASHS-6022', 'ashs6022', 'jcb 3dx xtra stabilizer kit', '336/F9122', 'backhoe loader', 'heavy machinery']
  },

  // ASHS-6023
  {
    id: 'ASHS-6023',
    name: 'JCB 3DX XTRA Steering Kit',
    partNumber: 'ASHS-6023',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Heavy-duty steering kit for JCB 3DX XTRA. Ensures precise and smooth steering control.',
    specifications: { Type: 'Steering Kit', Application: 'JCB 3DX XTRA', Material: 'Steel', Features: 'Durable, OEM Fit, Heavy-Duty' },
    oeReference: ['336/G1234'],
    compatibility: ['JCB 3DX XTRA Backhoe Loader'],
    tags: ['Steering Kit', 'JCB 3DX XTRA', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6023', 'ASHS-6023', 'ashs6023', 'jcb 3dx xtra steering kit', '336/G1234', 'backhoe loader', 'hydraulic kit']
  },

  // ASHS-6024
  {
    id: 'ASHS-6024',
    name: 'JCB 3DX XTRA Boom Arm Kit',
    partNumber: 'ASHS-6024',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Combined boom and arm kit for JCB 3DX XTRA. Perfect fit for heavy-duty operations.',
    specifications: { Type: 'Boom/Arm Kit', Application: 'JCB 3DX XTRA', Material: 'Steel', Features: 'OEM Fit, Durable, Heavy-Duty' },
    oeReference: ['336/G5678'],
    compatibility: ['JCB 3DX XTRA Backhoe Loader'],
    tags: ['Boom/Arm Kit', 'JCB 3DX XTRA', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6024', 'ASHS-6024', 'ashs6024', 'jcb 3dx xtra boom arm kit', '336/G5678', 'backhoe loader', 'hydraulic kit']
  },

  // ASHS-6025
  {
    id: 'ASHS-6025',
    name: 'JCB 3DX XTRA Bucket Arm Kit',
    partNumber: 'ASHS-6025',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Bucket and arm kit for JCB 3DX XTRA ensuring high performance and durability.',
    specifications: { Type: 'Bucket/Arm Kit', Application: 'JCB 3DX XTRA', Material: 'Steel', Features: 'OEM Fit, Durable, Heavy-Duty' },
    oeReference: ['336/H9012'],
    compatibility: ['JCB 3DX XTRA Backhoe Loader'],
    tags: ['Bucket/Arm Kit', 'JCB 3DX XTRA', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6025', 'ASHS-6025', 'ashs6025', 'jcb 3dx xtra bucket arm kit', '336/H9012', 'backhoe loader', 'hydraulic kit']
  },

  // ASHS-6026
  {
    id: 'ASHS-6026',
    name: 'JCB 3DX XTRA Dipper Kit',
    partNumber: 'ASHS-6026',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Dipper kit for JCB 3DX XTRA, built to last under heavy usage and rugged conditions.',
    specifications: { Type: 'Dipper Kit', Application: 'JCB 3DX XTRA', Material: 'Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['336/I3456'],
    compatibility: ['JCB 3DX XTRA Backhoe Loader'],
    tags: ['Dipper Kit', 'JCB 3DX XTRA', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6026', 'ASHS-6026', 'ashs6026', 'jcb 3dx xtra dipper kit', '336/I3456', 'backhoe loader', 'heavy machinery']
  },

  // ASHS-6027
  {
    id: 'ASHS-6027',
    name: 'JCB 3DX XTRA Arm Cylinder Kit',
    partNumber: 'ASHS-6027',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Arm cylinder kit for JCB 3DX XTRA ensuring smooth hydraulic operation and durability.',
    specifications: { Type: 'Cylinder Kit', Application: 'JCB 3DX XTRA', Material: 'Steel', Features: 'OEM Replacement, Heavy-Duty' },
    oeReference: ['336/J6789'],
    compatibility: ['JCB 3DX XTRA Backhoe Loader'],
    tags: ['Arm Cylinder Kit', 'JCB 3DX XTRA', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6027', 'ASHS-6027', 'ashs6027', 'jcb 3dx xtra arm cylinder kit', '336/J6789', 'backhoe loader', 'hydraulic kit']
  },

  // ASHS-6028
  {
    id: 'ASHS-6028',
    name: 'JCB 3DX Eco Tilt Cylinder Kit',
    partNumber: 'ASHS-6028',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Tilt cylinder kit for JCB 3DX Eco ensuring high durability and smooth operation.',
    specifications: { Type: 'Cylinder Kit', Application: 'JCB 3DX Eco', Features: 'OEM Replacement, Heavy-Duty' },
    oeReference: ['336/F1483'],
    compatibility: ['JCB 3DX Eco Backhoe Loader'],
    tags: ['Tilt Cylinder Kit', 'JCB 3DX Eco', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6028', 'ASHS-6028', 'ashs6028', 'jcb 3dx exo tilt cylinder kit', '336/f1486', 'backhoe loader', 'hydraulic kit']
  },

  // ASHS-6029
  {
    id: 'ASHS-6029',
    name: 'JCB 3DX Eco Lift Cylinder Kit',
    partNumber: 'ASHS-6029',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Lift cylinder kit for JCB 3DX Eco, ensures precise operation and durability.',
    specifications: { Type: 'Cylinder Kit', Application: 'JCB 3DX Eco', Features: 'OEM Replacement, Heavy-Duty' },
    oeReference: ['336/F1486'],
    compatibility: ['JCB 3DX Eco Backhoe Loader'],
    tags: ['Lift Cylinder Kit', 'JCB 3DX Eco', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6029', 'ASHS-6029', 'ashs6029', 'jcb 3dx eco lift cylinder kit', '336/F1486', 'backhoe loader', 'hydraulic kit']
  },

  // ASHS-6030
  {
    id: 'ASHS-6030',
    name: 'JCB 3DX Eco Steering Kit',
    partNumber: 'ASHS-6030',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Steering kit for JCB 3DX Eco, ensures smooth steering operation and heavy-duty reliability.',
    specifications: { Type: 'Cylinder Kit', Application: 'JCB 3DX XTRA', Features: 'Durable, OEM Fit, Heavy-Duty' },
    oeReference: ['336/F2141'],
    compatibility: ['JCB 3DX Eco Backhoe Loader'],
    tags: ['Steering Kit', 'JCB 3DX Eco', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6030', 'ASHS-6030', 'ashs6030', 'jcb 3dx eco steering kit', '336/F2141', 'backhoe loader', 'hydraulic kit']
  },

  // ASHS-6031
  {
    id: 'ASHS-6031',
    name: 'JCB 3CX Steering Kit',
    partNumber: 'ASHS-6031',
    machine: 'jcb',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Steering kit for JCB 3CX, providing precision, durability, and OEM-quality performance.',
    specifications: { Type: 'Steering Kit', Application: 'JCB 3CX', Features: 'Durable, OEM Fit, Heavy-Duty' },
    oeReference: ['991/00156'],
    compatibility: ['JCB 3CX Backhoe Loader'],
    tags: ['Steering Kit', 'JCB 3CX', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-6031', 'ASHS-6031', 'ashs6031', 'jcb 3cx steering kit', '991/00156', 'backhoe loader', 'hydraulic kit']
  },



  //Escorts ---------------------------------------------------------------------------------
  // ASHS-6501
  {
    id: 'ASHS-6501',
    name: 'ESCORTS Digimax Boom Kit W',
    partNumber: 'ASHS-6501',
    machine: 'escorts',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'High-quality boom kit (W variant) for Escorts Digimax backhoe loader. Built for strength and durability under demanding operations.',
    specifications: {
      Type: 'Boom Kit',
      Application: 'Escorts Digimax W',
      Material: 'Steel',
      Features: 'Heavy-Duty, OEM Replacement, Durable'
    },
    oeReference: ['SK7600350'],
    compatibility: ['Escorts Digimax Backhoe Loader (W Version)'],
    tags: ['Boom Kit', 'Escorts Digimax', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-6501', 'ASHS-6501', 'ashs6501', 'escorts digimax boom kit', 'sk7600350', 'boom kit w', 'digimax w', 'hydraulic boom kit', 'backhoe loader']
  },

  // ASHS-6502
  {
    id: 'ASHS-6502',
    name: 'ESCORTS Digimax Swing Kit W',
    partNumber: 'ASHS-6502',
    machine: 'escorts',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Swing kit (W variant) for Escorts Digimax backhoe loader. Ensures reliable and smooth operation.',
    specifications: {
      Type: 'Swing Kit',
      Application: 'Escorts Digimax W',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['SK7600368'],
    compatibility: ['Escorts Digimax Backhoe Loader (W Version)'],
    tags: ['Swing Kit', 'Escorts Digimax', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-6502', 'ASHS-6502', 'ashs6502', 'escorts digimax swing kit', 'sk7600368', 'swing kit w', 'digimax w', 'hydraulic swing kit', 'backhoe loader']
  },

  // ASHS-6503
  {
    id: 'ASHS-6503',
    name: 'ESCORTS Digimax Arm Kit W',
    partNumber: 'ASHS-6503',
    machine: 'escorts',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Arm kit (W variant) for Escorts Digimax backhoe loader. Offers precision and durability for extended use.',
    specifications: {
      Type: 'Arm Kit',
      Application: 'Escorts Digimax W',
      Material: 'Steel',
      Features: 'Heavy-Duty, OEM Quality, Long Life'
    },
    oeReference: ['SK7600367'],
    compatibility: ['Escorts Digimax Backhoe Loader (W Version)'],
    tags: ['Arm Kit', 'Escorts Digimax', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-6503', 'ASHS-6503', 'ashs6503', 'escorts digimax arm kit', 'sk7600367', 'arm kit w', 'digimax w', 'hydraulic arm kit', 'backhoe loader']
  },

  // ASHS-6504
  {
    id: 'ASHS-6504',
    name: 'ESCORTS Digimax Bucket Kit W',
    partNumber: 'ASHS-6504',
    machine: 'escorts',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Bucket kit (W variant) for Escorts Digimax backhoe loader. Built for heavy-duty digging and durability.',
    specifications: {
      Type: 'Bucket Kit',
      Application: 'Escorts Digimax W',
      Material: 'Steel',
      Features: 'Durable, OEM Replacement, Heavy-Duty'
    },
    oeReference: ['SK7600351'],
    compatibility: ['Escorts Digimax Backhoe Loader (W Version)'],
    tags: ['Bucket Kit', 'Escorts Digimax', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-6504', 'ASHS-6504', 'ashs6504', 'escorts digimax bucket kit', 'sk7600351', 'bucket kit w', 'digimax w', 'hydraulic bucket kit', 'backhoe loader']
  },

  // ASHS-6505
  {
    id: 'ASHS-6505',
    name: 'ESCORTS Digimax Lift Kit W',
    partNumber: 'ASHS-6505',
    machine: 'escorts',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Lift kit (W variant) for Escorts Digimax backhoe loader. Ensures efficient lifting and stable performance.',
    specifications: {
      Type: 'Lift Kit',
      Application: 'Escorts Digimax W',
      Material: 'Steel',
      Features: 'OEM Fit, Reliable, Heavy-Duty'
    },
    oeReference: ['SK7600352'],
    compatibility: ['Escorts Digimax Backhoe Loader (W Version)'],
    tags: ['Lift Kit', 'Escorts Digimax', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-6505', 'ASHS-6505', 'ashs6505', 'escorts digimax lift kit', 'sk7600352', 'lift kit w', 'digimax w', 'hydraulic lift kit', 'backhoe loader']
  },

  // ASHS-6506
  {
    id: 'ASHS-6506',
    name: 'ESCORTS Digimax Tilt Kit W',
    partNumber: 'ASHS-6506',
    machine: 'escorts',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Tilt kit (W variant) for Escorts Digimax backhoe loader. Provides smooth and reliable bucket tilting motion.',
    specifications: {
      Type: 'Tilt Kit',
      Application: 'Escorts Digimax W',
      Material: 'Steel',
      Features: 'Durable, OEM Fit, Heavy-Duty'
    },
    oeReference: ['SK7600369'],
    compatibility: ['Escorts Digimax Backhoe Loader (W Version)'],
    tags: ['Tilt Kit', 'Escorts Digimax', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-6506', 'ASHS-6506', 'ashs6506', 'escorts digimax tilt kit', 'sk7600369', 'tilt kit w', 'digimax w', 'hydraulic tilt kit', 'backhoe loader']
  },

  // ASHS-6507
  {
    id: 'ASHS-6507',
    name: 'ESCORTS Digimax Stab Kit W',
    partNumber: 'ASHS-6507',
    machine: 'escorts',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Stabilizer kit (W variant) for Escorts Digimax backhoe loader. Offers superior stability and durability.',
    specifications: {
      Type: 'Stabilizer Kit',
      Application: 'Escorts Digimax W',
      Material: 'Steel',
      Features: 'Heavy-Duty, OEM Quality, Reliable'
    },
    oeReference: ['SK7600371'],
    compatibility: ['Escorts Digimax Backhoe Loader (W Version)'],
    tags: ['Stabilizer Kit', 'Escorts Digimax', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-6507', 'ASHS-6507', 'ashs6507', 'escorts digimax stabilizer kit', 'sk7600371', 'stab kit w', 'digimax w', 'stabilizer hydraulic kit', 'backhoe loader']
  },

  // ASHS-6508
  {
    id: 'ASHS-6508',
    name: 'ESCORTS Digimax Boom Kit D',
    partNumber: 'ASHS-6508',
    machine: 'escorts',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Boom kit (D variant) for Escorts Digimax backhoe loader. Designed for long-lasting heavy-duty use.',
    specifications: {
      Type: 'Boom Kit',
      Application: 'Escorts Digimax D',
      Material: 'Steel',
      Features: 'Durable, OEM Replacement, Heavy-Duty'
    },
    oeReference: ['SK7601150'],
    compatibility: ['Escorts Digimax Backhoe Loader (D Version)'],
    tags: ['Boom Kit', 'Escorts Digimax', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-6508', 'ASHS-6508', 'ashs6508', 'escorts digimax boom kit', 'sk7601150', 'boom kit d', 'digimax d', 'hydraulic boom kit', 'backhoe loader']
  },

  // ASHS-6509
  {
    id: 'ASHS-6509',
    name: 'ESCORTS Digimax Swing Kit D',
    partNumber: 'ASHS-6509',
    machine: 'escorts',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Swing kit (D variant) for Escorts Digimax backhoe loader. Delivers consistent performance and reliability.',
    specifications: {
      Type: 'Swing Kit',
      Application: 'Escorts Digimax D',
      Material: 'Steel',
      Features: 'Heavy-Duty, OEM Fit, Durable'
    },
    oeReference: ['SK7601154'],
    compatibility: ['Escorts Digimax Backhoe Loader (D Version)'],
    tags: ['Swing Kit', 'Escorts Digimax', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-6509', 'ASHS-6509', 'ashs6509', 'escorts digimax swing kit', 'sk7601154', 'swing kit d', 'digimax d', 'hydraulic swing kit', 'backhoe loader']
  },

  // ASHS-6510
  {
    id: 'ASHS-6510',
    name: 'ESCORTS Digimax Bucket Kit D',
    partNumber: 'ASHS-6510',
    machine: 'escorts',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Bucket kit (D variant) for Escorts Digimax backhoe loader. Designed for efficient digging and extended lifespan.',
    specifications: {
      Type: 'Bucket Kit',
      Application: 'Escorts Digimax D',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['SK7601156'],
    compatibility: ['Escorts Digimax Backhoe Loader (D Version)'],
    tags: ['Bucket Kit', 'Escorts Digimax', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-6510', 'ASHS-6510', 'ashs6510', 'escorts digimax bucket kit', 'sk7601156', 'bucket kit d', 'digimax d', 'hydraulic bucket kit', 'backhoe loader']
  },

  // ASHS-6511
  {
    id: 'ASHS-6511',
    name: 'ESCORTS Digimax Tilt Kit D',
    partNumber: 'ASHS-6511',
    machine: 'escorts',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Tilt kit (D variant) for Escorts Digimax backhoe loader. Provides smooth operation and long-term reliability.',
    specifications: {
      Type: 'Tilt Kit',
      Application: 'Escorts Digimax D',
      Material: 'Steel',
      Features: 'Durable, OEM Quality, Heavy-Duty'
    },
    oeReference: ['SK7601151'],
    compatibility: ['Escorts Digimax Backhoe Loader (D Version)'],
    tags: ['Tilt Kit', 'Escorts Digimax', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-6511', 'ASHS-6511', 'ashs6511', 'escorts digimax tilt kit', 'sk7601151', 'tilt kit d', 'digimax d', 'hydraulic tilt kit', 'backhoe loader']
  },

  // ASHS-6512
  {
    id: 'ASHS-6512',
    name: 'ESCORTS Digimax Steering Kit D',
    partNumber: 'ASHS-6512',
    machine: 'escorts',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Steering kit (D variant) for Escorts Digimax backhoe loader. Offers precise steering performance and durability.',
    specifications: {
      Type: 'Steering Kit',
      Application: 'Escorts Digimax D',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['SK7601152'],
    compatibility: ['Escorts Digimax Backhoe Loader (D Version)'],
    tags: ['Steering Kit', 'Escorts Digimax', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-6512', 'ASHS-6512', 'ashs6512', 'escorts digimax steering kit', 'sk7601152', 'steering kit d', 'digimax d', 'hydraulic steering kit', 'backhoe loader']
  },




  //Mahindra ------------------------------------------------------------------------------------------
  // ASHS-7001
  {
    id: 'ASHS-7001',
    name: 'Mahindra Earthmaster Boom Kit W',
    partNumber: 'ASHS-7001',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Boom kit (W variant) for Mahindra Earthmaster backhoe loader. Designed for superior strength and long service life.',
    specifications: {
      Type: 'Boom Kit',
      Application: 'Mahindra Earthmaster W',
      Material: 'Steel',
      Features: 'Heavy-Duty, OEM Replacement, Durable'
    },
    oeReference: ['SSP8373-0010N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (W Version)'],
    tags: ['Boom Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-7001', 'ASHS-7001', 'ashs7001', 'mahindra earthmaster boom kit', 'ssp8373-0010n', 'boom kit w', 'earthmaster w', 'backhoe loader', 'hydraulic boom kit']
  },

  // ASHS-7002
  {
    id: 'ASHS-7002',
    name: 'Mahindra Earthmaster Bucket Kit W',
    partNumber: 'ASHS-7002',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Bucket kit (W variant) for Mahindra Earthmaster backhoe loader. Engineered for efficient digging and durability.',
    specifications: {
      Type: 'Bucket Kit',
      Application: 'Mahindra Earthmaster W',
      Material: 'Steel',
      Features: 'OEM Quality, Durable, Heavy-Duty'
    },
    oeReference: ['SSP9416-0030N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (W Version)'],
    tags: ['Bucket Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-7002', 'ASHS-7002', 'ashs7002', 'mahindra earthmaster bucket kit', 'ssp9416-0030n', 'bucket kit w', 'earthmaster w', 'backhoe loader', 'hydraulic bucket kit']
  },

  // ASHS-7003
  {
    id: 'ASHS-7003',
    name: 'Mahindra Earthmaster Arm Kit W',
    partNumber: 'ASHS-7003',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Arm kit (W variant) for Mahindra Earthmaster backhoe loader. Provides reliable performance and long lifespan.',
    specifications: {
      Type: 'Arm Kit',
      Application: 'Mahindra Earthmaster W',
      Material: 'Steel',
      Features: 'Heavy-Duty, OEM Fit, Reliable'
    },
    oeReference: ['SSP9411-0020N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (W Version)'],
    tags: ['Arm Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-7003', 'ASHS-7003', 'ashs7003', 'mahindra earthmaster arm kit', 'ssp9411-0020n', 'arm kit w', 'earthmaster w', 'backhoe loader', 'hydraulic arm kit']
  },

  // ASHS-7004
  {
    id: 'ASHS-7004',
    name: 'Mahindra Earthmaster Slew Kit W',
    partNumber: 'ASHS-7004',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Slew kit (W variant) for Mahindra Earthmaster backhoe loader. Ensures precise and smooth slewing function.',
    specifications: {
      Type: 'Slew Kit',
      Application: 'Mahindra Earthmaster W',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['SSP9417-0050N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (W Version)'],
    tags: ['Slew Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-7004', 'ASHS-7004', 'ashs7004', 'mahindra earthmaster slew kit', 'ssp9417-0050n', 'slew kit w', 'earthmaster w', 'hydraulic slew kit', 'backhoe loader']
  },

  // ASHS-7005
  {
    id: 'ASHS-7005',
    name: 'Mahindra Earthmaster Stab Kit W',
    partNumber: 'ASHS-7005',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Stabilizer kit (W variant) for Mahindra Earthmaster backhoe loader. Provides stability and reliable operation.',
    specifications: {
      Type: 'Stabilizer Kit',
      Application: 'Mahindra Earthmaster W',
      Material: 'Steel',
      Features: 'OEM Replacement, Heavy-Duty, Durable'
    },
    oeReference: ['SSP8248-0040N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (W Version)'],
    tags: ['Stabilizer Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-7005', 'ASHS-7005', 'ashs7005', 'mahindra earthmaster stabilizer kit', 'ssp8248-0040n', 'stab kit w', 'earthmaster w', 'backhoe loader', 'hydraulic stabilizer kit']
  },

  // ASHS-7006
  {
    id: 'ASHS-7006',
    name: 'Mahindra Earthmaster Lift Kit W',
    partNumber: 'ASHS-7006',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Lift kit (W variant) for Mahindra Earthmaster backhoe loader. Ensures powerful lifting and long-term performance.',
    specifications: {
      Type: 'Lift Kit',
      Application: 'Mahindra Earthmaster W',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['SSP8249-0060N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (W Version)'],
    tags: ['Lift Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-7006', 'ASHS-7006', 'ashs7006', 'mahindra earthmaster lift kit', 'ssp8249-0060n', 'lift kit w', 'earthmaster w', 'backhoe loader', 'hydraulic lift kit']
  },

  // ASHS-7007
  {
    id: 'ASHS-7007',
    name: 'Mahindra Earthmaster Tilt Kit W',
    partNumber: 'ASHS-7007',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Tilt kit (W variant) for Mahindra Earthmaster backhoe loader. Provides smooth tilt and reliability.',
    specifications: {
      Type: 'Tilt Kit',
      Application: 'Mahindra Earthmaster W',
      Material: 'Steel',
      Features: 'Heavy-Duty, OEM Quality, Durable'
    },
    oeReference: ['SSP8251-0070N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (W Version)'],
    tags: ['Tilt Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-7007', 'ASHS-7007', 'ashs7007', 'mahindra earthmaster tilt kit', 'ssp8251-0070n', 'tilt kit w', 'earthmaster w', 'backhoe loader', 'hydraulic tilt kit']
  },

  // ASHS-7008
  {
    id: 'ASHS-7008',
    name: 'Mahindra Earthmaster Steering Kit W',
    partNumber: 'ASHS-7008',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Steering kit (W variant) for Mahindra Earthmaster backhoe loader. Ensures smooth and precise steering control.',
    specifications: {
      Type: 'Steering Kit',
      Application: 'Mahindra Earthmaster W',
      Material: 'Steel',
      Features: 'OEM Fit, Reliable, Heavy-Duty'
    },
    oeReference: ['SSP8799-0080N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (W Version)'],
    tags: ['Steering Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'W Version'],
    references: ['ashs-7008', 'ASHS-7008', 'ashs7008', 'mahindra earthmaster steering kit', 'ssp8799-0080n', 'steering kit w', 'earthmaster w', 'backhoe loader', 'hydraulic steering kit']
  },

  // ASHS-7009
  {
    id: 'ASHS-7009',
    name: 'Mahindra Earthmaster Bucket Kit D',
    partNumber: 'ASHS-7009',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Bucket kit (D variant) for Mahindra Earthmaster backhoe loader. Built for durable and efficient performance.',
    specifications: {
      Type: 'Bucket Kit',
      Application: 'Mahindra Earthmaster D',
      Material: 'Steel',
      Features: 'OEM Fit, Heavy-Duty, Reliable'
    },
    oeReference: ['11384-1940N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (D Version)'],
    tags: ['Bucket Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-7009', 'ASHS-7009', 'ashs7009', 'mahindra earthmaster bucket kit', '11384-1940n', 'bucket kit d', 'earthmaster d', 'backhoe loader', 'hydraulic bucket kit']
  },

  // ASHS-7010
  {
    id: 'ASHS-7010',
    name: 'Mahindra Earthmaster Boom Kit D',
    partNumber: 'ASHS-7010',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Boom kit (D variant) for Mahindra Earthmaster backhoe loader. Ensures high strength and reliable operation.',
    specifications: {
      Type: 'Boom Kit',
      Application: 'Mahindra Earthmaster D',
      Material: 'Steel',
      Features: 'OEM Replacement, Heavy-Duty, Durable'
    },
    oeReference: ['11382-1800N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (D Version)'],
    tags: ['Boom Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-7010', 'ASHS-7010', 'ashs7010', 'mahindra earthmaster boom kit', '11382-1800n', 'boom kit d', 'earthmaster d', 'backhoe loader', 'hydraulic boom kit']
  },

  // ASHS-7011
  {
    id: 'ASHS-7011',
    name: 'Mahindra Earthmaster Slew Kit D',
    partNumber: 'ASHS-7011',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Slew kit (D variant) for Mahindra Earthmaster backhoe loader. Provides smooth slewing motion and long service.',
    specifications: {
      Type: 'Slew Kit',
      Application: 'Mahindra Earthmaster D',
      Material: 'Steel',
      Features: 'Durable, OEM Quality, Heavy-Duty'
    },
    oeReference: ['11385-2050N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (D Version)'],
    tags: ['Slew Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-7011', 'ASHS-7011', 'ashs7011', 'mahindra earthmaster slew kit', '11385-2050n', 'slew kit d', 'earthmaster d', 'hydraulic slew kit', 'backhoe loader']
  },

  // ASHS-7012
  {
    id: 'ASHS-7012',
    name: 'Mahindra Earthmaster Steering Kit D',
    partNumber: 'ASHS-7012',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Steering kit (D variant) for Mahindra Earthmaster backhoe loader. Designed for precise steering control.',
    specifications: {
      Type: 'Steering Kit',
      Application: 'Mahindra Earthmaster D',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['11389-2280N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (D Version)'],
    tags: ['Steering Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-7012', 'ASHS-7012', 'ashs7012', 'mahindra earthmaster steering kit', '11389-2280n', 'steering kit d', 'earthmaster d', 'backhoe loader', 'hydraulic steering kit']
  },

  // ASHS-7013
  {
    id: 'ASHS-7013',
    name: 'Mahindra Earthmaster Lift Kit D',
    partNumber: 'ASHS-7013',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Lift kit (D variant) for Mahindra Earthmaster backhoe loader. Ensures strong lifting capacity and long durability.',
    specifications: {
      Type: 'Lift Kit',
      Application: 'Mahindra Earthmaster D',
      Material: 'Steel',
      Features: 'OEM Replacement, Heavy-Duty, Durable'
    },
    oeReference: ['11387-2130N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (D Version)'],
    tags: ['Lift Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-7013', 'ASHS-7013', 'ashs7013', 'mahindra earthmaster lift kit', '11387-2130n', 'lift kit d', 'earthmaster d', 'backhoe loader', 'hydraulic lift kit']
  },

  // ASHS-7014
  {
    id: 'ASHS-7014',
    name: 'Mahindra Earthmaster Arm Kit D',
    partNumber: 'ASHS-7014',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Arm kit (D variant) for Mahindra Earthmaster backhoe loader. Ensures smooth operation and longevity.',
    specifications: {
      Type: 'Arm Kit',
      Application: 'Mahindra Earthmaster D',
      Material: 'Steel',
      Features: 'OEM Quality, Durable, Heavy-Duty'
    },
    oeReference: ['11383-1880N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (D Version)'],
    tags: ['Arm Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-7014', 'ASHS-7014', 'ashs7014', 'mahindra earthmaster arm kit', '11383-1880n', 'arm kit d', 'earthmaster d', 'backhoe loader', 'hydraulic arm kit']
  },

  // ASHS-7015
  {
    id: 'ASHS-7015',
    name: 'Mahindra Earthmaster Stabilizer Kit D',
    partNumber: 'ASHS-7015',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Stabilizer kit (D variant) for Mahindra Earthmaster backhoe loader. Enhances stability and durability.',
    specifications: {
      Type: 'Stabilizer Kit',
      Application: 'Mahindra Earthmaster D',
      Material: 'Steel',
      Features: 'OEM Fit, Heavy-Duty, Durable'
    },
    oeReference: ['11386-2360N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (D Version)'],
    tags: ['Stabilizer Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-7015', 'ASHS-7015', 'ashs7015', 'mahindra earthmaster stabilizer kit', '11386-2360n', 'stab kit d', 'earthmaster d', 'hydraulic stabilizer kit', 'backhoe loader']
  },

  // ASHS-7016
  {
    id: 'ASHS-7016',
    name: 'Mahindra Earthmaster Tilt Kit D',
    partNumber: 'ASHS-7016',
    machine: 'mahindra',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Tilt kit (D variant) for Mahindra Earthmaster backhoe loader. Built for smooth tilt performance and reliability.',
    specifications: {
      Type: 'Tilt Kit',
      Application: 'Mahindra Earthmaster D',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['11388-2190N'],
    compatibility: ['Mahindra Earthmaster Backhoe Loader (D Version)'],
    tags: ['Tilt Kit', 'Mahindra Earthmaster', 'Heavy Duty', 'OEM Replacement', 'D Version'],
    references: ['ashs-7016', 'ASHS-7016', 'ashs7016', 'mahindra earthmaster tilt kit', '11388-2190n', 'tilt kit d', 'earthmaster d', 'backhoe loader', 'hydraulic tilt kit']
  },






  //TEREX -------------------------------------------------------------------------------------------
  // ASHS-7501
  {
    id: 'ASHS-7501',
    name: 'Terex 760 Boom Kit',
    partNumber: 'ASHS-7501',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Boom kit for Terex 760 backhoe loader. Designed for high strength, smooth operation, and extended durability.',
    specifications: {
      Type: 'Boom Kit',
      Application: 'Terex 760',
      Material: 'Steel',
      Features: 'OEM Fit, Heavy-Duty, Reliable'
    },
    oeReference: ['TV-SSP-5087T', 'TV-10X0197'],
    compatibility: ['Terex 760 Backhoe Loader'],
    tags: ['Boom Kit', 'Terex 760', 'Backhoe Loader', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-7501', 'ASHS-7501', 'ashs7501', 'terex 760 boom kit', 'tv-ssp-5087t', '10x0197']
  },

  // ASHS-7502
  {
    id: 'ASHS-7502',
    name: 'Terex 760 Arm Kit',
    partNumber: 'ASHS-7502',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Arm kit for Terex 760 backhoe loader. Provides smooth motion and extended wear life.',
    specifications: {
      Type: 'Arm Kit',
      Application: 'Terex 760',
      Material: 'Steel',
      Features: 'OEM Quality, Heavy-Duty, Durable'
    },
    oeReference: ['TV-SSP-5088T', 'TV-10X0241'],
    compatibility: ['Terex 760 Backhoe Loader'],
    tags: ['Arm Kit', 'Terex 760', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7502', 'ASHS-7502', 'ashs7502', 'terex 760 arm kit', 'tv-ssp-5088t', '10x0241']
  },

  // ASHS-7503
  {
    id: 'ASHS-7503',
    name: 'Terex 760 Bucket Kit',
    partNumber: 'ASHS-7503',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Bucket kit for Terex 760 backhoe loader. Ensures superior digging and wear resistance.',
    specifications: {
      Type: 'Bucket Kit',
      Application: 'Terex 760',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['TV-SSP-5089T', 'TV-10X0175'],
    compatibility: ['Terex 760 Backhoe Loader'],
    tags: ['Bucket Kit', 'Terex 760', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7503', 'ASHS-7503', 'ashs7503', 'terex 760 bucket kit', 'tv-ssp-5089t', '10x0175']
  },

  // ASHS-7504
  {
    id: 'ASHS-7504',
    name: 'Terex 760 Stabilizer Kit',
    partNumber: 'ASHS-7504',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Stabilizer kit for Terex 760 backhoe loader. Offers enhanced stability and long-lasting performance.',
    specifications: {
      Type: 'Stabilizer Kit',
      Application: 'Terex 760',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['TV-SSP-5090T', 'TV-10X0069'],
    compatibility: ['Terex 760 Backhoe Loader'],
    tags: ['Stabilizer Kit', 'Terex 760', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7504', 'ASHS-7504', 'ashs7504', 'terex 760 stab kit', 'tv-ssp-5090t', '10x0069']
  },

  // ASHS-7505
  {
    id: 'ASHS-7505',
    name: 'Terex 760 Lift Kit',
    partNumber: 'ASHS-7505',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Lift kit for Terex 760 backhoe loader. Built for strength and smooth lifting action.',
    specifications: {
      Type: 'Lift Kit',
      Application: 'Terex 760',
      Material: 'Steel',
      Features: 'OEM Quality, Heavy-Duty, Reliable'
    },
    oeReference: ['TV-SSP-6521T', 'TV-SSP-5091T', 'TV-10X0220'],
    compatibility: ['Terex 760 Backhoe Loader'],
    tags: ['Lift Kit', 'Terex 760', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7505', 'ASHS-7505', 'ashs7505', 'terex 760 lift kit', 'tv-ssp-6521t', 'tv-ssp-5091t', '10x0220']
  },

  // ASHS-7506
  {
    id: 'ASHS-7506',
    name: 'Terex 760 Tilt Kit',
    partNumber: 'ASHS-7506',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Tilt kit for Terex 760 backhoe loader. Ensures smooth and reliable tilt performance.',
    specifications: {
      Type: 'Tilt Kit',
      Application: 'Terex 760',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['TV-SSP-5092T', 'TV-10X0155'],
    compatibility: ['Terex 760 Backhoe Loader'],
    tags: ['Tilt Kit', 'Terex 760', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7506', 'ASHS-7506', 'ashs7506', 'terex 760 tilt kit', 'tv-ssp-5092t', '10x0155']
  },

  // ASHS-7507
  {
    id: 'ASHS-7507',
    name: 'Terex 760 Slew Kit',
    partNumber: 'ASHS-7507',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Slew kit for Terex 760 backhoe loader. Ensures precise slewing with high durability.',
    specifications: {
      Type: 'Slew Kit',
      Application: 'Terex 760',
      Material: 'Steel',
      Features: 'OEM Fit, Heavy-Duty, Reliable'
    },
    oeReference: ['TV-SSP-5093T', 'TV-10X0092'],
    compatibility: ['Terex 760 Backhoe Loader'],
    tags: ['Slew Kit', 'Terex 760', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7507', 'ASHS-7507', 'ashs7507', 'terex 760 slew kit', 'tv-ssp-5093t', '10x0092']
  },

  // ASHS-7508
  {
    id: 'ASHS-7508',
    name: 'Terex 740 Boom Kit',
    partNumber: 'ASHS-7508',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Boom kit for Terex 740 backhoe loader. Delivers strong performance and reliability.',
    specifications: {
      Type: 'Boom Kit',
      Application: 'Terex 740',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['TV-10X2618'],
    compatibility: ['Terex 740 Backhoe Loader'],
    tags: ['Boom Kit', 'Terex 740', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7508', 'ASHS-7508', 'ashs7508', 'terex 740 boom kit', 'tv-10x2618']
  },

  // ASHS-7509
  {
    id: 'ASHS-7509',
    name: 'Terex 740 Arm Kit',
    partNumber: 'ASHS-7509',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Arm kit for Terex 740 backhoe loader. Ensures smooth operation and durability.',
    specifications: {
      Type: 'Arm Kit',
      Application: 'Terex 740',
      Material: 'Steel',
      Features: 'OEM Quality, Heavy-Duty, Reliable'
    },
    oeReference: ['TV-10X1927'],
    compatibility: ['Terex 740 Backhoe Loader'],
    tags: ['Arm Kit', 'Terex 740', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7509', 'ASHS-7509', 'ashs7509', 'terex 740 arm kit', 'tv-10x1927']
  },

  // ASHS-7510
  {
    id: 'ASHS-7510',
    name: 'Terex 740 Bucket Kit',
    partNumber: 'ASHS-7510',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Bucket kit for Terex 740 backhoe loader. Designed for long wear life and reliability.',
    specifications: {
      Type: 'Bucket Kit',
      Application: 'Terex 740',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['TV-SSP-8130T', 'TV-10X1700'],
    compatibility: ['Terex 740 Backhoe Loader'],
    tags: ['Bucket Kit', 'Terex 740', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7510', 'ASHS-7510', 'ashs7510', 'terex 740 bucket kit', 'tv-ssp-8130t', '10x1700']
  },

  // ASHS-7511
  {
    id: 'ASHS-7511',
    name: 'Terex 740 Slew Kit',
    partNumber: 'ASHS-7511',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Slew kit for Terex 740 backhoe loader. Ensures precision slewing and long service life.',
    specifications: {
      Type: 'Slew Kit',
      Application: 'Terex 740',
      Material: 'Steel',
      Features: 'OEM Quality, Heavy-Duty, Reliable'
    },
    oeReference: ['TV-SSP-7214T', 'TV-10X1755'],
    compatibility: ['Terex 740 Backhoe Loader'],
    tags: ['Slew Kit', 'Terex 740', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7511', 'ASHS-7511', 'ashs7511', 'terex 740 slew kit', 'tv-ssp-7214t', '10x1755']
  },

  // ASHS-7512
  {
    id: 'ASHS-7512',
    name: 'Terex 740 Slew Kit',
    partNumber: 'ASHS-7512',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Alternate slew kit for Terex 740 backhoe loader. Ensures high durability and precision performance.',
    specifications: {
      Type: 'Slew Kit',
      Application: 'Terex 740',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Heavy-Duty'
    },
    oeReference: ['TV-SSP-8020', 'TV-10X3211'],
    compatibility: ['Terex 740 Backhoe Loader'],
    tags: ['Slew Kit', 'Terex 740', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7512', 'ASHS-7512', 'ashs7512', 'terex 740 slew kit', 'tv-ssp-8020', '10x3211']
  },

  // ASHS-7513
  {
    id: 'ASHS-7513',
    name: 'Terex 740 Lift Kit',
    partNumber: 'ASHS-7513',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Lift kit for Terex 740 backhoe loader. Provides strong and consistent lifting performance.',
    specifications: {
      Type: 'Lift Kit',
      Application: 'Terex 740',
      Material: 'Steel',
      Features: 'OEM Fit, Heavy-Duty, Reliable'
    },
    oeReference: ['TV-SSP-7819', 'TV-10X1637'],
    compatibility: ['Terex 740 Backhoe Loader'],
    tags: ['Lift Kit', 'Terex 740', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7513', 'ASHS-7513', 'ashs7513', 'terex 740 lift kit', 'tv-ssp-7819', '10x1637']
  },

  // ASHS-7514
  {
    id: 'ASHS-7514',
    name: 'Terex 740 Tilt Kit',
    partNumber: 'ASHS-7514',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Tilt kit for Terex 740 backhoe loader. Provides smooth tilt motion and durability.',
    specifications: {
      Type: 'Tilt Kit',
      Application: 'Terex 740',
      Material: 'Steel',
      Features: 'OEM Fit, Heavy-Duty, Reliable'
    },
    oeReference: ['TV-10X2620'],
    compatibility: ['Terex 740 Backhoe Loader'],
    tags: ['Tilt Kit', 'Terex 740', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7514', 'ASHS-7514', 'ashs7514', 'terex 740 tilt kit', 'tv-10x2620']
  },

  // ASHS-7515
  {
    id: 'ASHS-7515',
    name: 'Terex 740 Stabilizer Kit',
    partNumber: 'ASHS-7515',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Stabilizer kit for Terex 740 backhoe loader. Ensures long service life and operational stability.',
    specifications: {
      Type: 'Stabilizer Kit',
      Application: 'Terex 740',
      Material: 'Steel',
      Features: 'OEM Quality, Durable, Heavy-Duty'
    },
    oeReference: ['TV-SSP-8990T', 'TV-10X1783'],
    compatibility: ['Terex 740 Backhoe Loader'],
    tags: ['Stabilizer Kit', 'Terex 740', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7515', 'ASHS-7515', 'ashs7515', 'terex 740 stab kit', 'tv-ssp-8990t', '10x1783']
  },

  // ASHS-7516
  {
    id: 'ASHS-7516',
    name: 'Terex 740 Steering Kit',
    partNumber: 'ASHS-7516',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Steering kit for Terex 740 backhoe loader. Provides smooth and precise steering control.',
    specifications: {
      Type: 'Steering Kit',
      Application: 'Terex 740',
      Material: 'Steel',
      Features: 'OEM Fit, Durable, Reliable'
    },
    oeReference: ['TV-10X1776'],
    compatibility: ['Terex 740 Backhoe Loader'],
    tags: ['Steering Kit', 'Terex 740', 'Backhoe Loader', 'OEM Replacement', 'Heavy Duty'],
    references: ['ashs-7516', 'ASHS-7516', 'ashs7516', 'terex 740 steering kit', 'tv-10x1776']
  },

  // ASHS-7517
  {
    id: 'ASHS-7517',
    name: 'TEREX 740 Lift Kit',
    partNumber: 'ASHS-7517',
    machine: 'terex',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Heavy-duty lift kit for TEREX 740 backhoe loader. Designed for superior performance and long life in demanding work conditions.',
    specifications: {
      Type: 'Lift Kit',
      Application: 'TEREX 740',
      Material: 'High-Grade Steel and Seal Components',
      Features: 'Durable, Precision Fit, OEM Replacement, Heavy-Duty Construction'
    },
    oeReference: ['TV-10X2623'],
    compatibility: ['TEREX 740 Backhoe Loader'],
    tags: ['Lift Kit', 'TEREX 740', 'Heavy Duty', 'OEM Replacement'],
    references: [
      'ashs-7517', 'ASHS-7517', 'ashs7517',
      'terex 740 lift kit', 'terex 740', 'lift kit', 'TV-10X2623',
      'heavy machinery', 'oem replacement', 'hydraulic seal kit', 'backhoe loader lift kit'
    ]
  },





  //L&T/CASE -----------------------------------------------------------------------------------------------
  // ASHS-8001
  {
    id: 'ASHS-8001',
    name: 'L&T/CASE 770 Boom Kit W',
    partNumber: 'ASHS-8001',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'High-performance boom kit for L&T/CASE 770 backhoe loader (wet type). Engineered for strength, reliability, and long service life.',
    specifications: { Type: 'Boom Kit (W)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['SSP4216'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['Boom Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'W'],
    references: ['ashs-8001', 'ASHS-8001', 'ashs8001', 'l&t case 770 boom kit', 'ssp4216', 'w', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8002
  {
    id: 'ASHS-8002',
    name: 'L&T/CASE 770 Arm Kit W',
    partNumber: 'ASHS-8002',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Arm kit for L&T/CASE 770 backhoe loader (wet type). Provides smooth motion and long-lasting performance.',
    specifications: { Type: 'Arm Kit (W)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['SSP4217'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['Arm Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'W'],
    references: ['ashs-8002', 'ASHS-8002', 'ashs8002', 'l&t case 770 arm kit', 'ssp4217', 'w', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8003
  {
    id: 'ASHS-8003',
    name: 'L&T/CASE 770 Bucket Kit W',
    partNumber: 'ASHS-8003',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Bucket kit for L&T/CASE 770 backhoe loader (wet type). Designed for long service life and heavy-duty performance.',
    specifications: { Type: 'Bucket Kit (W)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['SSP4218'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['Bucket Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'W'],
    references: ['ashs-8003', 'ASHS-8003', 'ashs8003', 'l&t case 770 bucket kit', 'ssp4218', 'w', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8004
  {
    id: 'ASHS-8004',
    name: 'L&T/CASE 770 Stabilizer Kit W',
    partNumber: 'ASHS-8004',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Stabilizer kit for L&T/CASE 770 backhoe loader (wet type). Ensures stability and reliability during heavy-duty operations.',
    specifications: { Type: 'Stabilizer Kit (W)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['SSP4219'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['Stabilizer Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'W'],
    references: ['ashs-8004', 'ASHS-8004', 'ashs8004', 'l&t case 770 stab kit', 'ssp4219', 'w', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8005
  {
    id: 'ASHS-8005',
    name: 'L&T/CASE 770 Lift Kit W',
    partNumber: 'ASHS-8005',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Lift kit for L&T/CASE 770 backhoe loader (wet type). Provides reliable lifting strength and durability.',
    specifications: { Type: 'Lift Kit (W)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['SSP4220'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['Lift Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'W'],
    references: ['ashs-8005', 'ASHS-8005', 'ashs8005', 'l&t case 770 lift kit', 'ssp4220', 'w', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8006
  {
    id: 'ASHS-8006',
    name: 'L&T/CASE 770 Tilt Kit W',
    partNumber: 'ASHS-8006',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Tilt kit for L&T/CASE 770 backhoe loader (wet type). Ensures smooth tilt performance and precision.',
    specifications: { Type: 'Tilt Kit (W)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['SSP4221'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['Tilt Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'W'],
    references: ['ashs-8006', 'ASHS-8006', 'ashs8006', 'l&t case 770 tilt kit', 'ssp4221', 'w', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8007
  {
    id: 'ASHS-8007',
    name: 'L&T/CASE 770 Swing Kit W',
    partNumber: 'ASHS-8007',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Swing kit for L&T/CASE 770 backhoe loader (wet type). Provides smooth swing motion and high durability.',
    specifications: { Type: 'Swing Kit (W)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['SSP4222'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['Swing Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'W'],
    references: ['ashs-8007', 'ASHS-8007', 'ashs8007', 'l&t case 770 swing kit', 'ssp4222', 'w', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8008
  {
    id: 'ASHS-8008',
    name: 'L&T/CASE 770 Boom Kit D',
    partNumber: 'ASHS-8008',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Boom kit (D type) for L&T/CASE 770 backhoe loader. Built for high durability and precise operation.',
    specifications: { Type: 'Boom Kit (D)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['DC7309-650'],
    compatibility: ['L&T/CASE 770 Backhoe Loader (D)'],
    tags: ['Boom Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'D'],
    references: ['ashs-8008', 'ASHS-8008', 'ashs8008', 'l&t case 770 boom kit', 'dc7309-650', 'd', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },
  // ASHS-8009
  {
    id: 'ASHS-8009',
    name: 'L&T/CASE 770 Dipper Kit D',
    partNumber: 'ASHS-8009',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Dipper/arm kit (D type) for L&T/CASE 770 backhoe loader. Ensures smooth operation and long-lasting performance.',
    specifications: { Type: 'Dipper Kit (D)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['DC7308-650'],
    compatibility: ['L&T/CASE 770 Backhoe Loader (D)'],
    tags: ['Dipper Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'D'],
    references: ['ashs-8009', 'ASHS-8009', 'ashs8009', 'l&t case 770 dipper kit', 'dc7308-650', 'd', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8010
  {
    id: 'ASHS-8010',
    name: 'L&T/CASE 770 Bucket Kit D',
    partNumber: 'ASHS-8010',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Bucket kit (D type) for L&T/CASE 770 backhoe loader. Designed for heavy-duty digging and durability.',
    specifications: { Type: 'Bucket Kit (D)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['DC7306-650'],
    compatibility: ['L&T/CASE 770 Backhoe Loader (D)'],
    tags: ['Bucket Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'D'],
    references: ['ashs-8010', 'ASHS-8010', 'ashs8010', 'l&t case 770 bucket kit', 'dc7306-650', 'd', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8011
  {
    id: 'ASHS-8011',
    name: 'L&T/CASE 770 Lift Kit D',
    partNumber: 'ASHS-8011',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Lift kit (D type) for L&T/CASE 770 backhoe loader. Provides reliable lifting performance under heavy loads.',
    specifications: { Type: 'Lift Kit (D)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['DC7307-650'],
    compatibility: ['L&T/CASE 770 Backhoe Loader (D)'],
    tags: ['Lift Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'D'],
    references: ['ashs-8011', 'ASHS-8011', 'ashs8011', 'l&t case 770 lift kit', 'dc7307-650', 'd', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8012
  {
    id: 'ASHS-8012',
    name: 'L&T/CASE 770 Tilt Kit D',
    partNumber: 'ASHS-8012',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Tilt kit (D type) for L&T/CASE 770 backhoe loader. Ensures smooth tilting and accurate control.',
    specifications: { Type: 'Tilt Kit (D)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['DC7305-650'],
    compatibility: ['L&T/CASE 770 Backhoe Loader (D)'],
    tags: ['Tilt Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'D'],
    references: ['ashs-8012', 'ASHS-8012', 'ashs8012', 'l&t case 770 tilt kit', 'dc7305-650', 'd', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8013
  {
    id: 'ASHS-8013',
    name: 'L&T/CASE 770 Stabilizer Kit D',
    partNumber: 'ASHS-8013',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'Stabilizer kit (D type) for L&T/CASE 770 backhoe loader. Maintains stability and reliable operation during heavy-duty work.',
    specifications: { Type: 'Stabilizer Kit (D)', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['DC7454-650'],
    compatibility: ['L&T/CASE 770 Backhoe Loader (D)'],
    tags: ['Stabilizer Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement', 'D'],
    references: ['ashs-8013', 'ASHS-8013', 'ashs8013', 'l&t case 770 stab kit', 'dc7454-650', 'd', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8014
  {
    id: 'ASHS-8014',
    name: 'L&T/CASE 770 EX Boom Kit',
    partNumber: 'ASHS-8014',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'EX Boom kit for L&T/CASE 770 backhoe loader. Heavy-duty kit for extended performance and durability.',
    specifications: { Type: 'EX Boom Kit', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['47568720'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['EX Boom Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-8014', 'ASHS-8014', 'ashs8014', 'l&t case 770 ex boom kit', '47568720', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8015
  {
    id: 'ASHS-8015',
    name: 'L&T/CASE 770 EX Bucket Kit',
    partNumber: 'ASHS-8015',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'EX Bucket kit for L&T/CASE 770 backhoe loader. Engineered for long-lasting performance in tough conditions.',
    specifications: { Type: 'EX Bucket Kit', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['48071100'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['EX Bucket Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-8015', 'ASHS-8015', 'ashs8015', 'l&t case 770 ex bucket kit', '48071100', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8016
  {
    id: 'ASHS-8016',
    name: 'L&T/CASE 770 EX Arm Kit',
    partNumber: 'ASHS-8016',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'EX Arm kit for L&T/CASE 770 backhoe loader. Provides reliable arm movement and long-term durability.',
    specifications: { Type: 'EX Arm Kit', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['47917960'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['EX Arm Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-8016', 'ASHS-8016', 'ashs8016', 'l&t case 770 ex arm kit', '47917960', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8017
  {
    id: 'ASHS-8017',
    name: 'L&T/CASE 770 EX Swing Kit',
    partNumber: 'ASHS-8017',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'EX Swing kit for L&T/CASE 770 backhoe loader. Ensures smooth swing operation under heavy load conditions.',
    specifications: { Type: 'EX Swing Kit', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['47568718'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['EX Swing Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-8017', 'ASHS-8017', 'ashs8017', 'l&t case 770 ex swing kit', '47568718', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8018
  {
    id: 'ASHS-8018',
    name: 'L&T/CASE 770 EX Stabilizer Kit',
    partNumber: 'ASHS-8018',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'EX Stabilizer kit for L&T/CASE 770 backhoe loader. Maintains stability and supports heavy-duty operations.',
    specifications: { Type: 'EX Stabilizer Kit', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['47568716'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['EX Stabilizer Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-8018', 'ASHS-8018', 'ashs8018', 'l&t case 770 ex stabilizer kit', '47568716', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8019
  {
    id: 'ASHS-8019',
    name: 'L&T/CASE 770 EX Tilt Kit',
    partNumber: 'ASHS-8019',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'EX Tilt kit for L&T/CASE 770 backhoe loader. Provides smooth tilting action for precision operation.',
    specifications: { Type: 'EX Tilt Kit', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['47857289'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['EX Tilt Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-8019', 'ASHS-8019', 'ashs8019', 'l&t case 770 ex tilt kit', '47857289', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8020
  {
    id: 'ASHS-8020',
    name: 'L&T/CASE 770 EX Lift Kit',
    partNumber: 'ASHS-8020',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'EX Lift kit for L&T/CASE 770 backhoe loader. Delivers consistent lifting performance under heavy loads.',
    specifications: { Type: 'EX Lift Kit', Application: 'L&T/CASE 770', Material: 'High-Grade Steel', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['47568738'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['EX Lift Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-8020', 'ASHS-8020', 'ashs8020', 'l&t case 770 ex lift kit', '47568738', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8021
  {
    id: 'ASHS-8021',
    name: 'L&T/CASE 770 EX Steering Kit',
    partNumber: 'ASHS-8021',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: 'EX Steering kit for L&T/CASE 770 backhoe loader. Ensures precise steering and high durability.',
    specifications: { Type: 'EX Steering Kit', Application: 'L&T/CASE 770', Material: 'High-Grade', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['84330972'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['EX Steering Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-8021', 'ASHS-8021', 'ashs8021', 'l&t case 770 ex steering kit', '84330972', 'backhoe loader', 'heavy machinery', 'oem replacement']
  },

  // ASHS-8022
  {
    id: 'ASHS-8022',
    name: 'L&T/CASE 770 6 in 1 Ram Kit',
    partNumber: 'ASHS-8022',
    machine: 'l&t/case',
    category: '5',
    price: 0,
    featured: false,
    images: ['v1759575356/seals_pylv78.webp'],
    description: '6-in-1 Ram kit for L&T/CASE 770 backhoe loader. Combines multiple hydraulic functions into a single durable unit.',
    specifications: { Type: '6 in 1 Ram Kit', Application: 'L&T/CASE 770', Material: 'High-Grade', Features: 'Durable, OEM Replacement, Heavy-Duty' },
    oeReference: ['47571209'],
    compatibility: ['L&T/CASE 770 Backhoe Loader'],
    tags: ['6 in 1 Ram Kit', 'L&T/CASE 770', 'Heavy Duty', 'OEM Replacement'],
    references: ['ashs-8022', 'ASHS-8022', 'ashs8022', 'l&t case 770 6 in 1 ram kit', '47571209', 'backhoe loader', 'heavy machinery', 'oem replacement']
  }
];